
import {  Diagram, PointPortModel, ConnectorModel, NodeModel, Connector, NodeConstraints, SnapConstraints, DiagramTools, AlignmentOptions, DiagramContextMenu, Snapping, DiagramComponent} from '@syncfusion/ej2-angular-diagrams';
import { ExpandMode,MenuEventArgs } from '@syncfusion/ej2-angular-navigations'
import {  ItemModel} from '@syncfusion/ej2-angular-splitbuttons';
import { Component, ViewEncapsulation, ViewChild,Inject, AfterViewInit, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {  CommandManagerModel, ContextMenuSettingsModel,  DiagramRegions,  FileFormats, IHistoryChangeArgs, IScrollChangeEventArgs, PageSettingsModel, RulerSettingsModel, ScrollSettingsModel,  SelectorModel, ShapeAnnotationModel,  ZoomOptions } from '@syncfusion/ej2-angular-diagrams';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { BeforeOpenCloseMenuEventArgs,  } from '@syncfusion/ej2-angular-splitbuttons';
import { closest } from '@syncfusion/ej2-base';
import * as uuid from 'uuid';
import { AngolicelleirregolariService } from 'src/app/_services/angolicelleirregolari.service';


import { UndoRedo,
  SymbolInfo, SnapSettingsModel, MarginModel,TextStyleModel, StrokeStyleModel,
  OrthogonalSegmentModel, Node, PaletteModel,KeyModifiers,Keys,SelectorConstraints,SymbolPalette,PrintAndExport,
  LayerModel,
  IDragEnterEventArgs,
  IDropEventArgs,
  ISelectionChangeEventArgs,
  DiagramConstraints,
  DiagramTooltipModel,
  IPaletteSelectionChangeArgs,
  IPaletteExpandArgs,
  IExportOptions,
  Rect
} from '@syncfusion/ej2-diagrams';
import { DiagramClientSideEvents, DiagramPropertyBinding } from '../../../scripts/events';
import { NodeProperties, SelectorViewModel } from '../../../scripts/selector';
import { GlobalService } from "src/app/_services/global.service";

import {  UtilityMethods } from '../../../scripts/utilitymethods';
import { v4 as uuidv4 } from 'uuid';
import * as JSPDF from 'jspdf';
import DxfWriter from 'dxf-writer';



Diagram.Inject(UndoRedo,DiagramContextMenu,PrintAndExport,Snapping);

import {DropDownDataSources } from '../../../scripts/dropdowndatasource'
import { AnimationSettingsModel, DialogComponent } from '@syncfusion/ej2-angular-popups';
import { ApiService } from 'src/app/_services/api.service';
import { ModelService } from '../model.service';
import { LanguageService } from 'src/app/_services/language.service';
import { ConnectableObservable, ignoreElements } from 'rxjs';
import { ParsedPropertyType } from '@angular/compiler';


import { ScaffalidataService } from 'src/app/_services/scaffalidata.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { MirrorShader } from 'three-stdlib';
import { NumberInput } from '@angular/cdk/coercion';
import { ImpiantiremotiService } from 'src/app/_services/impiantiremoti.service';
import { FreeblocksdataService } from 'src/app/_services/freeblocksdata.service';
import { DropindataService } from 'src/app/_services/dropindata.service';
import { B } from '@fullcalendar/core/internal-common';
import { MinicelleserviceService } from 'src/app/_services/minicelleservice.service';
import { LunghezzeAngolariService } from 'src/app/_services/lunghezze-angolari.service';
import { HttpClient } from '@angular/common/http';
@Component({
  selector: 'app-model-design',
  standalone: false,
  templateUrl: './model-design.component.html',
  styleUrl: './model-design.component.scss',
  providers:[ConfirmationService,MessageService]
})
  
export class ModelDesignComponent implements OnInit, AfterViewInit{
  private _cC: any=undefined;

  @Output() messageEvent  = new EventEmitter<any>();

  @Output() cCChange = new EventEmitter<any>();
  @Input() 
      get cC():any{ return this._cC; }
      set cC(d:any){
            this._cC = d;
            this.mS.celleConfig=d;
            this.cCChange.emit(this._cC);
      };
  @Input('opzioniList') opzioniList:any=null;
  @Input('prev') prev:any=null;

  
  @ViewChild('diagram') public diagram: Diagram | any;
  @ViewChild('symbolpalette') public symbolpalette:  any;
  @ViewChild('symbolpaletteMC') public symbolpaletteMC:  any;
  @ViewChild('exportDialog')  public exportDialog: DialogComponent | undefined;
  @ViewChild('showPageBreak')  public showPageBreak: any;
  @ViewChild('ddlTextPosition')  public ddlTextPosition: any;
  @ViewChild('hyperlinkDialog')  public hyperlinkDialog: DialogComponent | undefined;
  @ViewChild('btnHideElement')  public btnHideElement: any;

  diagramCostraint=DiagramConstraints.Default | DiagramConstraints.Tooltip;
  public zoomMenuItems: ItemModel[] = [];
  public currentLevel:any='';
  public showDialogPrint:boolean=false;
  public showDialogListini:boolean=false;
  public listini:any={
    ingombroXMin:100,
    ingombroXMax:400,
    ingombroYMin:100,
    ingombroYMax:400,
    currentIterazione:0,
    totIterazioni:0
  };
  listiniModelliPortaOptionsSenzaPav:any[]=[];
  listiniModelliPortaOptionsConPav:any[]=[];
  
  listiniModelloPorta:any=null;
  listiniPortaConPav:any=null;
  listiniPortaSenzaPav:any=null;
  
  listiniModelloPortaDesc:string='';
  listiniError:string='';
  celleCollegateList:any[]=[];
  showError:boolean=false;
  saving:boolean=false;
  scaffaliMiniCelleOptions:any[]=[];
  statusCellaOptions:any[]=[];
  allineamentoScaffaleOptions:any[]=[];
  allineamentoScaffale:string='';
  showEditDesc:boolean=false;
  showEditDescTecnica:boolean=false;
  showEditScaffali:boolean=false;
  elencoScaffali:any[]=[];
  profonditaScaffale:string='';
  lunghtotscaffali=0;
  
  errorMessage:any[]=[];
  pdf:any;
  dxf:any;
  pdfOrdDxf:string='PDF';
  pdfProp:number=0.1;
  pdfIsPrinting:boolean=false;
  pdfStartX:number=0;
  pdfStartY:number=0;
  public tipoStampa:string='pareti';
  public formatoStampa:string='a4';
  tipodistampaList:any[]=[
    {
      label:'Tutto',
      value:'all'
    },
     {
      label:'Pareti',
      value:'pareti'
    },
     {
      label:'Pavimento',
      value:'pavimento'
    },
     {
      label:'Soffitto',
      value:'soffitto'
    }
  ];
  formatostampaList:any[]=[
    {
      label:'A4',
      value:'a4'
    },
    {
      label:'A3',
      value:'a3'
    },
    {
      label:'A2',
      value:'a2'
    },
    {
      label:'A1',
      value:'a1'
    },
    {
      label:'A0',
      value:'a0'
    },

    
  ];
  public showPalette:boolean=true;
  public hideShowElementsList: ItemModel[] = [];

  public layers: LayerModel[] =[];
  public mostraMisure:boolean=false;
  public nodeConstraint:any= ~NodeConstraints.Rotate;
  public dropDownDataSources: DropDownDataSources = new DropDownDataSources();
  public selectedItem: any = new SelectorViewModel();
  public utilityMethods: UtilityMethods = new UtilityMethods();
  public nodeProperties: NodeProperties = new NodeProperties();
  public diagramClientSideEvents: DiagramClientSideEvents = new DiagramClientSideEvents(this.selectedItem);
  public diagramPropertyBinding: DiagramPropertyBinding = new DiagramPropertyBinding(this.selectedItem,this.nodeProperties);
  //   public selector:SelectorViewModel = new SelectorViewModel();

  public strokeStyleItemTemplate: string = '<div class="db-ddl-template-style"><span class="${className}"></span></div>';
  public commandManager: CommandManagerModel = this.getCommandManagerSettings();
  public rulerSettings: RulerSettingsModel = {showRulers:true};
  public snapSettings: any = { 
    snapLineColor:'#000', 
    constraints: (SnapConstraints.All),
  };
  public pageSettings: PageSettingsModel = {
    background: { color: '#EFEFEF' }, width: 7500, height: 5000, multiplePage: false, margin: { left: 5, top: 5 },
    orientation: 'Landscape'
  };
  public scrollSettings: ScrollSettingsModel = {
    canAutoScroll: false, scrollLimit: 'Diagram', minZoom: 0.25, maxZoom: 30 
  };
  public selectedItems:SelectorModel = { constraints: SelectorConstraints.All};
  public palettes: PaletteModel[] = [];
  public palettesMC: PaletteModel[] = [];
  

  

  public contextMenu:ContextMenuSettingsModel = {
      show:false,
  };

  //SymbolPalette Properties
  public symbolMargin: MarginModel = { left: 2, right: 2, top: 5, bottom: 10 };
  public symbolMarginMC: MarginModel = { left: 3, right: 3, top: 3, bottom: 0 };

  public expandMode: ExpandMode = 'Single';
  public enableSearch: boolean = true;
  public dropdownListFields: any = { text: 'text', value: 'value' };
  public dialogAnimationSettings: AnimationSettingsModel = { effect: 'None' };
  public dlgTarget: HTMLElement = document.body;
  public printingButtons: Object[] = this.getDialogButtons('print');
  public exportingButtons: Object[] = this.getDialogButtons('export');
  public dialogVisibility: boolean = false;

  public divisorioCellaOptions:any[]=[];
  public scaffaliData:any[]=[];
  
  constructor(
      private http: HttpClient, 
      private impiantiremotiService:ImpiantiremotiService,
      private minicelleservice:MinicelleserviceService,
      private lunghezzeAngolariService: LunghezzeAngolariService,
      private freeblocksService:FreeblocksdataService,
      private dropinService:DropindataService,
      public angoliCelleIrregolari:AngolicelleirregolariService,

      private scaffalidataService:ScaffalidataService,
      private apiService: ApiService,
      public lang:LanguageService,
      private messageService: MessageService,
      private confirmationService:ConfirmationService,
      public globalService:GlobalService,
      public mS:ModelService) {
        
  }


  ngOnInit(): void { 
   
    this.scaffaliMiniCelleOptions=[
      {
        value:this.lang.el(''),
        label:this.lang.el('Nessuno scaffale')
      },
      {
        value:this.lang.el('3 ripiani'),
        label:this.lang.el('3 ripiani')
      },
      {
        value:this.lang.el('4 ripiani'),
        label:this.lang.el('4 ripiani')
      }
    ];
    this.tipodistampaList=[
      {
        label:this.lang.el('Tutto'),
        value:'all'
      },
      {
        label:this.lang.el('Pareti'),
        value:'pareti'
      },
      {
        label:this.lang.el('Pavimento'),
        value:'pavimento'
      },
      {
        label:this.lang.el('Soffitto'),
        value:'soffitto'
      }
    ];
    this.allineamentoScaffaleOptions=[
      {
      value:'', label:this.lang.el('Nessuno')
      },
      {
      value:'left', label:this.lang.el('Sinitra')
      },
      {
      value:'right', label:this.lang.el('Destra')
      },
      {
      value:'center', label:this.lang.el('Centro')
      },
      {
      value:'top', label:this.lang.el('Alto')
      },
      {
      value:'bottom', label:this.lang.el('Basso')
      },
    ];

    this.mS.impiantiMiniCelleOptions=[
      {
        value:'Nessun_impianto',
        label:this.lang.el('Nessun impianto')
      },
      {
        value:'FB',
        label:this.lang.el('FB')
      },
      {
        value:'MisaSplit MS',
        label:this.lang.el('MisaSplit MS')
      },
      {
        value:'MisaSplit MSG',
        label:this.lang.el('MisaSplit MSG')
      }
    ];

    if(this.cC.electrolux==1){
      this.mS.finituraOptions=['STANDARD'];
      this.mS.controlloreOptions=['Carel'];
    } else {
      this.mS.finituraOptions=['STANDARD', 'INOX_INT', 'INOX_EST','INOX_IE'];
    }

    this.mS.tipologiaPortaOptions.forEach((l:any)=>{
      l.label=this.lang.el(l.label);
     });

    this.mS.finituraPavimentoOptions.forEach((l:any)=>{
      l.label=this.lang.el(l.label);
     });

    this.mS.irData=this.impiantiremotiService.getData();
    if(this.cC.electrolux==1){
      this.mS.irData.MS= this.mS.irData.MS.filter((x:any)=> this.mS.impiantiRemotiMSElectrolux.includes(x.art_comp));
      this.mS.irData.MSG= this.mS.irData.MSG.filter((x:any)=> this.mS.impiantiRemotiMSGElectrolux.includes(x.art_comp));
    } else {
      this.mS.irData.MS= this.mS.irData.MS.filter((x:any)=> !this.mS.impiantiRemotiMSElectrolux.includes(x.art_comp));
      this.mS.irData.MSG= this.mS.irData.MSG.filter((x:any)=> !this.mS.impiantiRemotiMSGElectrolux.includes(x.art_comp));
    }

    this.mS.loadImpiantiremotiOptionms('MS',this.mS.irData);
    this.mS.loadImpiantiremotiOptionms('MISAERM',this.mS.irData);
    this.mS.loadImpiantiremotiOptionms('MSG',this.mS.irData);
    this.mS.loadImpiantiremotiOptionms('REFREEX',this.mS.irData);
    this.mS.loadImpiantiremotiOptionms('S_CAR',this.mS.irData);
    this.mS.loadImpiantiremotiOptionms('SEE',this.mS.irData);
    this.mS.loadImpiantiremotiOptionms('SEEW',this.mS.irData);
    this.mS.loadImpiantiremotiOptionms('SILENT',this.mS.irData);

    this.statusCellaOptions=[
      {
        value:'NUOVA',
        label:this.lang.el('NUOVA')
      },
      {
        value:'IN PROGETTAZIONE',
        label:this.lang.el('IN PROGETTAZIONE')
      },
      {
        value:'CONFERMATA',
        label:this.lang.el('CONFERMATA')
      }
    ];

    this.scaffaliData=this.scaffalidataService.getData();


    this.divisorioCellaOptions=[
      {value:'',label:this.lang.el('Seleziona una opzione')},
      {value:'normale',label:this.lang.el('Normale')},
      {value:'conPorta',label:this.lang.el('Con porta')},
      {value:'nessunDivisorio',label:this.lang.el('Nessun divisorio')},
    ];

    this.mS.pannelloPlasticContent='<div style="width:100%;height:100%;border:2px solid #ddd;background-color:'+this.mS.pannelloPanna+';"></div>' ;
    this.mS.pannelloInoxContent='<div style="width:100%;height:100%;border:2px solid #ddd;background-color:'+this.mS.pannelloAzzurro+';"></div>' ;
    this.mS.pannelloPortaContent='<div style="width:100%;height:100%;border:2px solid #ddd;background-color:'+this.mS.colorPorta+';"></div>' ;
   
    this.mS.angolarePlasticContent='<div style="width:100%;height:100%;border:2px solid #ddd;background-color:'+this.mS.angolarePanna+';"></div>' ;
    this.mS.angolareInoxContent='<div style="width:100%;height:100%;border:2px solid #ddd;background-color:'+this.mS.pannelloAzzurro+';"></div>' ;
 
    this.mS.nodePannello.shape.content=this.mS.pannelloPlasticContent;
    this.mS.nodeAngolare.shape.content=this.mS.angolarePlasticContent;
    
    this.mS.nodePannelloOrizz.shape.content=this.mS.pannelloPlasticContent;
     this.currentLevel=this.lang.el('Mostra celle');
     this.hideShowElementsList= [
      { text: this.lang.el('Mostra celle')},
      { text: this.lang.el('Mostra pareti') ,disabled:false},
      { text: this.lang.el('Mostra pavimento') ,disabled:false},
      { text: this.lang.el('Mostra soffitto'),disabled:false }
    ];

     this.zoomMenuItems= [
      { text: '400%' }, { text: '300%' }, { text: '200%' }, { text: '150%' },
      { text: '100%' }, { text: '75%' }, { text: '50%' }, { text: '25%' }, { separator: true },
      { text: this.lang.el('Fit To Screen') }
    ];
     if(!this.mS.userCellePreConf()){
       if(this.globalService.getUser().role!='UTENTE' && this.globalService.getUser().role!='AGENTE'){

        this.palettesMC=[
          { id: 'minicellemisa', expanded: false, symbols:this.minicelleservice.getDataMisa() as NodeModel[],  iconCss: 'e-ddb-icons e-flow' ,
          title: this.lang.el('Misa') },
          { id: 'minicelleelectrolux', expanded: false, symbols:this.minicelleservice.getDataElectrolux() as NodeModel[], iconCss: 'e-ddb-icons e-flow' ,
          title: this.lang.el('Electrolux') }
        ];

       } else{
          this.palettesMC=[
          { id: 'minicellemisa', expanded: false, symbols:this.minicelleservice.getDataMisa() as NodeModel[],  iconCss: 'e-ddb-icons e-flow' ,
          title: this.lang.el('Misa') }
          ];
       }

      this.palettes=[
    
        { id: 'celle', expanded: false, symbols: this.getCelleShapes(), iconCss: 'e-ddb-icons e-flow' ,
        title: this.lang.el('Celle e divisori') },        
        { id: 'porte', expanded: false, symbols: this.getPannelliPorteShapes(), iconCss: 'e-ddb-icons e-flow' ,
        title: this.lang.el('Porte') },
       
        { id: 'scaffali37', expanded: false, symbols: this.getScaffaliShapes(37), iconCss: 'e-ddb-icons e-flow', 
        title: this.lang.el('Scaffali 37')},
        { id: 'scaffali47', expanded: false, symbols: this.getScaffaliShapes(47), iconCss: 'e-ddb-icons e-flow', 
        title: this.lang.el('Scaffali 47')},
        { id: 'scaffali56', expanded: false, symbols: this.getScaffaliShapes(56), iconCss: 'e-ddb-icons e-flow', 
        title: this.lang.el('Scaffali 56')},

        { id: 'impianti', expanded: false, symbols: this.getImpiantiShapes(), iconCss: 'e-ddb-icons e-flow', 
        title: this.lang.el('Impianti')},
       { id: 'impiantiremoti', expanded: false, symbols: this.getImpiantiRemotiShapes(), iconCss: 'e-ddb-icons e-flow', 
        title: this.lang.el('Impianti remoti')}
        
      ];
    } else {
      this.palettes=[

        { id: 'scaffali37', expanded: false, symbols: this.getScaffaliShapes(37), iconCss: 'e-ddb-icons e-flow', 
        title: this.lang.el('Scaffali 37')},
        { id: 'scaffali47', expanded: false, symbols: this.getScaffaliShapes(47), iconCss: 'e-ddb-icons e-flow', 
        title: this.lang.el('Scaffali 47')},
        { id: 'scaffali56', expanded: false, symbols: this.getScaffaliShapes(56), iconCss: 'e-ddb-icons e-flow', 
        title: this.lang.el('Scaffali 56')},
     
      ];
    }

    this.layers = [
          {
              id: 'visibleLayer',
              visible: true,
              objects: []
          },
          {
              id: 'hiddenLayer',
              visible: false,
              objects: [],
          },
      ];
    if(this.mS.userCellePreConf()){
      this.showPalette=false;
    }
   
    this.apiService.post('app/opportunity_getscaffalicellepreconf',{}).subscribe(data => {
      this.mS.scaffaliPreCof_L=data.l;
      this.mS.scaffaliPreCof_LU=data.lu;

    });
  }



  public ngAfterViewInit(): void {
    this.selectedItem.diagram = this.diagram;
    this.mS.diagram = this.diagram;
    this.diagramClientSideEvents!.ddlTextPosition = this.ddlTextPosition;
    document.onmouseover = this.menumouseover.bind(this);
    // Placeholder SymbolPalette creato a render: riallinea dopo mount
    setTimeout(() => this.lang.applySyncfusionTranslation(), 0);
  }

  zoom(what:string){
    if(this.diagram){
      if(what=='plus'){
            this.diagram.zoomTo({ type: 'ZoomIn', zoomFactor: 0.2 });
      } else {
            this.diagram.zoomTo({ type: 'ZoomOut', zoomFactor: 0.2 });
      }
    
    }
      
  }

  
  
  
  private getMiniCelleDati(params:any){

    let res: any[] = [];
     this.apiService.post('app/get_minicelle_dati',params).subscribe(data => {
       
      });
    return res;
  }

  private getCelleShapes(): NodeModel[] {
    this.mS.nodeDivisorioOrizz.addInfo.title=this.lang.el('Divisorio orizz.');
    this.mS.nodeDivisorioVert.addInfo.title=this.lang.el('Divisorio vert.');
    let shapes: NodeModel[] = [
          this.mS.nodeCella,
          this.mS.nodeDivisorioOrizz,
          this.mS.nodeDivisorioVert,
          ];
    return shapes;
  }



  public utentevedeListini(){
    // marco e mariano fusaro carlo
    if(this.globalService.getUser().id==1 || this.globalService.getUser().id==10 || this.globalService.getUser().id==291 ){
      return true;
    }
    return false;
  }
  

  private getPannelliPorteShapes(): NodeModel[] {
   
    let pannelliShapes: NodeModel[] = [
          this.mS.nodePortaDS,
          this.mS.nodePortaSN,
          this.mS.nodePortaScorrSn,
          this.mS.nodePortaScorrDs,
          this.mS.nodePortaDSInd,
          this.mS.nodePortaSNInd,
          this.mS.nodePortaScorrIndSN,
          this.mS.nodePortaScorrIndDs,
          ];

          
    if(this.globalService.getUser().organization=='DAGARD' && this.globalService.getUser().company.toUpperCase()=='GFF'){
      pannelliShapes= [
          this.mS.nodePortaDS,
          this.mS.nodePortaSN
          ];
    }
    return pannelliShapes;
  }
  
  private getImpiantiRemotiShapes(): NodeModel[] {
 
    let impiantiRemotiShapes: NodeModel[] = [
        this.mS.nodeMISAERM,
        this.mS.nodeMS,
        this.mS.nodeMSG,
        this.mS.nodeREFREEX,
        this.mS.nodeS_CAR,        
        this.mS.nodeSEE,
        this.mS.nodeSEEW,
        this.mS.nodeSILENT,
      ];

    if(this.cC.electrolux==1){
      impiantiRemotiShapes= [
        this.mS.nodeMS,
        this.mS.nodeMSG,
      ];
    }

    return impiantiRemotiShapes;
  }

  private getScaffaliShapes(what:number): NodeModel[] {
    let scaffaliShapes: NodeModel[] = [];
  
    this.mS.nodeScaffale3765.shape.content=this.mS.scaffaleContentIcon;
    this.mS.nodeScaffale3765R.shape.content=this.mS.scaffaleContentIconVert;
    this.mS.nodeScaffale37118.shape.content=this.mS.scaffaleContentIcon;
    this.mS.nodeScaffale37118R.shape.content=this.mS.scaffaleContentIconVert;
    this.mS.nodeScaffale37130.shape.content=this.mS.scaffaleContentIcon;
    this.mS.nodeScaffale37130R.shape.content=this.mS.scaffaleContentIconVert;
    this.mS.nodeScaffale4765.shape.content=this.mS.scaffaleContentIcon;
    this.mS.nodeScaffale4765R.shape.content=this.mS.scaffaleContentIconVert;
    this.mS.nodeScaffale47118.shape.content=this.mS.scaffaleContentIcon;
    this.mS.nodeScaffale47118R.shape.content=this.mS.scaffaleContentIconVert;
    this.mS.nodeScaffale47130.shape.content=this.mS.scaffaleContentIcon;
    this.mS.nodeScaffale47130R.shape.content=this.mS.scaffaleContentIconVert;
    this.mS.nodeScaffale5671.shape.content=this.mS.scaffaleContentIcon;
    this.mS.nodeScaffale5671R.shape.content=this.mS.scaffaleContentIconVert;
    this.mS.nodeScaffale56125.shape.content=this.mS.scaffaleContentIcon;
    this.mS.nodeScaffale56125R.shape.content=this.mS.scaffaleContentIconVert; 
    this.mS.nodeScaffale56136.shape.content=this.mS.scaffaleContentIcon;
    this.mS.nodeScaffale56136R.shape.content=this.mS.scaffaleContentIconVert;


   
    if(what==37){
      scaffaliShapes=[
        this.mS.nodeScaffale3765,
        this.mS.nodeScaffale3765R,
     //   this.mS.nodeScaffale37118,
      //  this.mS.nodeScaffale37118R,
     //   this.mS.nodeScaffale37130,
     //   this.mS.nodeScaffale37130R,
      ];
    }
 
    if(what==47){
      scaffaliShapes=[
        this.mS.nodeScaffale4765,
        this.mS.nodeScaffale4765R,
    //    this.mS.nodeScaffale47118,
    //    this.mS.nodeScaffale47118R,
   //     this.mS.nodeScaffale47130,
   //     this.mS.nodeScaffale47130R,
      ];
    }
    if(what==56){
      scaffaliShapes=[
          this.mS.nodeScaffale5671,
          this.mS.nodeScaffale5671R,
   //       this.mS.nodeScaffale56125,
    //      this.mS.nodeScaffale56125R, 
    //      this.mS.nodeScaffale56136,
   //       this.mS.nodeScaffale56136R     

      ];
    }
   
    return scaffaliShapes;
   }

  private getImpiantiShapes(): NodeModel[] {
     let accessoriShapes: NodeModel[] = [
        this.mS.nodeDropIn,
        this.mS.nodeFreeBlock1,
        this.mS.nodeFreeBlock2,
      //  this.mS.nodeFreeBlockUniversal,
      ];  

    if(this.cC.electrolux==1){
        accessoriShapes= [
        this.mS.nodeFreeBlock1,
        this.mS.nodeFreeBlock2,
      ];

    }
   
    return accessoriShapes;
  }

  private getMicrocelleShapes(): NodeModel[] {

    let microcelleShapes: NodeModel[] = [
      ];

    return microcelleShapes;
  }

  private getCelleElectroluxShapes(): NodeModel[] {

    let electroluxShapes: NodeModel[] = [
      ];

    return electroluxShapes;
  }

  



  public setPaletteNodeDefaultsMC(node: NodeModel): void {
      node.width = 30;
      node.height = 20;
      // Syncfusion always shows a hover tooltip (defaults to node id); Custom disables it
      node.tooltip = { openOn: 'Custom' };
  }


  public setPaletteNodeDefaults(node: NodeModel): void {
      node.width = 50;
      node.height = 50;
      // Syncfusion always shows a hover tooltip (defaults to node id); Custom disables it
      node.tooltip = { openOn: 'Custom' };
  }

  

  public diagramNameChange(args: any): void {
  //  (document.getElementById('diagramName') as any).innerHTML = (document.getElementById('diagramEditable') as HTMLInputElement).value;
    document.getElementsByClassName('db-diagram-name-container')[0].classList.remove('db-edit-name');
  }

  public zoomContent()
  {
      // let diagram = (document.getElementById('diagram') as any).ej2_instances[0];
      return Math.round(this.diagram!.scrollSettings.currentZoom*100) + ' %'
  };

  public diagramNameKeyDown(args: KeyboardEvent): void {
    if (args.which === 13) {
  //    (document.getElementById('diagramName') as any).innerHTML = (document.getElementById('diagramEditable') as HTMLInputElement).value;
        document.getElementsByClassName('db-diagram-name-container')[0].classList.remove('db-edit-name');
    }
  }
  public renameDiagram(args: MouseEvent): void {
    document.getElementsByClassName('db-diagram-name-container')[0].classList.add('db-edit-name');
    let element: HTMLInputElement = (document.getElementById('diagramEditable') as HTMLInputElement);
    
    
    element.focus();
  }

  private btnExportClick(): void {
      let diagram: Diagram = this.selectedItem.diagram;
      diagram.exportDiagram({
          fileName: 'aa',
          format: this.selectedItem.exportSettings.format as FileFormats,
          region: this.selectedItem.exportSettings.region as DiagramRegions,
          multiplePage:this.selectedItem.diagram.pageSettings.multiplePage
      });
      this.exportDialog!.hide();
  };

  private btnCancelClick(args: MouseEvent): void {
      let ss: HTMLElement = args.target as HTMLElement;
      let key: string = ss.offsetParent!.id;
      switch (key) {
          case 'exportDialog':
              this.exportDialog!.hide();
              break;
        
          case 'hyperlinkDialog':
              this.hyperlinkDialog!.hide();
              break;
      }
  };

   public openUploadBox(isOpen: boolean, extensionType: string): void {
    let defaultUpload: any = document.getElementById("fileupload");
    defaultUpload = defaultUpload.ej2_instances[0];
    defaultUpload.clearAll();
    this.selectedItem.orgDataSettings.extensionType =
      defaultUpload.allowedExtensions = extensionType;
    defaultUpload.dataBind();
    isOpen = isOpen;
    (
      document.getElementsByClassName("e-file-select-wrap")[0]
        .children[0] as HTMLButtonElement
    ).click();
  }

  private btnHyperLink(): void {
  }

  public getDialogButtons(dialogType: string): Object[] {
      let buttons: Object[] = [];
      switch (dialogType) {
          case 'export':
              buttons.push({
                  click: this.btnExportClick.bind(this), buttonModel: { content: 'Export', cssClass: 'e-flat e-db-primary', isPrimary: true }
              });
              break;
          case 'hyperlink':
              buttons.push({
                  click: this.btnHyperLink.bind(this), buttonModel: { content: 'Apply', cssClass: 'e-flat e-db-primary', isPrimary: true }
              });
              break;
      }
      buttons.push({
          click: this.btnCancelClick.bind(this), buttonModel: { content: 'Cancel', cssClass: 'e-flat', isPrimary: true }
      });
      return buttons;
  }

  private buttonInstance: any;
  public menumouseover(args: MouseEvent): void {
      let diagram = this.selectedItem.diagram;
      let target: any = args.target as HTMLButtonElement;
      if (target && (target.className === 'e-control e-dropdown-btn e-lib e-btn db-dropdown-menu' ||
          target.className === 'e-control e-dropdown-btn e-lib e-btn db-dropdown-menu e-ddb-active')) {
          if (this.buttonInstance && this.buttonInstance.id !== target.id) {
              if (this.buttonInstance.getPopUpElement().classList.contains('e-popup-open')) {
                  this.buttonInstance.toggle();
                  let buttonElement: any = document.getElementById(this.buttonInstance.element.id);
                  buttonElement.classList.remove('e-btn-hover');
              }
          }
          let button1: any = target.ej2_instances[0];
          this.buttonInstance = button1;
          if (button1.getPopUpElement().classList.contains('e-popup-close')) {
              button1.toggle();
              // if (button1.element.id === 'btnEditMenu') {
              //     this.enabelEditMenuItems(diagram.selectedItems);
              // }
              let buttonElement: any = document.getElementById(this.buttonInstance.element.id);
              buttonElement.classList.add('e-btn-hover');
          }
      } 
      else {
          if (closest(target, '.e-dropdown-popup') === null && closest(target, '.e-dropdown-btn') === null) {
              if (this.buttonInstance && this.buttonInstance.getPopUpElement().classList.contains('e-popup-open')) {
                  this.buttonInstance.toggle();
                  let buttonElement: any = document.getElementById(this.buttonInstance.element.id);
                  buttonElement.classList.remove('e-btn-hover');
              }
          }
      }
  }

  public exportItems(): ItemModel[]
  {
      let exportItems: ItemModel[] = [
          { text: 'JPG' }, { text: 'PNG' },{ text: 'SVG' }
      ]
      return exportItems;
  }

  public arrangeMenuBeforeClose(args: BeforeOpenCloseMenuEventArgs): void {
      if (args.event && closest(args.event.target as Element, '.e-dropdown-btn') !== null) {
          args.cancel = true;
      }
      if (!args.element) {
          args.cancel = true;
      }
  }
  public arrangeMenuBeforeOpen(args: BeforeOpenCloseMenuEventArgs): void {
      (args.element.children[0] as HTMLElement).style.display = 'block';
      if (args.event && closest(args.event.target as Element, '.e-dropdown-btn') !== null) {
          args.cancel = true;
      }
  }

  public beforeItemRender(args: MenuEventArgs): void {
    let shortCutText: string = this.utilityMethods.getShortCutKey(args.item.text as any);
    if (shortCutText) {
        let shortCutSpan: HTMLElement = document.createElement('span');
      
        
        shortCutSpan.textContent = shortCutText;
        shortCutSpan.style.pointerEvents = 'none';
        args.element.appendChild(shortCutSpan);
        shortCutSpan.setAttribute('class', 'db-shortcut');
    }
  //   let diagram = (document.getElementById('diagram') as any).ej2_instances[0];
    let status: boolean = this.enableMenuItems(args.item.text as any, this.selectedItem.diagram);
    if (status) {
        args.element.classList.add('e-disabled');
    } else {
        if (args.element.classList.contains('e-disabled')) {
            args.element.classList.remove('e-disabled');
        }
    }
  }

  public toolbarCreated(){
      this.selectedItem.toolbarObj = (document.getElementById('toolbarEditor') as any).ej2_instances[0];
      let c = (document.getElementById('conTypeBtn') as any);
      if(this.selectedItem.toolbarObj.items[5].cssClass.indexOf(' tb-item-selected')!==-1){
          c.classList.add('tb-item-selected');
      }
  }

  public checkBoxCreated(args:any){   
      this.selectedItem.showPageBreak = this.showPageBreak;
  } 

  public toolbarEditorClick(args:ClickEventArgs): void {
      let diagram = this.selectedItem.diagram;
      let toolbarObj = this.selectedItem.toolbarObj;
      let item = args.item.tooltipText;
      switch(item)
      {
          case 'Undo':
              diagram.undo();
              break;
          case 'Redo':
              diagram.redo();
              break;
          case 'Lock':
              this.utilityMethods.lockObject(diagram);
              break;
          case'Delete':
              diagram.remove();
              break;
          case 'Select Tool':
              diagram.clearSelection();
              diagram.tool = DiagramTools.Default;
              break;
            case 'Straight' : 
            this.diagram!.drawingObject = { type: 'Straight' ,targetDecorator:{ shape: "None"}} ;
            this.diagram!.tool = DiagramTools.ContinuousDraw;
            break;
          case 'Text Tool':
              diagram.drawingObject = { shape: { type: 'Text' }, };
              diagram.tool = DiagramTools.ContinuousDraw;
              break;
          case 'Pan Tool':
              diagram.clearSelection()
              diagram.tool = DiagramTools.ZoomPan;
              break;
          case 'Rotate Clockwise':
              diagram.rotate(diagram.selectedItems,90);
              break;
          case 'Rotate Counter-clockwise':
              diagram.rotate(diagram.selectedItems,-90);
              break;
          case 'Bring To Front':
              diagram.bringToFront();
              break;
          case 'Send To Back':
              diagram.sendToBack();
              break;
          case 'Bring Forward':
              diagram.moveForward();
              break;
          case 'Send Backward':
              diagram.sendBackward();
              break;
          case 'Align Left':
          case 'Align Right':
          case 'Align Top':
          case 'Align Bottom':
          case 'Align Middle':
          case 'Align Center':
              // selectedItem.isModified = true;
              var alignType = item.replace('Align', '');
              var alignType1 = alignType.charAt(0).toUpperCase() + alignType.slice(1);
              diagram.align(alignType1.trim() as AlignmentOptions);
              break;
          case 'Distribute Objects Horizontally':
              diagram.distribute('RightToLeft');
              break;
          case 'Distribute Objects Vertically':
              diagram.distribute('BottomToTop');
              break;
          case 'Duplicate':
              this.duplicateNodes();
              break;
          case this.lang.el('Mostra struttura'):
              this.showHideMostraMisure();
              break;
          case this.lang.el('Inserisci in preventivo'):
              this.exportDiagram();
              break;
          case 'Group':
              diagram.group();
              args.item.prefixIcon = 'sf-icon-ungroup';
              args.item.tooltipText = 'UnGroup';
              break;
          case 'UnGroup':
              diagram.unGroup();
              args.item.prefixIcon = 'sf-icon-group';
              args.item.tooltipText = 'Group';
              break;
      }
      if (item === 'Select Tool' || item === 'Pan Tool' || item === 'Text Tool' ||  item === 'Straight' ) {
          if ((args.item.cssClass as string).indexOf('tb-item-selected') === -1) {
              this.utilityMethods.removeSelectedToolbarItem(toolbarObj);
              args.item.cssClass += ' tb-item-selected';
          }
      }
      diagram.dataBind();
  };

  public menuClick(args:MenuEventArgs): void{

    var buttonElement = document.getElementsByClassName('e-btn-hover')[0];
    if (buttonElement) {
        buttonElement.classList.remove('e-btn-hover');
    }
    let diagram = this.selectedItem.diagram;
    let toolbarObj:any = this.selectedItem.toolbarObj;
    var option = args.item.text;
    switch(option)
    {
        case 'New':
            diagram.clear();
          this.diagramClientSideEvents.historyChange();
            break;
        case 'Save':
          //  this.utilityMethods.download(diagram.saveDiagram(), (document.getElementById('diagramName') as HTMLInputElement).innerHTML);
            break;
      
            
        case 'Export':
            this.exportDialog!.show();
            break;
        case 'Open':
            (document.getElementsByClassName('e-file-select-wrap')[0].querySelector('button') as any).click();
            break;
        case 'Undo':
            diagram.undo();
            break;
        case 'Redo':
            diagram.redo();
            break;
        case 'Cut':
            diagram.cut();
            break;
        case 'Copy':
            diagram.copy();
            break;
        case 'Paste':
            diagram.paste();
            break;
        case 'Delete':
            diagram.remove();
            break;
        case 'Insert Link':
        
        case 'Letter (8.5 in x 11 in)':
        case 'Legal (8.5 in x 14 in)':
        case 'A3 (297 mm x 420 mm)':
        case 'A4 (210 mm x 297 mm)':
        case 'A5 (148 mm x 210 mm)':
        case 'A6 (105 mm x 148 mm)':
        case 'Tabloid (279 mm x 432 mm)':
            this.diagramPropertyBinding.paperListChange(args)
            this.utilityMethods.updateSelection(args.item)
            this.selectedItem.pageSettings.paperSize = (args.item as any).value;
            break;
        case 'Show Grid':
        //   diagram.snapSettings.constraints = diagram.snapSettings.constraints ^ SnapConstraints.ShowLines;
            args.item.iconCss  = args.item.iconCss ? '' : 'sf-icon-check-tick';
            break;
        case 'Snap To Grid':
          //  diagram.snapSettings.constraints = diagram.snapSettings.constraints ^ SnapConstraints.SnapToLines;
            args.item.iconCss = args.item.iconCss ? '' : 'sf-icon-check-tick';
            break;
        case 'Show Guides':
        //   diagram.snapSettings.constraints = diagram!.snapSettings.constraints ^ SnapConstraints.SnapToObject;
            args.item.iconCss = args.item.iconCss ? '' : 'sf-icon-check-tick';
            break;
        case 'Show Rulers':
            args.item.iconCss = args.item.iconCss ? '' : 'sf-icon-check-tick';
            diagram.rulerSettings.showRulers = !diagram.rulerSettings.showRulers;
            break;
        case 'Page Break':
            args.item.iconCss = args.item.iconCss ? '' : 'sf-icon-check-tick';
            diagram.pageSettings.showPageBreaks = !diagram.pageSettings.showPageBreaks;
            break;
        case 'Fit To Screen':
            diagram.fitToPage();
    }
    if (option === 'Pan Tool') {
        if (toolbarObj.items[3].cssClass.indexOf('tb-item-selected') === -1) {
            toolbarObj.items[3].cssClass += ' tb-item-selected';
        }
    }
    else if (option === 'Selection Tool') {
        if (toolbarObj.items[4].cssClass.indexOf('tb-item-selected') === -1) {
            toolbarObj.items[4].cssClass += ' tb-item-selected';
        }
    }
    else if (option ===  'Orthogonal' || option === 'Straight' || option === 'Bezier') {
        (document.getElementById('conTypeBtn') as HTMLButtonElement).classList.add('tb-item-selected');
    }
    diagram.dataBind();
  }

  
  public enableMenuItems(itemText: string, diagram: Diagram): boolean {
    
    let selectedItems: Object[] = diagram.selectedItems.nodes as Object[];
    selectedItems = selectedItems.concat(diagram.selectedItems.connectors as ConnectorModel);
    if (itemText) {
        let commandType: string = itemText.replace(/[' ']/g, '');
        if (selectedItems.length === 0) {
            switch (commandType.toLowerCase()) {
                case 'cut':
                    return true;
                case 'copy':
                    return true;
                case 'delete':
                    return true;
                case 'duplicate':
                    return true;
            }
        }
        if (selectedItems.length > 1) {
            switch (commandType.toLowerCase()) {
                case 'edittooltip':
                    return true;
            }
        }
        if (!(diagram?.commandHandler?.clipboardData?.pasteIndex !== undefined
          && diagram.commandHandler.clipboardData.clipObject !==undefined) && itemText === 'Paste') {
            return true;
        }
        if ((itemText === 'Insert Image' || itemText === 'Insert Link') && (diagram as any)?.selectedItems?.nodes?.length === 0) {
          return true;
        }
        if (itemText === 'Undo' && (diagram as any)?.historyManager?.undoStack.length === 0) {
            return true;
        }
        if (itemText === 'Redo' && (diagram as any)?.historyManager?.redoStack.length === 0) {
            return true;
        }
        if (itemText === 'Paste' && (diagram.commandHandler?.clipboardData?.clipObject as any)?.length === 0) {
          return true;
        }
        if (itemText === 'Select All') {
            if (diagram.nodes.length === 0 && diagram.connectors.length === 0) {
                return true;
            }
        }
    }
    return false;
  }

  public setNodeDefaults(node: Node, diagram: Diagram): NodeModel {
    if (node.style) {
        if (node.style.fill === "transparent" && !node.children) {
            node.style.fill = "white";
        }
    }
    let node1: NodeModel = {
        style: { strokeWidth: 1 }
    };
    return node1;
  }
  
  public diagramLoaded(args: any) {
   
  }
  
  public diagramCreated(args: any) {
   
    this.diagram.setActiveLayer("visibleLayer"); 
    this.diagram.fitToPage({ mode: 'Page', region: 'Content'});
    document.getElementById('diagram')!.addEventListener('keydown', this.keyboardDiagramEvent, false);
    document.getElementById('diagram')!.addEventListener('keyup', this.keyboardDiagramEvent, false);
  
    
  
  }

  keyboardDiagramEvent(event: KeyboardEvent){
    
    event.preventDefault();
 
  }

  public diagramCreate(args: Object): void {
    // paletteIconClick();
  }

  duplicateNodes(){
    let maxX=0;
    (this.diagram as Diagram).nodes.forEach((node:any)=>{
      if(node.offsetX+Math.round(node.width/2)>maxX){
        maxX=node.offsetX+Math.round(node.width/2);
      }
   
    });
    
    maxX+=20;
    this.selectedItem.diagram.selectedItems.nodes.forEach((n:any)=>{
       let newNode:any={
        id:'n'+uuid.v4(),
        constraints:n.constraints,
        offsetX:n.offsetX+maxX,
        offsetY:n.offsetY,
        width:n.width,
        height:n.height,
        zIndex:n.zIndex,
        addInfo:n.addInfo,
        shape:n.shape,
        annotations:n.annotations
       };
             
       switch(newNode.addInfo.type){
        case 'cella':
          let c=this.cC.elencoCelle[newNode.addInfo.cellaIndex];
          c.id='n'+uuid.v4();
          if(n.addInfo.subtype){
            c.combinata=n.addInfo.subtype;
          }
          this.mS.changeDescTecnica(c,this.prev.lang);
          this.cC.elencoCelle.push(JSON.parse(JSON.stringify(c)));
          newNode.addInfo.cellaIndex=this.cC.elencoCelle.length-1;
          newNode.addInfo.id=c.id;
          this.addToLayer(newNode.id);
          break;
          
        case 'scaffale':
          let sc=this.cC.elencoScaffali[newNode.addInfo.currScaffaleInd];
          sc.id='n'+uuid.v4();
          this.cC.elencoScaffali.push(sc);
          newNode.addInfo.currScaffaleInd=this.cC.elencoScaffali.length-1;
          newNode.addInfo.id=sc.id;
          break;
        case 'freeblock':
        let fb=this.cC.elencoFreeBlocks[newNode.addInfo.freeBlockInd];
          fb.id='n'+uuid.v4();
          this.cC.elencoFreeBlocks.push(fb);
          newNode.addInfo.freeBlockInd=this.cC.elencoFreeBlocks.length-1;
          newNode.addInfo.id=fb.id;
          break;
        case 'impiantoRemoto':
        let ir=this.cC.elencoImpiantiRemoti[newNode.addInfo.impiantoRemotoInd];
          ir.id='n'+uuid.v4();
          this.cC.elencoImpiantiRemoti.push(fb);
          newNode.addInfo.impiantoRemotoInd=this.cC.elencoImpiantiRemoti.length-1;
          newNode.addInfo.id=ir.id;
          break;
        
        case 'impiantoRemoto':
          let din=this.cC.elencoDropin[newNode.addInfo.dropinInd];
          din.id='n'+uuid.v4();
          this.cC.elencoDropin.push(fb);
          newNode.addInfo.dropinInd=this.cC.elencoDropin.length-1;
          newNode.addInfo.id=din.id;
          break;
        case 'porta':
          this.cC.elencoPorteScollegate.forEach((p:any)=>{
            if(p.id==newNode.addInfo.id){
              let currp=p;
              currp.id='n'+uuid.v4();
              this.cC.elencoPorteScollegate.push(currp);
              newNode.addInfo.id=currp.id;
            }
          });
          break;
      }

      this.diagram.add(newNode);
      
    });
  }
  
  public hideElements(idElement:string,elementType: string, diagram?: Diagram): void {
    
      var diagramContainer = document.getElementsByClassName('diagrambuilder-container')[0];
      if (diagramContainer.classList.contains(elementType)) {
          diagramContainer.classList.remove(elementType);
          ((document.getElementById(idElement) as any).style.backgroundColor as any) = '';
          ((document.getElementById(idElement) as any).style.color as any) = '#fff';
          (document.getElementById(idElement) as any).ej2_instances[0].isPrimary = true;

      }
      else {
          diagramContainer.classList.add(elementType);
          ((document.getElementById(idElement) as any).style.backgroundColor as any) = '#e3e3e3';
          ((document.getElementById(idElement) as any).style.color as any) = 'black';
          (document.getElementById(idElement) as any).ej2_instances[0].isPrimary = false;
          
      }
      
      if (diagram) {
          diagram.updateViewPort();
      }
  }
    
  getTooltipNodes(){

    (this.diagram as Diagram).nodes.forEach((node:any)=>{
        const tipo = node.addInfo?.type;
        // tooltip hover solo su cella / divisorio / porta; altre shape restano mute (openOn Custom)
        if (tipo !== 'cella' && tipo !== 'divisorioorizz' && tipo !== 'porta') {
          node.tooltip = { openOn: 'Custom' };
          return;
        }
        node.constraints = node.constraints | NodeConstraints.Tooltip;
        if(tipo=='cella'){
          let volume=(3+node.width)*(3+node.height);
          const cella = this.cC.elencoCelle.find((x:any)=>x.id==node.addInfo.id);
          if(!cella){
            volume=0;
          } else {
            volume*=(3+cella.altezza)/1000000;
          }
          node.tooltip = {
            content:
              ' '+this.lang.el('Dimensioni')+': '+node.width+'x'+node.height+
              ' '+this.lang.el('vol.:')+': '+ Math.round(volume*100)/100,
            relativeMode: 'Object',
            openOn: 'Auto',
          } as DiagramTooltipModel;
        }
        if(tipo=='divisorioorizz' && node.addInfo.cellaCollegataId){
          let nodoCella=(this.diagram as Diagram).nodes.filter((x:any)=> x.addInfo && x.addInfo.id==node.addInfo.cellaCollegataId)[0];
          let left=Math.round(node.offsetY-node.height/2-nodoCella.offsetY!+nodoCella.height!/2);
          let right=Math.round(nodoCella.height!-node.height-left);
          node.tooltip = {
            content:
              ' '+this.lang.el('Larghezza')+': '+node.width+
              ' '+this.lang.el('Posizione')+': '+': '+left+' '+right,
            relativeMode: 'Object',
            openOn: 'Auto',
          } as DiagramTooltipModel;
        }
        if(tipo=='porta' && node.addInfo.cellaCollegataId && node.addInfo.cellaCollegataId!=0) {
          let content = this.lang.el('Modello')+' - ';
          let porta=this.cC.elencoCelle[node.addInfo.cellaCollegataInd].elencoPorte.filter((x:any)=>x.id==node.addInfo.id)[0];
          if(porta?.modelloPorta!='' && porta?.modelliPortaOptions){
            if(porta.modelliPortaOptions.filter((x:any)=>x.value==porta.modelloPorta).length>0){
                let mod=porta.modelliPortaOptions.filter((x:any)=>x.value==porta.modelloPorta)[0].label;
                content=this.lang.el('Modello')+' '+mod;
            }
          }
          let nodoCella=(this.diagram as Diagram).nodes.filter((x:any)=> x.addInfo && x.addInfo.id==node.addInfo.cellaCollegataId)[0];
          let left=0;
          let right=0;
          if(porta.lato_porta=='lato_sn' || porta.lato_porta=='lato_ds'){
             left=nodoCella.height!-porta.distSnPorta-node.height;
             right=porta.distSnPorta; 
          }
          if(porta.lato_porta=='lato_fronte' || porta.lato_porta=='lato_retro'){
             right=Math.round(nodoCella.width!-porta.distSnPorta-node.width);
             left=Math.round(porta.distSnPorta); 
          }
          content+=' '+this.lang.el('Posizione')+': '+left+' '+right+' '+this.lang.el('Luce netta')+':'+porta.luceNetta;
          node.tooltip = {
            content,
            relativeMode: 'Object',
            openOn: 'Auto',
          } as DiagramTooltipModel;
        }
     
     });
  }

  dropMiniCella(obj:any){
    let c:any=this.mS.initCella(this.opzioniList,this.prev.lang,this.cC.electrolux);
    c.isMiniCella=true;
    c.customClient=obj.addInfo.customClient;
    c.ingombroX=obj.width*10;
    c.ingombroY=obj.height*10;
    c.altezza=200;
    if(obj.addInfo.customClient!='Electrolux'){
      c.minicellaImpianto='Nessun_impianto';
      c.impiantiMiniCelleOptions=[
        {
          value:'Nessun_impianto',
          label:this.lang.el('Nessun impianto')
        },
        {
          value:'FB',
          label:this.lang.el('FB')
        },
        {
          value:'MisaSplit MS',
          label:this.lang.el('MisaSplit MS')
        },
        {
          value:'MisaSplit MSG',
          label:this.lang.el('MisaSplit MSG')
        }
      ];
    } else {
       c.minicellaImpianto='FB';
      c.impiantiMiniCelleOptions=[
        {
          value:'Nessun_impianto',
          label:this.lang.el('Nessun impianto')
        },
        {
          value:'FB',
          label:this.lang.el('FB')
        },
        {
          value:'MisaSplit MSG',
          label:this.lang.el('MisaSplit MSG')
        }
      ];
    }
    

    this.mS.changeDescTecnica(c,this.prev.lang);
    this.cC.elencoCelle.push(c);
    obj.shape.content=this.mS.setCellaContent(c,this.cC.elencoCelle);
    obj.addInfo.id=c.id;
    obj.offsetX=460;
    obj.offsetY=260;
    obj.height=obj.height*10;
    obj.width=obj.width*10;
    obj.addInfo.nodeHeight=obj.height*10;
    obj.addInfo.nodeWidth=obj.width*10;
    obj.addInfo.cellaIndex=this.cC.elencoCelle.length-1;
    this.diagram.add(obj);  
    this.addToLayer(obj.id);
    this.diagram.dataBind();
    // aggiunge porta
    let copyPorta = (JSON.parse(JSON.stringify(this.mS.nodePortaDS)));
    copyPorta.offsetX=obj.offsetX;
    copyPorta.offsetY=Math.round(obj.offsetY+obj.height/2+copyPorta.height/2);
    this.diagram.add(copyPorta);  
  
    let args={
      oldValue:{
        offsetX:copyPorta.offsetX,
        offsetY:copyPorta.offsetY,
      }
    };
    this.diagram.dataBind();
    (this.diagram as Diagram).nodes.forEach((node:any)=>{
      if(node.addInfo.type=='porta'){
        (this.diagram as Diagram).select([node]);
        this.checkPositionNode(node, args);
        let cc= this.cC.elencoCelle[this.cC.elencoCelle.length-1];
        this.changeModPorta(null,cc,cc.elencoPorte[cc.elencoPorte.length-1]);
      
      }
    });
    
                     
    /*
    (this.diagram as Diagram).nodes.forEach((node:any)=>{
      if(node.addInfo.type=='cella'){
        (this.diagram as Diagram).select([node]);
      }
    });
    */
  }

  bringToFront(obj:any){
    setTimeout(() => {

      if(!obj || obj.addInfo.type=='cella'){
          let ele:any[]=[];
          (this.diagram as Diagram).nodes.forEach((node:any)=>{
            if(node.addInfo.type=='porta' 
              || node.addInfo.type=='scaffale' 
              || node.addInfo.type=='divisorioorizz' 
              || node.addInfo.type=='divisoriovert' ){
              ele.push(node);
            }
          });
          this.diagram.select(ele);   
       
          this.diagram.bringToFront();   
          if(!obj){
            this.diagram.clearSelection();   
          }
        }
      
      this.getTooltipNodes();
 
    }, 500);
  }

  /**
   * Porta la cella selezionata sopra le altre celle (senza cambiare selezione),
   * poi riporta porte/scaffali/divisori sopra. Evita celle "non cliccabili" per overlap+zIndex.
   */
  bringCellaSopraAltreCelle(cellaNode: any): void {
    if (!this.diagram || !cellaNode?.addInfo || cellaNode.addInfo.type !== 'cella') {
      return;
    }
    const nodes = (this.diagram as Diagram).nodes as any[];
    let maxZ = 0;
    nodes.forEach((n: any) => {
      maxZ = Math.max(maxZ, n.zIndex || 0);
    });
    cellaNode.zIndex = maxZ + 1;
    let z = cellaNode.zIndex;
    nodes.forEach((n: any) => {
      const t = n?.addInfo?.type;
      if (t === 'porta' || t === 'scaffale' || t === 'divisorioorizz' || t === 'divisoriovert') {
        z += 1;
        n.zIndex = z;
      }
    });
  }

  /**
   * Imposta il bordo HTML solo sui pezzi di lato non adiacenti.
   * Per le celle: nasconde solo i tratti verso altre celle con collegamento
   * celleCollegate attivo e tipoCollegamento === 'unite' (lato da latocollegato).
   */
  updateHtmlNodesOuterBorders(options?: {
    nodeFilter?: (n: any) => boolean;
    borderWidth?: number;
    borderColor?: string;
    gapTolerance?: number;
  }): void {
    if (!this.diagram) {
      return;
    }

    const defaultBorderWidth = options?.borderWidth ?? 3;
    const eps = options?.gapTolerance ?? 3;
    const mergeEps = 0.5;
    const nodeFilter =
      options?.nodeFilter ??
      ((n: any) => n?.shape?.type === 'HTML' && n?.addInfo?.type === 'cella');
    type RectInfo = {
      node: any;
      cellId: string;
      left: number;
      right: number;
      top: number;
      bottom: number;
      width: number;
      height: number;
      borderWidth: number;
      colorTop: string;
      colorRight: string;
      colorBottom: string;
      colorLeft: string;
    };
    type Interval = { a: number; b: number };

    const extractBackground = (content: string): string => {
      if (!content) {
        return this.mS.coloreSfondoCella || '#FFF9EF';
      }
      const m = content.match(/background-color\s*:\s*([^;"]+)/i);
      return m ? m[1].trim() : this.mS.coloreSfondoCella || '#FFF9EF';
    };

    /** Legge colori/spessore bordo già presenti nel content HTML/SVG */
    const extractBorderStyle = (content: string, fallbackColor: string, fallbackWidth: number) => {
      const colors = {
        top: fallbackColor,
        right: fallbackColor,
        bottom: fallbackColor,
        left: fallbackColor,
      };
      let width = fallbackWidth;
      let foundCss = false;

      if (!content) {
        return { colors, width };
      }

      const normalizeColor = (c: string): string => {
        const t = (c || '').trim();
        // transparent da setCellaContent/unite non deve “ Sticky ” sui passaggi successivi
        if (!t || t.toLowerCase() === 'transparent') {
          return fallbackColor;
        }
        return t;
      };

      const shorthand = content.match(/border\s*:\s*(\d+(?:\.\d+)?)px\s+solid\s+([^;"]+)/i);
      if (shorthand) {
        foundCss = true;
        width = parseFloat(shorthand[1]) || width;
        const c = normalizeColor(shorthand[2]);
        colors.top = colors.right = colors.bottom = colors.left = c;
      }

      const sideRe = /border-(top|right|bottom|left)\s*:\s*(\d+(?:\.\d+)?)px\s+solid\s+([^;"]+)/gi;
      let m: RegExpExecArray | null;
      while ((m = sideRe.exec(content)) !== null) {
        foundCss = true;
        const side = m[1].toLowerCase() as 'top' | 'right' | 'bottom' | 'left';
        width = parseFloat(m[2]) || width;
        colors[side] = normalizeColor(m[3]);
      }

      // passata precedente con SVG: recupera stroke per lato
      if (!foundCss) {
        const lineTags = content.match(/<line\b[^>]*>/gi) || [];
        lineTags.forEach((tag) => {
          const stroke = tag.match(/stroke="([^"]+)"/i)?.[1]?.trim();
          const sw = tag.match(/stroke-width="(\d+(?:\.\d+)?)"/i)?.[1];
          if (sw) {
            width = parseFloat(sw) || width;
          }
          if (!stroke || stroke.toLowerCase() === 'transparent') {
            return;
          }
          const x1 = parseFloat(tag.match(/x1="([^"]+)"/i)?.[1] || 'NaN');
          const y1 = parseFloat(tag.match(/y1="([^"]+)"/i)?.[1] || 'NaN');
          const x2 = parseFloat(tag.match(/x2="([^"]+)"/i)?.[1] || 'NaN');
          const y2 = parseFloat(tag.match(/y2="([^"]+)"/i)?.[1] || 'NaN');
          if (Number.isNaN(x1) || Number.isNaN(y1) || Number.isNaN(x2) || Number.isNaN(y2)) {
            return;
          }
          if (Math.abs(y1 - y2) <= 0.5) {
            if (y1 <= width) {
              colors.top = stroke;
            } else {
              colors.bottom = stroke;
            }
          } else if (Math.abs(x1 - x2) <= 0.5) {
            if (x1 <= width) {
              colors.left = stroke;
            } else {
              colors.right = stroke;
            }
          }
        });
      }

      return { colors, width };
    };

    const defaultBorderForCella = (node: any): string => {
      if (options?.borderColor) {
        return options.borderColor;
      }
      if (node.addInfo?.type === 'cella' && typeof node.addInfo.cellaIndex === 'number') {
        const cella = this.cC?.elencoCelle?.[node.addInfo.cellaIndex];
        if (cella?.finitura && cella.finitura !== 'STANDARD') {
          return this.mS.pannelloAzzurro || '#7ACEE8';
        }
      }
      return this.mS.pannelloPanna || '#D6D38F';
    };

    const mergeIntervals = (intervals: Interval[]): Interval[] => {
      if (!intervals.length) {
        return [];
      }
      const sorted = intervals
        .map((i) => ({ a: Math.min(i.a, i.b), b: Math.max(i.a, i.b) }))
        .filter((i) => i.b - i.a > 1e-6)
        .sort((x, y) => x.a - y.a);
      if (!sorted.length) {
        return [];
      }
      const out: Interval[] = [{ ...sorted[0] }];
      for (let i = 1; i < sorted.length; i++) {
        const cur = sorted[i];
        const last = out[out.length - 1];
        if (cur.a <= last.b + mergeEps) {
          last.b = Math.max(last.b, cur.b);
        } else {
          out.push({ ...cur });
        }
      }
      return out;
    };

    const subtractIntervals = (full: Interval, covered: Interval[]): Interval[] => {
      const merged = mergeIntervals(covered);
      const free: Interval[] = [];
      let cursor = full.a;
      for (const c of merged) {
        const ca = Math.max(c.a, full.a);
        const cb = Math.min(c.b, full.b);
        if (cb <= ca) {
          continue;
        }
        if (ca > cursor + 1e-6) {
          free.push({ a: cursor, b: ca });
        }
        cursor = Math.max(cursor, cb);
      }
      if (cursor < full.b - 1e-6) {
        free.push({ a: cursor, b: full.b });
      }
      return free.filter((i) => i.b - i.a > 1e-6);
    };

    const overlap1D = (a1: number, a2: number, b1: number, b2: number): Interval | null => {
      const a = Math.max(a1, b1);
      const b = Math.min(a2, b2);
      // serve un'overlap reale (non solo un punto)
      if (b - a > mergeEps) {
        return { a, b };
      }
      return null;
    };

    /** gap in [-eps, eps] = lati a contatto (anche leggero overlap) */
    const sidesTouch = (gap: number): boolean => gap >= -eps && gap <= eps;

    const rects: RectInfo[] = [];
    (this.diagram as Diagram).nodes.forEach((node: any) => {
      if (!nodeFilter(node)) {
        return;
      }

      let left: number;
      let top: number;
      let width: number;
      let height: number;

      // preferisci offset/width del nodo (bounds Syncfusion a volte uniscono celle adiacenti)
      width = node.width || 0;
      height = node.height || 0;
      left = (node.offsetX || 0) - width / 2;
      top = (node.offsetY || 0) - height / 2;
      if (width <= 0 || height <= 0) {
        const bounds = node.wrapper?.bounds;
        if (bounds && bounds.width > 0 && bounds.height > 0) {
          left = bounds.x;
          top = bounds.y;
          width = bounds.width;
          height = bounds.height;
        }
      }
      if (width <= 0 || height <= 0) {
        return;
      }
      if (!node.addInfo?.id) {
        return;
      }

      let bw = defaultBorderWidth;
      if (node.addInfo?.type === 'cella' && typeof node.addInfo.cellaIndex === 'number') {
        const cella = this.cC?.elencoCelle?.[node.addInfo.cellaIndex];
        if (cella?.spessore) {
          bw = cella.spessore;
        }
      }

      const fallbackColor = defaultBorderForCella(node);
      const parsed = extractBorderStyle(node.shape?.content || '', fallbackColor, bw);

      rects.push({
        node,
        cellId: node.addInfo.id,
        left,
        right: left + width,
        top,
        bottom: top + height,
        width,
        height,
        borderWidth: parsed.width,
        colorTop: parsed.colors.top,
        colorRight: parsed.colors.right,
        colorBottom: parsed.colors.bottom,
        colorLeft: parsed.colors.left,
      });
    });

    const findCellaById = (id: string): any => {
      if (!this.cC?.elencoCelle || !id) {
        return null;
      }
      return this.cC.elencoCelle.find((c: any) => c.id === id) || null;
    };

    /** Collegamento unite attivo da cellaA verso cellaB */
    const findUniteLink = (cellaAId: string, cellaBId: string): any => {
      const cella = findCellaById(cellaAId);
      if (!cella?.celleCollegate) {
        return null;
      }
      return (
        cella.celleCollegate.find(
          (c: any) =>
            c.attivo === true &&
            c.tipoCollegamento === 'unite' &&
            c.cellaCollegataId == cellaBId,
        ) || null
      );
    };

    const buildSvgLines = (
      rect: RectInfo,
      freeTop: Interval[],
      freeRight: Interval[],
      freeBottom: Interval[],
      freeLeft: Interval[],
    ): string => {
      const sw = rect.borderWidth;
      const lines: string[] = [];
      const pushH = (y: number, segs: Interval[], color: string) => {
        if (!color || color.toLowerCase() === 'transparent') {
          return;
        }
        segs.forEach((s) => {
          const x1 = s.a - rect.left;
          const x2 = s.b - rect.left;
          lines.push(
            `<line x1="${x1}" y1="${y}" x2="${x2}" y2="${y}" stroke="${color}" stroke-width="${sw}" stroke-linecap="square" />`,
          );
        });
      };
      const pushV = (x: number, segs: Interval[], color: string) => {
        if (!color || color.toLowerCase() === 'transparent') {
          return;
        }
        segs.forEach((s) => {
          const y1 = s.a - rect.top;
          const y2 = s.b - rect.top;
          lines.push(
            `<line x1="${x}" y1="${y1}" x2="${x}" y2="${y2}" stroke="${color}" stroke-width="${sw}" stroke-linecap="square" />`,
          );
        });
      };

      const inset = sw / 2;
      pushH(inset, freeTop, rect.colorTop);
      pushH(rect.height - inset, freeBottom, rect.colorBottom);
      pushV(inset, freeLeft, rect.colorLeft);
      pushV(rect.width - inset, freeRight, rect.colorRight);

      return lines.join('');
    };

    type SideCovers = {
      top: Interval[];
      bottom: Interval[];
      left: Interval[];
      right: Interval[];
    };
    const coversByCellId = new Map<string, SideCovers>();
    rects.forEach((r) => {
      coversByCellId.set(r.cellId, { top: [], bottom: [], left: [], right: [] });
    });

    const addCover = (
      cellId: string,
      lato: string,
      ov: Interval,
    ) => {
      const c = coversByCellId.get(cellId);
      if (!c || !ov) {
        return;
      }
      switch (lato) {
        case 'lato_retro': c.top.push(ov); break;
        case 'lato_fronte': c.bottom.push(ov); break;
        case 'lato_sn': c.left.push(ov); break;
        case 'lato_ds': c.right.push(ov); break;
      }
    };

    // Coppie unite: nasconde solo il tratto effettivamente a contatto.
    // Usa SOLO geometria del lato indicato da latocollegato (non ogni adiacenza).
    for (let i = 0; i < rects.length; i++) {
      for (let j = i + 1; j < rects.length; j++) {
        const a = rects[i];
        const b = rects[j];
        const linkAB = findUniteLink(a.cellId, b.cellId);
        const linkBA = findUniteLink(b.cellId, a.cellId);
        if (!linkAB && !linkBA) {
          continue;
        }

        // adiacenza orizzontale: a a sinistra di b (contatto a.ds / b.sn)
        const gapALeftOfB = b.left - a.right;
        const gapBLeftOfA = a.left - b.right;
        if (sidesTouch(gapALeftOfB)) {
          const ov = overlap1D(a.top, a.bottom, b.top, b.bottom);
          if (ov) {
            addCover(a.cellId, 'lato_ds', ov);
            addCover(b.cellId, 'lato_sn', ov);
          }
          continue;
        }
        if (sidesTouch(gapBLeftOfA)) {
          const ov = overlap1D(a.top, a.bottom, b.top, b.bottom);
          if (ov) {
            addCover(b.cellId, 'lato_ds', ov);
            addCover(a.cellId, 'lato_sn', ov);
          }
          continue;
        }

        // adiacenza verticale: a sopra b (contatto a.fronte=bottom / b.retro=top)
        const gapAAboveB = b.top - a.bottom;
        const gapBAboveA = a.top - b.bottom;
        if (sidesTouch(gapAAboveB)) {
          const ov = overlap1D(a.left, a.right, b.left, b.right);
          if (ov) {
            addCover(a.cellId, 'lato_fronte', ov);
            addCover(b.cellId, 'lato_retro', ov);
          }
          continue;
        }
        if (sidesTouch(gapBAboveA)) {
          const ov = overlap1D(a.left, a.right, b.left, b.right);
          if (ov) {
            addCover(b.cellId, 'lato_fronte', ov);
            addCover(a.cellId, 'lato_retro', ov);
          }
        }
      }
    }

    rects.forEach((rect) => {
      const covers = coversByCellId.get(rect.cellId) || {
        top: [],
        bottom: [],
        left: [],
        right: [],
      };

      const freeTop = subtractIntervals({ a: rect.left, b: rect.right }, covers.top);
      const freeBottom = subtractIntervals({ a: rect.left, b: rect.right }, covers.bottom);
      const freeLeft = subtractIntervals({ a: rect.top, b: rect.bottom }, covers.left);
      const freeRight = subtractIntervals({ a: rect.top, b: rect.bottom }, covers.right);

      const bg = extractBackground(rect.node.shape?.content || '');
      const svgLines = buildSvgLines(rect, freeTop, freeRight, freeBottom, freeLeft);

      rect.node.shape.content =
        `<div style="position:relative;box-sizing:border-box;width:100%;height:100%;background-color:${bg};overflow:hidden;">` +
        `<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 ${rect.width} ${rect.height}" preserveAspectRatio="none" style="position:absolute;left:0;top:0;display:block;pointer-events:none;overflow:visible;">` +
        svgLines +
        `</svg></div>`;
    });

    this.diagram.dataBind();
  }

  collapseAllSymbol(){
    if(this.symbolpalette){
  
      for (let i = 0; i < this.symbolpalette.palettes.length; i++) {
        this.symbolpalette.palettes[i].expanded = false;
      }
      this.symbolpalette.refresh();
    }
  }

  public drop(args: IDropEventArgs) {
    
   

    setTimeout(() => {
       this.collapseAllSymbol();
    }, 700);
   
  
     // args.cancel= true;
     if(this.currentLevel!=this.lang.el('Mostra celle')){
       args.cancel= true;
       return;
     }

    let obj: any = args.element as NodeModel;
    
   

    obj.offsetX=Math.round(obj.offsetX/20)*20;
    obj.offsetY=Math.round(obj.offsetY/20)*20;
    // MINICELLA
    if(obj.addInfo.isMiniCella){
      this.dropMiniCella(obj);
      return;
    }
    this.adjustDivisorioVertOrizz(obj);
   
    if(obj.addInfo.type=='scaffale'){
      obj.shape.content=this.mS.scaffaleContent;
    }
    if(obj.addInfo.type=='divisoriovert'){
      obj.shape.content=this.mS.divisirioVertContent;
    }
    if(obj.addInfo.type=='divisorioorizz'){
      obj.shape.content=this.mS.divisirioOrizzContent;
    }
    
    if(obj.addInfo.type=='porta'){
      let pId=this.mS.addPortaScollegata(this.cC,obj);
      obj.addInfo.id=pId;
    }


    
    this.bringToFront(obj);  
   
    


    if(obj.addInfo.type=='freeblock' && !obj.addInfo.hasOwnProperty('freeBlockInd')){
      let fb=this.mS.initFB(6,obj.properties.addInfo.dimensione,obj.properties.width,obj.properties.height,0,'','');
      this.cC.elencoFreeBlocks.push(fb);
      this.mS.changeFreeBlockOptions(this.cC,this.cC.elencoFreeBlocks.length-1,this.prev,true);
      obj.addInfo.freeBlockInd=this.cC.elencoFreeBlocks.length-1;
      obj.addInfo.id=fb.id;

      this.mS.setFreeBlock(this.cC,this.cC.elencoFreeBlocks.length-1,this.prev);

      
    }
    

    if(obj.addInfo.type=='impiantoRemoto' && !obj.addInfo.hasOwnProperty('impiantoRemotoInd')){
      let ir=this.mS.initimpiantoRemoto(obj.addInfo.title);
      this.cC.elencoImpiantiRemoti.push(ir);
      obj.addInfo.impiantoRemotoInd=this.cC.elencoImpiantiRemoti.length-1;
      obj.addInfo.id=ir.id;
    }
     

    this.checkPositionNode(obj);
   
    if(obj.addInfo.type=='scaffale' ){
      let larg=0;
      if(obj.addInfo.title.indexOf('R')>0){
        larg=obj.height;
        let minY=-1;
        let maxY=-1;
        let offsetY=0;
        larg=obj.width;;
        if(obj.addInfo.cellaCollegataId){
          (this.diagram as Diagram).nodes.forEach((node:any)=>{
            if(node.addInfo.type=='cella' && node.addInfo.id==obj.addInfo.cellaCollegataId){
              if(minY<0 || minY>Math.round(node.offsetY-node.height/2)){
                minY=Math.round(node.offsetY-node.height/2);
                offsetY=node.ofoffsetYfsetX;
              }
              if(maxY<0 || maxY<Math.round(node.offsetY+node.height/2)){
                maxY=Math.round(node.offsetY+node.height/2);
              }
            }
          });
          (this.diagram as Diagram).nodes.forEach((node:any)=>{
            if(node.addInfo.type=='scaffale' && node.addInfo.title.indexOf('R')<0 
            && node.addInfo.cellaCollegataId==obj.addInfo.cellaCollegataId){
              if(obj.offsetY>node.offsetY && minY<Math.round(node.offsetY+node.height/2)){
                minY=Math.round(node.offsetY+node.height/2);
                offsetY=node.offsetY;
              }
              if(obj.offsetY<node.offsetY && maxY>Math.round(node.offsetY-node.height/2)){
                maxY=Math.round(node.offsetY-node.height/2);
              }
            }
          });
          larg=maxY-minY;
          obj.offsetY=minY+Math.round(obj.height/2);
        }
      } else{
        let minX=-1;
        let maxX=-1;
        let offsetX=0;
        larg=obj.width;;
        if(obj.addInfo.cellaCollegataId){
          (this.diagram as Diagram).nodes.forEach((node:any)=>{
            if(node.addInfo.type=='cella' && node.addInfo.id==obj.addInfo.cellaCollegataId){
              if(minX<0 || minX>Math.round(node.offsetX-node.width/2)){
                minX=Math.round(node.offsetX-node.width/2);
                offsetX=node.offsetX;
              }
              if(maxX<0 || maxX<Math.round(node.offsetX+node.width/2)){
                maxX=Math.round(node.offsetX+node.width/2);
              }
            }
          });
          (this.diagram as Diagram).nodes.forEach((node:any)=>{
            if(node.addInfo.type=='scaffale' && node.addInfo.title.indexOf('R')>0 
            && node.addInfo.cellaCollegataId==obj.addInfo.cellaCollegataId){
              if(obj.offsetX>node.offsetX && minX<Math.round(node.offsetX+node.width/2)){
                minX=Math.round(node.offsetX+node.width/2);
                offsetX=node.offsetX;
              }
              if(obj.offsetX<node.offsetX && maxX>Math.round(node.offsetX-node.width/2)){
                maxX=Math.round(node.offsetX-node.width/2);
              }
            }
          });
          larg=maxX-minX;
          obj.offsetX=minX+Math.round(obj.width/2);
        }
      }
   

      let sc=this.mS.initScaffale(larg);
      this.cC.elencoScaffali.push(sc);
      obj.addInfo.currScaffaleInd=this.cC.elencoScaffali.length-1;
      obj.addInfo.id=sc.id;
      this.changeScaffale(this.cC.elencoScaffali[this.cC.elencoScaffali.length-1]);
    }
    
    if(obj.addInfo.type=='dropin' && !obj.addInfo.hasOwnProperty('cellaCollegataInd')  ){
      let din=this.mS.initDropIn(6);
      this.cC.elencoDropin.push(din);
      this.mS.changeDropinOptionms(this.cC,this.cC.elencoDropin.length-1);
      obj.addInfo.dropinInd=this.cC.elencoDropin.length-1;
      obj.addInfo.id=din.id;
    }

    if(obj.addInfo.type=='cella'){
          let c=this.mS.initCella(this.opzioniList,this.prev.lang,this.cC.electrolux);
          if(obj.addInfo.subtype){
            c.combinata=obj.addInfo.subtype;
          }
          this.mS.changeDescTecnica(c,this.prev.lang);
          this.cC.elencoCelle.push(c);
          obj.shape.content=this.mS.setCellaContent(c,this.cC.elencoCelle);
          obj.addInfo.id=c.id;
          obj.addInfo.cellaIndex=this.cC.elencoCelle.length-1;
          this.addToLayer(obj.id);
          this.cC.elencoCelle[obj.addInfo.cellaIndex].offsetX=obj.offsetX;
          this.cC.elencoCelle[obj.addInfo.cellaIndex].offsetY=obj.offsetY;
    }
    
  }

  public isOncella(nodoCella:any,nodeSelezionato:any){
    let xSCella=Math.round(nodoCella.offsetX-nodoCella.width/2);
    let ySCella=Math.round(nodoCella.offsetY-nodoCella.height/2);
    let xLCella=Math.round(nodoCella.offsetX+nodoCella.width/2);
    let yLCella=Math.round(nodoCella.offsetY+nodoCella.height/2);
    let xSNodo=Math.round(nodeSelezionato.offsetX-nodeSelezionato.width/2);
    let ySNodo=Math.round(nodeSelezionato.offsetY-nodeSelezionato.height/2);
    let xLNodo=Math.round(nodeSelezionato.offsetX+nodeSelezionato.width/2);
    let yLNodo=Math.round(nodeSelezionato.offsetY+nodeSelezionato.height/2);
    // latoSn
    if(Math.abs(xSCella-xLNodo)<=5 && ySNodo>=ySCella && ySNodo<=yLCella && yLNodo>=ySCella && yLNodo<=yLCella ){
          let distLato=yLCella-yLNodo;
     
      return {
        lato:'lato_sn',
        gradi:270,
        distLato:distLato
      }
    }
    // latoDs
    if(Math.abs(xLCella-xSNodo)<=5 && ySNodo>=ySCella && ySNodo<=yLCella && yLNodo>=ySCella && yLNodo<=yLCella ){
       let distLato=yLCella-yLNodo;
      return {
        lato:'lato_ds',
        gradi:90,
        distLato:distLato
      };
    }
    // lato Sopra
   
    if(Math.abs(ySCella-yLNodo)<=5 && xSNodo>=xSCella && xSNodo<=xLCella && xLNodo>=xSCella && xLNodo<=xLCella ){
      let distLato=xSNodo-xSCella;
      return {
        lato:'lato_retro',
        gradi:0,
        distLato:distLato
      };
    }
    // lato sotto
    if(Math.abs(yLCella-ySNodo)<=5 && xSNodo>=xSCella && xSNodo<=xLCella && xLNodo>=xSCella && xLNodo<=xLCella ){
      let distLato=xSNodo-xSCella;
      return {
        lato:'lato_fronte',
        gradi:180,
        distLato:distLato
      };
    }
    return null;

   
  }
  public isInsCella(nodoCella:any,nodeSel:any){
    let lxCella=Math.round(nodoCella.offsetX-nodoCella.width/2);
    let rxCella=Math.round(nodoCella.offsetX+nodoCella.width/2);
    let tyCella=Math.round(nodoCella.offsetY-nodoCella.height/2);
    let byCella=Math.round(nodoCella.offsetY+nodoCella.height/2);

    let lxNode=Math.round(nodeSel.offsetX-nodeSel.width/2);
    let rxNode=Math.round(nodeSel.offsetX+nodeSel.width/2);
    let tyNode=Math.round(nodeSel.offsetY-nodeSel.height/2);
    let byNode=Math.round(nodeSel.offsetY+nodeSel.height/2);
    if(lxCella<=lxNode && rxCella>=rxNode && tyCella<=tyNode && byCella>=byNode ){
      return true;
    } else {
      return false;
    }
   
  }
 adjustDivisorioVertOrizz(nodeSel:any){
  if(nodeSel.addInfo.type=='divisorioorizz' || nodeSel.addInfo.type=='divisoriovert'){
      (this.diagram as Diagram).nodes.forEach((node:any)=>{
        if(node.addInfo.type=='cella'){
          if(this.isInsCella(node,nodeSel)){
            let w=0;
            if(nodeSel.addInfo.type=='divisorioorizz'){
              nodeSel.offsetY=Math.round(nodeSel.offsetY / 20) * 20;
              nodeSel.offsetX=node.offsetX;
              nodeSel.width=node.width;
              w=nodeSel.width;
              this.cC.elencoCelle.forEach((c:any)=>{
                c.celleCollegate.forEach((coll:any)=>{
                  if(coll.cellaCollegataId==node.addInfo.id){
                    if(coll.tipoCollegamento=='unite' && coll.latocollegato=='lato_sn'){
                       (this.diagram as Diagram).nodes.filter((x:any)=>x.addInfo.id==c.id).forEach((nodeColl:any)=>{
                        let yTop=Math.round(nodeColl.offsetY-nodeColl.height/2);
                        let yBotom=Math.round(nodeColl.offsetY+nodeColl.height/2);
                        if(Math.round(nodeSel.offsetY-nodeSel.height/2)>yTop && Math.round(nodeSel.offsetY+nodeSel.height/2)<yBotom ){
                          nodeSel.width+=nodeColl.width;
                          w+=nodeColl.width;
                          nodeSel.offsetX=Math.round(nodeColl.offsetX-node.width-nodeColl.width/2+nodeSel.width/2);
                        }
                       });
                    }
                    if(coll.tipoCollegamento=='unite' && coll.latocollegato=='lato_ds'){
                       (this.diagram as Diagram).nodes.filter((x:any)=>x.addInfo.id==c.id).forEach((nodeColl:any)=>{
                        let yTop=Math.round(nodeColl.offsetY-nodeColl.height/2);
                        let yBotom=Math.round(nodeColl.offsetY+nodeColl.height/2);
                        if(Math.round(nodeSel.offsetY-nodeSel.height/2)>yTop && Math.round(nodeSel.offsetY+nodeSel.height/2)<yBotom ){
                          nodeSel.width+=nodeColl.width;
                          w+=nodeColl.width;
                          nodeSel.offsetX=Math.round(nodeColl.offsetX-nodeColl.width/2+nodeSel.width/2);
                        }
                       });
                    }
                  }
                });
              });
              
            } else {
              nodeSel.offsetX=Math.round(nodeSel.offsetX / 20) * 20;
              nodeSel.offsetY=node.offsetY;
              nodeSel.height=node.height;
              w=nodeSel.height;
              this.cC.elencoCelle.forEach((c:any)=>{
                c.celleCollegate.forEach((coll:any)=>{
                  if(coll.cellaCollegataId==node.addInfo.id){
                    if(coll.tipoCollegamento=='unite' && coll.latocollegato=='lato_fronte'){
                       (this.diagram as Diagram).nodes.filter((x:any)=>x.addInfo.id==c.id).forEach((nodeColl:any)=>{
                        let xTop=Math.round(nodeColl.offsetX-nodeColl.width/2);
                        let xBotom=Math.round(nodeColl.offsetX+nodeColl.width/2);
                        if(Math.round(nodeSel.offsetX-nodeSel.width/2)>xTop && Math.round(nodeSel.offsetX+nodeSel.width/2)<xBotom ){
                          nodeSel.height+=nodeColl.height;
                          w+=nodeColl.height;
                          nodeSel.offsetY=Math.round(nodeColl.offsetY-nodeColl.height/2+nodeSel.height/2);
                        }
                       });
                    }
                    if(coll.tipoCollegamento=='unite' && coll.latocollegato=='lato_retro'){
                       (this.diagram as Diagram).nodes.filter((x:any)=>x.addInfo.id==c.id).forEach((nodeColl:any)=>{
                        let xTop=Math.round(nodeColl.offsetX-nodeColl.width/2);
                        let xBotom=Math.round(nodeColl.offsetX+nodeColl.width/2);
                        if(Math.round(nodeSel.offsetX-nodeSel.width/2)>xTop && Math.round(nodeSel.offsetX+nodeSel.width/2)<xBotom ){
                          nodeSel.height+=nodeColl.height;
                          w+=nodeColl.height;
                          nodeSel.offsetY=Math.round(nodeColl.offsetY-node.height-nodeColl.height/2+nodeSel.height/2);

                        }
                       });
                    }
                  }
                });
              });
            }
            if(nodeSel.addInfo.cellaCollegataId){
              this.cC.elencoCelle.forEach((c:any)=>{
                if(c.id==node.addInfo.id){
                  c.divisori.forEach((d:any)=>{
                    if(d.id==nodeSel.addInfo.divisorioCollegatoId){
                      d.w=w;
                      d.x=nodeSel.offsetX;
                      d.y=nodeSel.offsetY;
                    }
                  });
                }
              });
            } else {
              nodeSel.addInfo.cellaCollegataId=node.addInfo.id;
              this.cC.elencoCelle.forEach((c:any,ind:number)=>{
                if(c.id==node.addInfo.id){
                  let d=this.mS.initDivisorio(nodeSel.addInfo.type,w,c.spessore,nodeSel.offsetX,nodeSel.offsetY);
                  let distLato=Math.round(node.offsetY+node.height/2)-Math.round(nodeSel.offsetY+nodeSel.height/2);
                  if(nodeSel.addInfo.type!='divisorioorizz'){
                    distLato=Math.round(nodeSel.offsetX+nodeSel.width/2)-Math.round(node.offsetX-node.width/2);
                  }
                  d.distLato=distLato;
                  nodeSel.addInfo.divisorioCollegatoId=d.id;
                  nodeSel.addInfo.cellaIndex=ind; 
                  nodeSel.addInfo.cellaCollegataId=c.id; 
                  nodeSel.addInfo.distLato=distLato; 
                  c.divisori.push(d);
                }
              });
            }
          }
        }
      });
    }
 }
       
  public positionChange(args: any) {   
  
     if(this.currentLevel==this.lang.el('Mostra pareti')){
        args.cancel=true;
        return;
    }
    if(this.selectedItem.diagram.selectedItems.nodes[0].children){
      return;
    }

  
    if(this.selectedItem.diagram.selectedItems.nodes[0].addInfo.type=='cella'
      || this.selectedItem.diagram.selectedItems.nodes[0].addInfo.type=='scaffale'
    ){

        if(this.mS.disabledMoveOrResize(this.cC,this.selectedItem.diagram.selectedItems.nodes[0])){
          args.cancel=true;
          return;
        }
    }

    
    this.selectedItem.preventPropertyChange = true;
    this.selectedItem.nodeProperties.offsetX = (Math.round(args.newValue.offsetX * 100) / 100);
    this.selectedItem.nodeProperties.offsetY = (Math.round(args.newValue.offsetY * 100) / 100);
    if (args.state === 'Completed') {

      this.selectedItem.isModified = true;
      this.selectedItem.preventPropertyChange = false;
     
      if(this.selectedItem.diagram.selectedItems.nodes.length==1){
       
        let nodeSel=this.selectedItem.diagram.selectedItems.nodes[0];
       
        
        this.adjustDivisorioVertOrizz(nodeSel);
      
        if(nodeSel.addInfo.type=='cella'){
           this.removeMisure();
        }
        this.checkPositionNode(nodeSel,args);
        
        if(this.mS.currCellaInd>=0){
          
          this.detectCellaEndMove({
            offsetX:args.source.offsetX, offsetY:args.source.offsetY,
            width:args.source.width, height:args.source.height
          },nodeSel.addInfo.id);
         
        }
        
      }
      this.getTooltipNodes();
    }
    this.aggiustaOffsetCelle();
  }

  aggiustaOffsetCelle(){
    this.cC.elencoCelle.forEach((c:any,ind:number)=>{
      (this.diagram as Diagram).nodes.forEach((node:any,indCella:number)=>{
        if(node.addInfo.type=='cella' && node.addInfo.id==c.id){
          this.cC.elencoCelle[ind].offsetX=node.offsetX;
          this.cC.elencoCelle[ind].offsetY=node.offsetY;
        }
      });
    });
  }

  checkScaffaliUniti(isUnito:boolean){
    if(isUnito){
      return false;
    }
    let uniti=this.cC.elencoScaffali.filter((s:any)=>s.scaffaliUniti).length;
    if(uniti==this.cC.elencoScaffali.length-1){
      return true;
    }
    return false;
  }

  changeDistPorta(){
    let nodeSel= this.selectedItem.diagram.selectedItems.nodes[0];
    let distSnPorta=this.cC.elencoCelle[this.mS.cellaCollegataInd].elencoPorte[this.mS.currPortaInd].distSnPorta;
    let currDivisorio:any=null;
    this.cC.elencoCelle[nodeSel.addInfo.cellaCollegataInd].elencoPorte.forEach((cp:any,ind:number)=>{
      if(cp.id==nodeSel.addInfo.id && cp.divisorioCollegatoId && cp.divisorioCollegatoId!=''){
         currDivisorio=this.cC.elencoCelle[nodeSel.addInfo.cellaCollegataInd].divisori.filter((x:any)=>x.id==cp.divisorioCollegatoId)[0];
         (this.diagram as Diagram).nodes.forEach((node:any)=>{
            if(node.addInfo.divisorioCollegatoId==currDivisorio.id){
             if(currDivisorio.type=='divisoriovert'){
                 nodeSel.offsetY=node.offsetY+Math.round(node.height/2)-distSnPorta-Math.round(nodeSel.height/2);
             } else {
                 nodeSel.offsetX=node.offsetX-Math.round(node.width/2)+distSnPorta+Math.round(nodeSel.width/2);
            }
         
          }
        });
     
      }
    });
    if(!currDivisorio){
    
      (this.diagram as Diagram).nodes.forEach((node:any,indCella:number)=>{
        if(node.addInfo.type=='cella' && node.addInfo.id==nodeSel.addInfo.cellaCollegataId){
          if(nodeSel.addInfo.cellaCollegataLato=='lato_sn' || nodeSel.addInfo.cellaCollegataLato=='lato_ds' ){ 
            nodeSel.offsetY=node.offsetY+Math.round(node.height/2)-distSnPorta-Math.round(nodeSel.height/2);
          }
          if(nodeSel.addInfo.cellaCollegataLato=='lato_retro' || nodeSel.addInfo.cellaCollegataLato=='lato_fronte' ){
            nodeSel.offsetX=node.offsetX-Math.round(node.width/2)+distSnPorta+Math.round(nodeSel.width/2);
          }
        }
      });
    }
  }

  disabledMoveOrResize(){
    return this.mS.disabledMoveOrResize(this.cC,this.diagram.selectedItems.nodes[0]);
  }
   // PER UNIFORMITA CON IL CONFIGURATORE
  aggiustaLatoPorteEFB(lato:string){
    return lato;
    let latoCorretto='';
    if(lato=='lato_sn'){
        latoCorretto='lato_fronte';
    }
    if(lato=='lato_ds'){
        latoCorretto='lato_retro';
    }
    if(lato=='lato_retro'){
        latoCorretto='lato_sn';
    }
    if(lato=='lato_fronte'){
        latoCorretto='lato_ds';
    }
    return lato;
  }
  
 recalcDistPortaOptions(c:any,p:any){
  this.mS.distSnPortaOptions=[];
  let cd=0;
  if(p.lato_porta=='lato_fronte' || p.lato_porta=='lato_retro'){
    while(cd+p.larghporta<=c.ingombroX){
      this.mS.distSnPortaOptions.push(cd);
      cd+=20;
    }
  } else {
    while(cd+p.larghporta<=c.ingombroY){
      this.mS.distSnPortaOptions.push(cd);
      cd+=20;
    }
  }
  
 }

 recalcDistPortaOptionsForDivisorio(ingombro:number,p:any){
  this.mS.distSnPortaOptions=[];
  let cd=0;
  while(cd+p.larghporta<=ingombro){
    this.mS.distSnPortaOptions.push(cd);
    cd+=20;
  }
 }
   
 addPorta(cc:any,cellaDati:any,lato:string,prev:any,nodo:any=null,divisorio:any=null, distLato:any=null){
    // elimina la porta dall'elenco delle porte scollegate
    if(nodo){
      cc.elencoPorteScollegate.forEach((p:any,ind:number)=>{
        if(p.id==nodo.addInfo.id){
          cc.elencoPorteScollegate.splice(ind,1);
          this.mS.currPortaScollegataInd=-1;
        }
      });
    }
    let p:any=this.mS.initPorta();
    if(nodo){
     p.versoAperturaPorta=nodo.addInfo.apertura;
     switch(nodo.addInfo.title){
      case 'SC L':
      case 'SC R':
        p.tipologiaPorta='SCORREVOLI';
        p.scorrevole=true;
        p.configurata=true;
         break;
      case 'SC IND L':
      case 'SC IND R':
        p.tipologiaPorta='INDUSTRIALI SCORREVOLI';
        p.scorrevole=true;
        p.configurata=true;
       
        break;
      case 'IND L':
      case 'IND R':
        p.tipologiaPorta='INDUSTRIALI BATTENTE';
        p.configurata=true;
        break;
      case 'L':
      case 'R':
        p.tipologiaPorta='STANDARD';
         break;

     }
    }

    if(lato=='lato_retro'){
      let nump=cellaDati.elencoPorte.filter((x:any)=>x.lato_porta=='lato_retro').length+1;
      p.nomePorta=this.lang.el('Lato retro')+' '+nump;
      p.lato_porta='lato_retro';
    }
    if(lato=='lato_fronte'){
      let nump=cellaDati.elencoPorte.filter((x:any)=>x.lato_porta=='lato_fronte').length+1;
      p.nomePorta=this.lang.el('Lato fronte')+' '+nump;
      p.lato_porta='lato_fronte';
    }
    if(lato=='lato_ds'){
      let nump=cellaDati.elencoPorte.filter((x:any)=>x.lato_porta=='lato_ds').length+1;
      p.nomePorta=this.lang.el('Lato destro')+' '+nump;
      p.lato_porta='lato_ds';
    }
    if(lato=='lato_sn'){
      let nump=cellaDati.elencoPorte.filter((x:any)=>x.lato_porta=='lato_sn').length+1;
      p.nomePorta=this.lang.el('Lato sinistro')+' '+nump;
      p.lato_porta='lato_sn';
    }
  
    if(divisorio){
      p.portaDivisorio=true;
      p.divisorioCollegatoId=divisorio.divisorioCollegatoId;
    }
   
    cellaDati.elencoPorte.push(p);
    this.mS.onChangeSpessore(cellaDati,prev.lang);
    this.changeModPorta(null,cellaDati,cellaDati.elencoPorte[cellaDati.elencoPorte.length-1],'',distLato);
    cellaDati.elencoPorte.sort((a:any, b:any) => (a.lato_porta > b.lato_porta ? -1 : 1));
  
    if(lato=='lato_fronte'){
      cellaDati.lato_porta_lato_fronte=true;
    }
    if(lato=='lato_retro'){
      cellaDati.lato_porta_lato_retro=true;
   
    }
    if(lato=='lato_sn'){
      cellaDati.lato_porta_lato_sn=true;
    }
    
    if(lato=='lato_ds'){
      cellaDati.lato_porta_lato_ds=true;
    }

    return p.id;
  
  }

 checkPositionNode(nodeSel:any,args:any=null){
  // PORTA
    if(nodeSel.addInfo.type=='porta'){
       // è collegato ad un cella posso muoverlo solo sul lato
      if(nodeSel.addInfo.hasOwnProperty('cellaCollegataId')){
        // cerca se è porta di divisorio
        let currDivisorio:any=null;
        this.cC.elencoCelle[nodeSel.addInfo.cellaCollegataInd].elencoPorte.forEach((cp:any,ind:number)=>{
          if(cp.id==nodeSel.addInfo.id && cp.divisorioCollegatoId && cp.divisorioCollegatoId!=''){
            currDivisorio=this.cC.elencoCelle[nodeSel.addInfo.cellaCollegataInd].divisori.filter((x:any)=>x.id==cp.divisorioCollegatoId)[0];
          
            (this.diagram as Diagram).nodes.forEach((node:any)=>{
              if(node.addInfo.divisorioCollegatoId==currDivisorio.id){
                if(currDivisorio.type=='divisoriovert'){
                  let dist=node.offsetY+Math.round(node.height/2)-args.newValue.offsetY-Math.round(nodeSel.height/2);
                  this.cC.elencoCelle[nodeSel.addInfo.cellaCollegataInd].elencoPorte[ind].distSnPorta=dist;
                } else {
                  let dist=args.newValue.offsetX-Math.round(nodeSel.width/2)-(node.offsetX-Math.round(node.width/2));
                  this.cC.elencoCelle[nodeSel.addInfo.cellaCollegataInd].elencoPorte[ind].distSnPorta=dist;
                }
                this.recalcDistPortaOptionsForDivisorio(currDivisorio.w,this.cC.elencoCelle[nodeSel.addInfo.cellaCollegataInd].elencoPorte[ind]);
              }
            });
          }
        });

        if(!currDivisorio){
          (this.diagram as Diagram).nodes.forEach((node:any,indCella:number)=>{
            let portaC:any=null;
            if(node.addInfo.type=='cella' && node.addInfo.id==nodeSel.addInfo.cellaCollegataId){
              let distSnPorta=0;

              
              let portaIndustriale=false;
              this.cC.elencoCelle[nodeSel.addInfo.cellaCollegataInd].elencoPorte.forEach((cp:any,ind:number)=>{
                if(cp.id==nodeSel.addInfo.id){
                  portaC=cp;
                  if(this.cC.elencoCelle[nodeSel.addInfo.cellaCollegataInd].elencoPorte[ind].tipologiaPorta=='INDUSTRIALI BATTENTE'){
                    portaIndustriale=true;
                  }
                    if(this.cC.elencoCelle[nodeSel.addInfo.cellaCollegataInd].elencoPorte[ind].tipologiaPorta=='INDUSTRIALI SCORREVOLI'){
                    portaIndustriale=true;
                  }
                }
              });
              if(nodeSel.addInfo.cellaCollegataLato=='lato_sn' || nodeSel.addInfo.cellaCollegataLato=='lato_ds' ){ 
                distSnPorta=node.offsetY+Math.round(node.height/2)-nodeSel.offsetY-Math.round(nodeSel.height/2);


                if(portaIndustriale && (distSnPorta==0 || distSnPorta+(!portaC ? 0 : portaC.larghporta )>=node.height)){
                  nodeSel.offsetY=args.oldValue.offsetY;
                }
                if(!portaIndustriale &&  (distSnPorta==0 || distSnPorta+(!portaC ? 0 : portaC.larghporta )>node.height)){
                  nodeSel.offsetY=args.oldValue.offsetY;
                }

                if(args.newValue.offsetY-Math.round(nodeSel.height/2)<node.offsetY-Math.round(node.height/2)){
                  nodeSel.offsetY=args.oldValue.offsetY;
                }
                if(args.newValue.offsetY+Math.round(nodeSel.height/2)>node.offsetY+Math.round(node.height/2)){
                  nodeSel.offsetY=args.oldValue.offsetY;
                }

                nodeSel.offsetX=args.oldValue.offsetX;
                distSnPorta=node.offsetY+Math.round(node.height/2)-nodeSel.offsetY-Math.round(nodeSel.height/2);
              }
              if(nodeSel.addInfo.cellaCollegataLato=='lato_retro' || nodeSel.addInfo.cellaCollegataLato=='lato_fronte' ){
                   distSnPorta=nodeSel.offsetX-Math.round(nodeSel.width/2)-node.offsetX+Math.round(node.width/2);

                  if(portaIndustriale && (distSnPorta==0 || distSnPorta+(!portaC ? 0 : portaC.larghporta )>=node.width)){
                    nodeSel.offsetX=args.oldValue.offsetX;
                  }
                  if(!portaIndustriale &&  (distSnPorta==0 || distSnPorta+(!portaC ? 0 : portaC.larghporta )>node.width)){
                    nodeSel.offsetX=args.oldValue.offsetX;
                  }

                  if(args.newValue.offsetX-Math.round(nodeSel.width/2)<node.offsetX-Math.round(node.width/2)){
                    nodeSel.offsetX=args.oldValue.offsetX;
                  }
                  if(args.newValue.offsetX+Math.round(nodeSel.width/2)>node.offsetX+Math.round(node.width/2)){
                    nodeSel.offsetX=args.oldValue.offsetX;
                  }

                  if(this.mS.userCellePreConf()){
                    if(args.newValue.offsetX+Math.round(nodeSel.width/2)+40>node.offsetX+Math.round(node.width/2)){
                       if(args.newValue.offsetX+Math.round(nodeSel.width/2)!=node.offsetX+Math.round(node.width/2)){
                          nodeSel.offsetX=args.oldValue.offsetX;
                       }
                    }
                    if(args.newValue.offsetX-Math.round(nodeSel.width/2)<node.offsetX-Math.round(node.width/2)+40){
                       if(args.newValue.offsetX-Math.round(nodeSel.width/2)!=node.offsetX-Math.round(node.width/2)){
                          nodeSel.offsetX=args.oldValue.offsetX;
                        }
                    }
                  }
                  nodeSel.offsetY=args.oldValue.offsetY;
                  distSnPorta=nodeSel.offsetX-Math.round(nodeSel.width/2)-node.offsetX+Math.round(node.width/2);
              }
              this.cC.elencoCelle[nodeSel.addInfo.cellaCollegataInd].elencoPorte.forEach((cp:any,ind:number)=>{
                if(cp.id==nodeSel.addInfo.id){
                  this.cC.elencoCelle[nodeSel.addInfo.cellaCollegataInd].elencoPorte[ind].distSnPorta=Math.round(distSnPorta/20)*20;
                  this.recalcDistPortaOptions(this.cC.elencoCelle[nodeSel.addInfo.cellaCollegataInd],this.cC.elencoCelle[nodeSel.addInfo.cellaCollegataInd].elencoPorte[ind]);
                }
              });
            }
          });
        }

      } else {
        (this.diagram as Diagram).nodes.forEach((node:any)=>{
          if(node.addInfo.type=='cella' || node.addInfo.type=='divisorioorizz'  || node.addInfo.type=='divisoriovert' ){
            let position:any=this.isOncella(node,nodeSel);
            if(position){   
              if(!nodeSel.addInfo.hasOwnProperty('cellaCollegataInd') ||
                (nodeSel.addInfo.cellaCollegataInd!=node.addInfo.cellaIndex) 
              ) {
                
                let latoCorretto=this.aggiustaLatoPorteEFB(position.lato);
                let pId=0;
                if(node.addInfo.type=='divisorioorizz' || node.addInfo.type=='divisoriovert' ){
                  pId=this.addPorta(this.cC,this.cC.elencoCelle[node.addInfo.cellaIndex],latoCorretto,this.prev,nodeSel,node.addInfo,position.distLato);
                } else { 
                  if(this.mS.userCellePreConf()){
                    nodeSel.offsetX,node.offsetX=Math.round(node.offsetX-node.width/2+nodeSel.width/2);
                    position.distLato=0;
                  }
                    this.cC.elencoCelle[node.addInfo.cellaIndex].celleCollegate.forEach((c:any,ind:number)=>{
                    if(latoCorretto==c.latocollegato && !c.latocombinato){
                      // scambia
                      this.cC.elencoCelle[node.addInfo.cellaIndex].celleCollegate[ind].latocombinato=true;
                      this.cC.elencoCelle.forEach((c2:any,ind2:number)=>{
                        if(c2.id==c.cellaCollegataId){
                          this.cC.elencoCelle[ind2].celleCollegate.forEach((c4:any,ind4:number)=>{
                            if(c4.cellaCollegataId==this.cC.elencoCelle[node.addInfo.cellaIndex].id){
                              this.cC.elencoCelle[ind2].celleCollegate[ind4].latocombinato=false;
                            }
                          });
                        }
                      });
                    }
                  });
                  pId=this.addPorta(this.cC,this.cC.elencoCelle[node.addInfo.cellaIndex],latoCorretto,this.prev,nodeSel,null, position.distLato);
                  
                }
                this.mS.currPortaId='';
                this.cC.elencoCelle[node.addInfo.cellaIndex].elencoPorte.forEach((p:any,ind:number)=>{
                  if(p.id==pId){
                    this.mS.currPortaInd=ind;
                    if( position.distLato!=Math.round(position.distLato / 20) * 20){
                      if(latoCorretto=='lato_sn' || latoCorretto=='lato_ds'){
                        node.offsetY+=Math.round(position.distLato / 20) * 20-position.distLato;
                        position.distLato=Math.round(position.distLato / 20) * 20;
                      }
                    }
                    p.distSnPorta=position.distLato;
                    this.recalcDistPortaOptions(this.cC.elencoCelle[node.addInfo.cellaIndex],p);
                    p.versoAperturaPorta=nodeSel.addInfo.apertura;
                  }
                });
                
                nodeSel.constraints=NodeConstraints.Default & ~NodeConstraints.Resize;
                (this.diagram as DiagramComponent).rotate((this.diagram as DiagramComponent).selectedItems,position.gradi);
                nodeSel.constraints=NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize;
                nodeSel.addInfo.cellaCollegataInd=node.addInfo.cellaIndex;
                nodeSel.addInfo.cellaCollegataId=node.addInfo.id;
                nodeSel.addInfo.id=pId;
                nodeSel.addInfo.cellaCollegataLato=latoCorretto;
                
                nodeSel.addInfo.distSnPorta=position.distLato;
                let ind=this.cC.elencoCelle[node.addInfo.cellaIndex].elencoPorte.length-1;
                this.cC.elencoCelle[node.addInfo.cellaIndex].elencoPorte[ind].distSnPorta=nodeSel.addInfo.distSnPorta;
                this.recalcDistPortaOptions(this.cC.elencoCelle[node.addInfo.cellaIndex],this.cC.elencoCelle[node.addInfo.cellaIndex].elencoPorte[ind]);
                this.mS.cellaCollegataInd=nodeSel.addInfo.cellaCollegataInd;
           
           //     this.mS.changeModelloPorta(null,this.cC.elencoCelle[0],this.cC.elencoCelle[this.mS.cellaCollegataInd].elencoPorte[this.mS.currPortaInd])
                this.mS.currPortaId=nodeSel.addInfo.id; 
               }  
            }    
          }
        });
      }
      
    }
  // SCAFFALE
    if(nodeSel.addInfo.type=='scaffale'){
       // è collegato ad un cella posso muoverlo solo sul lato
      let isInside=false;
      (this.diagram as Diagram).nodes.forEach((node:any)=>{
        if(node.addInfo.type=='cella'){
          if(this.isInsCella(node,nodeSel)){    
            isInside=true;
            nodeSel.addInfo.cellaCollegataId=node.addInfo.id;
            nodeSel.addInfo.cellaCollegataOffsetX=nodeSel.offsetX-Math.round(nodeSel.width/2)-node.offsetX+Math.round(node.width/2);
            nodeSel.addInfo.cellaCollegataOffsetY=nodeSel.offsetY-Math.round(nodeSel.height/2)-node.offsetY+Math.round(node.height/2);
          }    
        }
      });
      if(!isInside){
          nodeSel.addInfo.cellaCollegataId=null;
          nodeSel.addInfo.cellaCollegataOffsetX=null;
          nodeSel.addInfo.cellaCollegataOffsetY=null;
      }
    }
  // FREEBLOCK
    if(nodeSel.addInfo.type=='freeblock'){
      // è collegato ad un cella posso muoverlo solo sul lato
      if(nodeSel.addInfo.hasOwnProperty('currFreeBlockCellaId')){
        (this.diagram as Diagram).nodes.forEach((node:any,indCella:number)=>{
          if(node.addInfo.type=='cella' && node.addInfo.id==nodeSel.addInfo.currFreeBlockCellaId){
            let distSnPorta=0;
            if(nodeSel.addInfo.currrFreeBlockCellaLato=='lato_sn' || nodeSel.addInfo.currrFreeBlockCellaLato=='lato_ds' ){
              if(args.newValue.offsetY-Math.round(nodeSel.height/2)<node.offsetY-Math.round(node.height/2)){
                nodeSel.offsetY=args.oldValue.offsetY;
              }
              if(args.newValue.offsetY+Math.round(nodeSel.height/2)>node.offsetY+Math.round(node.height/2)){
                nodeSel.offsetY=args.oldValue.offsetY;
              }
              nodeSel.offsetX=args.oldValue.offsetX;
              distSnPorta=node.offsetY+Math.round(node.height/2)-nodeSel.offsetY-Math.round(nodeSel.height/2);
            }
            if(nodeSel.addInfo.currrFreeBlockCellaLato=='lato_retro' || nodeSel.addInfo.currrFreeBlockCellaLato=='lato_fronte' ){
              if(args.newValue.offsetX-Math.round(nodeSel.width/2)<node.offsetX-Math.round(node.width/2)){
                nodeSel.offsetX=args.oldValue.offsetX;
              }
              if(args.newValue.offsetX+Math.round(nodeSel.width/2)>node.offsetX+Math.round(node.width/2)){
                nodeSel.offsetX=args.oldValue.offsetX;
              }
              nodeSel.offsetY=args.oldValue.offsetY;
              distSnPorta=nodeSel.offsetX-Math.round(nodeSel.width/2)-node.offsetX+Math.round(node.width/2);
        
            }
            this.cC.elencoFreeBlocks[nodeSel.addInfo.freeBlockInd].distLato=Math.round(distSnPorta/20)*20;

          }
        });

      } else {
        (this.diagram as Diagram).nodes.forEach((node:any,indCella:number)=>{
            if(node.addInfo.type=='cella'){
              let position:any=this.isOncella(node,nodeSel);
              if(position){   
                if( !nodeSel.addInfo.hasOwnProperty('currFreeBlockCellaId')) {
                  // PER UNIFORMITA CON IL CONFIGURATORE 
                  let latoCorretto=this.aggiustaLatoPorteEFB(position.lato);
               //   let fb=this.mS.initFB(6,nodeSel.properties.addInfo.dimensione,nodeSel.properties.addInfo.width,nodeSel.properties.addInfo.height,position.distLato,latoCorretto,
               // node.addInfo.id);
              //    this.cC.elencoFreeBlocks.push(fb);
              //    nodeSel.addInfo.freeBlockInd=this.cC.elencoFreeBlocks.length-1;
                  nodeSel.constraints=NodeConstraints.Default & ~NodeConstraints.ResizeNorth & ~NodeConstraints.ResizeSouth;
                  (this.diagram as DiagramComponent).rotate((this.diagram as DiagramComponent).selectedItems,position.gradi);
                  nodeSel.constraints=NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.ResizeNorth & ~NodeConstraints.ResizeSouth;      
                  nodeSel.addInfo.currFreeBlockCellaId=node.addInfo.id;
                  nodeSel.addInfo.currrFreeBlockCellaLato=position.lato;
                  nodeSel.addInfo.currrFreeBlockCellaDistLato=position.distLato;
                  this.cC.elencoFreeBlocks[nodeSel.addInfo.freeBlockInd].lato=latoCorretto;
                  this.cC.elencoFreeBlocks[nodeSel.addInfo.freeBlockInd].distLato=position.distLato;
                  this.cC.elencoFreeBlocks[nodeSel.addInfo.freeBlockInd].cellaId=nodeSel.addInfo.currFreeBlockCellaId;
                  
                  
                  
                }
              }    
            }
          });
      }
      
 
    }
    return true;
  }
  
  
  public dragEnter(args: IDragEnterEventArgs): void {
  
    
  
    let obj: any = args.element as NodeModel;
    obj.width = obj.properties.addInfo.nodeWidth;
    obj.height = obj.properties.addInfo.nodeHeight;
    
    return;
        // se tipo cella inserisce un nuova cella
        if (obj.properties.addInfo && obj.properties.addInfo.type=='cella'){
           let c=this.mS.initCella(this.opzioniList,this.prev.lang,this.cC.electrolux);
          this.mS.changeDescTecnica(c,this.prev.lang);
          this.cC.elencoCelle.push(c);
          obj.properties.addInfo.indiceCella=this.cC.elencoCelle.length-1;
        }
        obj.shape.content='<div style="width:90px;height:90px;border:2px solid black;"></div>';
   
        if (obj.properties.addInfo && obj.properties.addInfo.nodeWidth) {
            obj.width = obj.nodeWidth;
        //    this.cC.elencoCelle[obj.properties.addInfo.indiceCella].ingombroX=obj.nodeWidth;
        } else {
          obj.width=this.cC.elencoCelle[obj.properties.addInfo.indiceCella].ingombroX;
        }
        if (obj.properties.addInfo && obj.properties.addInfo.nodeHeight) {
            obj.height = obj.nodeHeight;
         //       this.cC.elencoCelle[obj.properties.addInfo.indiceCella].ingombroY=obj.nodeHeight;
        } else {
            obj.height=this.cC.elencoCelle[obj.properties.addInfo.indiceCella].ingombroY;
        }
      
  }

   //Sets the description of a symbol
  getSymbolInfo(symbol: Node | Connector): SymbolInfo {
    return {
      fit:true,
      width: 50,
      height: 50,
      description: {
        //Defines the description text for the symbol
        text: (symbol as any).addInfo.title,
        fontSize: 8,

      },
    };
  }
     //Sets the description of a symbol
  getSymbolInfoMC(symbol: Node | Connector): SymbolInfo {
    return {
      fit:true,
      width: 30,
      height: 20,
    };
  }

  
  apriOpzioni(cellaDati:any,ind:number){
    this.messageEvent.emit({what:'apriOpzioni',cellaDati:cellaDati,ind:ind});
  }

  oneSelected(){
      if(this.selectedItem && this.selectedItem.diagram && this.selectedItem.diagram.selectedItems  
        && this.selectedItem.diagram.selectedItems.nodes 
        && this.selectedItem.diagram.selectedItems.nodes.length>0
        && ( this.mS.currPannelloInd>=0 
            ||  this.mS.currAngolareCellaInd>=0 
            ||  this.mS.currFreeBlockInd>=0 
            ||  this.mS.currImpiantoInd>=0 
            ||  this.mS.currScaffaleInd>=0 
            ||  this.mS.currDropinInd>=0 
            ||  this.mS.currCellaInd>=0 
            ||  this.mS.currPortaScollegataInd>=0 
            ||  this.mS.currPortaInd>=0  )){
        return true;
      } else {
        return false;
      }  

  }

  changeScaffaliCellePreConf(cella:any){

    cella.scaffaliCellePreconfTipoOptions=[];
    let items:any=[];
    this.mS.scaffaliPreCof_L.forEach((s:any)=>{
      if(cella.ingombroX==s.latoCellaA){
        items.push({
          value:s.codice,
          label:s.ripiani+' '+this.lang.el('ripiani')+' '+s.prof+' '+this.lang.el('profondita')+' '+this.lang.el('In linea')
        });
      }
    });
    if(items.length>0){
      cella.scaffaliCellePreconfTipoOptions.push(
        {
          label:this.lang.el('In linea'),
          value:'inlinea',
          items:items,
        }
      ); 
    }
    
    let itemsU:any=[];
    let itemsLU:any=[];
    this.mS.scaffaliPreCof_LU.forEach((s:any)=>{
      if(cella.ingombroX==s.latoCellaA && cella.ingombroY==s.latoCellaB ){
        if(s.tipo=='L'){
          itemsLU.push({
            value:s.codice,
             label:s.ripiani+' '+this.lang.el('ripiani')+' '+this.lang.el('a L')
          });
        }
       if(s.tipo=='U'){
          itemsU.push({
            value:s.codice,
             label:s.ripiani+' '+this.lang.el('ripiani')+' '+this.lang.el('a U')
          });
        }
     
      }
    });
    if(itemsLU.length>0){
      cella.scaffaliCellePreconfTipoOptions.push(
        {
          label:this.lang.el('a L'),
          value:'aL',
          items:itemsLU,
        }
      ); 
    }
    if(itemsU.length>0){
      cella.scaffaliCellePreconfTipoOptions.push(
        {
          label:this.lang.el('a U'),
          value:'aU',
          items:itemsU,
        }
      ); 
    }
    
  }

  setScaffaliCellePreConf(cella:any){
  
 
   let cellaNode:any={};
   let nodetoRemove:any=[];
    (this.diagram as Diagram).nodes.forEach((node:any)=>{
        if(node.addInfo.type=='scaffale'){
          nodetoRemove.push(node);
         
        }
        if(node.addInfo.type=='cella'){
          cellaNode=node;
        }
        
    });
    nodetoRemove.forEach((node:any)=>{
      (this.diagram as Diagram).remove(node);
      this.diagram.dataBind();
    })
    
   
    this.cC.elencoScaffali=[];
   
    let scaff:any={};
    let scaffNode:any ={};
    let confL=this.mS.scaffaliPreCof_L.filter((s:any)=> s.codice==cella.scaffaliCellePreconfCodice);
    if(confL.length>0){
      scaff=confL[0];
      let sc=this.mS.initScaffale(scaff.latoCellaA);
      this.cC.elencoScaffali.push(sc);
      if(scaff.prof==37){
        scaffNode = (JSON.parse(JSON.stringify(this.mS.nodeScaffale37130)));
      }
      else {
         scaffNode = (JSON.parse(JSON.stringify(this.mS.nodeScaffale4765)));
      }
      scaffNode.id='n'+uuid.v4();
      scaffNode.shape.content=this.mS.scaffaleContent;
      scaffNode.width=scaff.ingombrototale;
      scaffNode.height=scaff.prof;
      scaffNode.constraints= ~NodeConstraints.Select;
      scaffNode.offsetX=Math.round(cellaNode.offsetX-cellaNode.width/2+scaffNode.width/2);
      scaffNode.offsetY=Math.round(cellaNode.offsetY-cellaNode.height/2+scaffNode.height/2);
      scaffNode.addInfo.id=sc.id;
      scaffNode.addInfo.type='scaffale';
      this.diagram.add(scaffNode);
      this.addToLayer(scaffNode);
      this.diagram.dataBind();
     
    } else {
      let confLU=this.mS.scaffaliPreCof_LU.filter((s:any)=> s.codice==cella.scaffaliCellePreconfCodice);
      scaff=confLU[0];
      
      let sc=this.mS.initScaffale(scaff.latoCellaA);
      this.cC.elencoScaffali.push(sc);
      if(scaff.prof==37){
        scaffNode = (JSON.parse(JSON.stringify(this.mS.nodeScaffale37130)));
      }
      else {
         scaffNode = (JSON.parse(JSON.stringify(this.mS.nodeScaffale4765)));
      }
      scaffNode.id='n'+uuid.v4();
      scaffNode.shape.content=this.mS.scaffaleContent;
      scaffNode.width=scaff.latoCellaA;
      scaffNode.height=37;
      scaffNode.constraints= ~NodeConstraints.Select;
      scaffNode.offsetX=Math.round(cellaNode.offsetX-cellaNode.width/2+scaffNode.width/2);
      scaffNode.offsetY=Math.round(cellaNode.offsetY-cellaNode.height/2+scaffNode.height/2);
      scaffNode.addInfo.id=sc.id;
      scaffNode.addInfo.type='scaffale';
      this.diagram.add(scaffNode);
      this.diagram.dataBind();
      this.addToLayer(scaffNode);
      let sc2=this.mS.initScaffale(scaff.latoCellaB);
      this.cC.elencoScaffali.push(sc2);
      scaffNode = (JSON.parse(JSON.stringify(this.mS.nodeScaffale37130R)));
      scaffNode.id='n'+uuid.v4();
      scaffNode.shape.content=this.mS.scaffaleContent;
      scaffNode.height=scaff.latoCellaB;
      scaffNode.width=37;
      scaffNode.constraints= ~NodeConstraints.Select;
      scaffNode.offsetX=Math.round(cellaNode.offsetX-cellaNode.width/2+scaffNode.width/2);
      scaffNode.offsetY=Math.round(cellaNode.offsetY-cellaNode.height/2+scaffNode.height/2);
      scaffNode.addInfo.id=sc2.id;
      scaffNode.addInfo.type='scaffale';
      this.diagram.add(scaffNode);
       this.addToLayer(scaffNode);
      this.diagram.dataBind();
      if(scaff.tipo=='U'){
        let sc3=this.mS.initScaffale(scaff.latoCellaB);
        this.cC.elencoScaffali.push(sc3);
        let scaffNodeD = (JSON.parse(JSON.stringify(this.mS.nodeScaffale37130R)));
        scaffNodeD.id='n'+uuid.v4();
        scaffNodeD.shape.content=this.mS.scaffaleContent;
        scaffNodeD.height=scaff.latoCellaB;
        scaffNodeD.width=37;
        scaffNodeD.constraints= ~NodeConstraints.Select;
        scaffNodeD.offsetX=Math.round(cellaNode.offsetX+cellaNode.width/2-scaffNodeD.width/2);
        scaffNodeD.offsetY=Math.round(cellaNode.offsetY-cellaNode.height/2+scaffNodeD.height/2);
        scaffNodeD.addInfo.id=sc3.id;
        scaffNodeD.addInfo.type='scaffale';
        this.diagram.add(scaffNodeD); 
         this.addToLayer(scaffNode);
        this.diagram.dataBind();

        
      }
    }
   

  }


  changeVersoApe(porta:any){
    (this.diagram as Diagram).nodes.forEach((node:any)=>{
      if(node.addInfo.id==porta.id){
        switch (node.addInfo.title){
          case 'L':
            node.addInfo.apertura=1;
            node.addInfo.title='R';
            node.shape=this.mS.nodePortaDS.shape;
            break;
          case 'R': 
            node.addInfo.apertura= 2;
            node.addInfo.title='L';
            node.shape=this.mS.nodePortaSN.shape;
            break;
          case 'IND L':
            node.addInfo.apertura= 1;
            node.addInfo.title='IND R';
            node.shape=this.mS.nodePortaDSInd.shape;
            break;
          case 'IND R': 
            node.addInfo.apertura= 2;
            node.addInfo.title='IND L';
            node.shape=this.mS.nodePortaSNInd.shape;
            break;
          case 'SC IND L':
            node.addInfo.apertura=1;
            node.addInfo.title='SC IND R';
            node.shape=this.mS.nodePortaScorrIndSN.shape;
            break;
          case 'SC IND R': 
            node.addInfo.apertura= 2;
            node.addInfo.title='SC IND L';
            node.shape=this.mS.nodePortaScorrIndDs.shape;
            break;
          case 'SC L':
            node.addInfo.apertura= 1;
            node.addInfo.title='SC R';
            node.shape=this.mS.nodePortaScorrSn.shape;
            break;
          case 'SC R': 
            node.addInfo.apertura= 2;
            node.addInfo.title='SC L';
            node.shape=this.mS.nodePortaScorrDs.shape;
            break;
        }
          
    
      }
    });
    this.diagram.dataBind();
  }

  public getLatoCollegato2(n1:any,n2:any){

       if(Math.round(n1.offsetY+n1.height/2)==Math.round(n2.offsetY-n2.height/2)
        &&  
        (  (Math.round(n1.offsetX-n1.width/2)>= Math.round(n2.offsetX-n2.width/2)) && (Math.round(n1.offsetX+n1.width/2)<= Math.round(n2.offsetX+n2.width/2))
        || (Math.round(n2.offsetX-n2.width/2)>= Math.round(n1.offsetX-n1.width/2)) && (Math.round(n2.offsetX+n2.width/2)<= Math.round(n1.offsetX+n1.width/2))
        ))
      {
        return 'lato_fronte';
      }
      if(Math.round(n1.offsetY-n1.height/2)==Math.round(n2.offsetY+n2.height/2)
        &&  
        (  (Math.round(n1.offsetX-n1.width/2)>= Math.round(n2.offsetX-n2.width/2)) && (Math.round(n1.offsetX+n1.width/2)<= Math.round(n2.offsetX+n2.width/2))
        || (Math.round(n2.offsetX-n2.width/2)>= Math.round(n1.offsetX-n1.width/2)) && (Math.round(n2.offsetX+n2.width/2)<= Math.round(n1.offsetX+n1.width/2))
        ))
      {
        return 'lato_retro';
      }

      if(Math.round(n1.offsetX-n1.width/2)==Math.round(n2.offsetX+n2.width/2)
        &&  
        (  (Math.round(n1.offsetY-n1.height/2)>= Math.round(n2.offsetY-n2.height/2)) && (Math.round(n1.offsetY+n1.height/2)<= Math.round(n2.offsetY+n2.height/2))
        || (Math.round(n2.offsetY-n2.height/2)>= Math.round(n1.offsetY-n1.height/2)) && (Math.round(n2.offsetY+n2.height/2)<= Math.round(n1.offsetY+n1.height/2))
        ))
      {
         return 'lato_sn';
      }
      if(Math.round(n1.offsetX+n1.width/2)==Math.round(n2.offsetX-n2.width/2)
        &&  
        (  (Math.round(n1.offsetY-n1.height/2)>= Math.round(n2.offsetY-n2.height/2)) && (Math.round(n1.offsetY+n1.height/2)<= Math.round(n2.offsetY+n2.height/2))
        || (Math.round(n2.offsetY-n2.height/2)>= Math.round(n1.offsetY-n1.height/2)) && (Math.round(n2.offsetY+n2.height/2)<= Math.round(n1.offsetY+n1.height/2))
        ))
      {
        return 'lato_ds';
      }  
      return null;
  }

  public getLatoCollegato(n1:any,n2:any,isCombinate=false){
  
    if(isCombinate){
      let cella=(n2.addInfo.type=='cella' ) ? n2:n1;
      let comb=(n2.addInfo.type=='cella' ) ? n1:n2;
      
      if(comb.addInfo.subtype=='cellacombinatatop'){
        if(Math.round(cella.offsetY+cella.height/2)==Math.round(comb.offsetY-comb.height/2) 
          && Math.round(comb.offsetX-comb.width/2)>= Math.round(cella.offsetX-cella.width/2)
          && Math.round(comb.offsetX+comb.width/2)<= Math.round(cella.offsetX+cella.width/2)){
          return 'lato_fronte'; 
        } else {
          return null;
        }
      }
     if(comb.addInfo.subtype=='cellacombinatabottom'){
        if(Math.round(cella.offsetY-cella.height/2)==Math.round(comb.offsetY+comb.height/2) 
          && Math.round(comb.offsetX-comb.width/2)>= Math.round(cella.offsetX-cella.width/2)
          && Math.round(comb.offsetX+comb.width/2)<= Math.round(cella.offsetX+cella.width/2)){
          return 'lato_retro'; 
        } else {
          return null;
        }
      }
      if(comb.addInfo.subtype=='cellacombinataleft'){
      

        if(Math.round(cella.offsetX+cella.width/2)==Math.round(comb.offsetX-comb.width/2) 
          && Math.round(comb.offsetY-comb.height/2)>= Math.round(cella.offsetY-cella.height/2)
          && Math.round(comb.offsetY+comb.height/2)<= Math.round(cella.offsetY+cella.height/2)){
          return 'lato_ds'; 
        } else {
          return null;
        }
      }
      if(comb.addInfo.subtype=='cellacombinataright'){
          
        if(Math.round(cella.offsetX-cella.width/2)==Math.round(comb.offsetX+comb.width/2) 
          && Math.round(comb.offsetY-comb.height/2)>= Math.round(cella.offsetY-cella.height/2)
          && Math.round(comb.offsetY+comb.height/2)<= Math.round(cella.offsetY+cella.height/2)){
          return 'lato_sn'; 
        } else {
          return null;
        }
      }
    } else {
      if(Math.round(n1.offsetY)==Math.round(n2.offsetY) && Math.round(n1.offsetX-n1.width/2)==Math.round(n2.offsetX+n2.width/2) ){
        if(Math.round(n1.height)==Math.round(n2.height) ){
          return 'lato_sn'; 
        } else {
          return null;
        }
      }
      if(Math.round(n1.offsetY)==Math.round(n2.offsetY) && Math.round(n1.offsetX+n1.width/2)==Math.round(n2.offsetX-n2.width/2) ){
        if(Math.round(n1.height)==Math.round(n2.height) ){
          return 'lato_ds'; 
        } else {
          return null;
        }
      }
      if(Math.round(n1.offsetX)==Math.round(n2.offsetX) && Math.round(n1.offsetY+n1.height/2)==Math.round(n2.offsetY-n2.height/2) ){
        if(Math.round(n1.width)==Math.round(n2.width) ){
          return 'lato_fronte'; 
        } else {
          return null;
        }
      }
      if(Math.round(n1.offsetX)==Math.round(n2.offsetX) && Math.round(n1.offsetY-n1.height/2)==Math.round(n2.offsetY+n2.height/2) ){
        if(Math.round(n1.width)==Math.round(n2.width) ){
          return 'lato_retro'; 
        } else {
          return null;
        }
      }
    }
   
    return null;
  }

  ptIsInsideNode(x:number,y:number,n1:any){
    if(x>=Math.round(n1.offsetX-n1.width/2) && x<= Math.round(n1.offsetX+n1.width/2)){
      if(y>=Math.round(n1.offsetY-n1.height/2) && y<= Math.round(n1.offsetY+n1.height/2)){
        return true;
      }
    }
    return false;
  }

  paletteSelectionChange(args: IPaletteSelectionChangeArgs) {
      (this.diagram as Diagram).clearSelection();
      (this.diagram as Diagram).refresh();
  }
  paletteExpanding(args: IPaletteExpandArgs) {
     (this.diagram as Diagram).clearSelection();
   //  (this.diagram as Diagram).refresh();
  }
    
  public selectionChange(args: ISelectionChangeEventArgs): void {
    const comb=['cellacombinatatop','cellacombinataleft','cellacombinatabottom','cellacombinataright'];

    if(args.state!='Changed'){
      return;
    }

    
    this.mS.currCellaInd=-1;
    this.mS.cellaCollegataInd=-1;
    this.mS.currPortaId='';
    this.mS.currPortaInd=-1;
    this.mS.currPortaScollegataInd=-1;
    this.mS.currCellaSucc=-1;
    this.mS.currLatoDivisorio='';

    this.mS.currFreeBlockInd=-1;
    this.mS.currrFreeBlockCellaLato='';
    this.mS.currDropinInd=-1;

    this.mS.currPannelloInd=-1;
    this.mS.currPannelloCellaInd=-1;
    this.mS.currPannelloCellaLato='';
    this.mS.currScaffaleInd=-1;
    this.mS.currScaffaleCellaInd=-1;
    this.mS.portaDivisorio=false;
    this.mS.cellaCombinataInd=-1;
    this.mS.cellaCombinataLatoCollegato='';
    this.mS.cellaCombinataDiverseMisure=false;
    this.mS.cellaCombinataInd=-1;
    this.mS.currImpiantoInd=-1;
    this.mS.currimpiantiRemotiTipo='';
    this.mS.currCollegamento=null;

    if(this.selectedItem && this.selectedItem.diagram && this.selectedItem.diagram.selectedItems  
      && this.selectedItem.diagram.selectedItems.nodes  ){

      // DUE CeLLE 
      if(this.selectedItem.diagram.selectedItems.nodes.length==2){
        let no=this.selectedItem.diagram.selectedItems.nodes[0];
        let nv=this.selectedItem.diagram.selectedItems.nodes[1];
          
        
        if(no.addInfo.type=='scaffale' && nv.addInfo.type=='scaffale'  ){
          if(no.addInfo.title.indexOf('R')>=0 && nv.addInfo.title.indexOf('R')>=0){
            return;
          }
          if(no.addInfo.title.indexOf('R')<0 && nv.addInfo.title.indexOf('R')<0){
            return;
          }
          if(no.addInfo.title.indexOf('R')>=0){
            no=this.selectedItem.diagram.selectedItems.nodes[1];
            nv=this.selectedItem.diagram.selectedItems.nodes[0];
          }
          let dist_v_des_o_des=Math.round(nv.offsetX+nv.width/2)-Math.round(no.offsetX+no.width/2);
          let dist_v_sin_o_sin=Math.round(nv.offsetX-nv.width/2)-Math.round(no.offsetX-no.width/2);
          let dist_v_des_o_sin=Math.round(nv.offsetX+nv.width/2)-Math.round(no.offsetX-no.width/2);
          let dist_v_sin_o_des=Math.round(nv.offsetX-nv.width/2)-Math.round(no.offsetX+no.width/2);
          let dist_v_top_o_top=10+Math.round(nv.offsetY-nv.height/2)-Math.round(no.offsetY-no.height/2);
          let dist_v_top_o_bott=10+Math.round(nv.offsetY-nv.height/2)-Math.round(no.offsetY+no.height/2);
          let dist_v_bott_o_bott=10+Math.round(nv.offsetY+nv.height/2)-Math.round(no.offsetY+no.height/2);
          let dist_v_bott_o_top=10+Math.round(nv.offsetY+nv.height/2)-Math.round(no.offsetY-no.height/2);
          // in alto 
          if(dist_v_des_o_sin>=0 && dist_v_sin_o_des<=0 && dist_v_top_o_top>=0 && dist_v_top_o_bott<=0){
            if(dist_v_des_o_des>=0 || dist_v_sin_o_sin<=0){
              nv.offsetY=Math.round(no.offsetY-no.height/2+nv.height/2);
              if(dist_v_des_o_sin<-1*dist_v_sin_o_des){
                nv.offsetX=Math.round(no.offsetX-no.width/2-nv.width/2); 
              } else {
                nv.offsetX=Math.round(no.offsetX+no.width/2+nv.width/2); 
              }
            } else {
              nv.offsetY=Math.round(no.offsetY+no.height/2+nv.height/2);
              if(dist_v_des_o_sin<-1*dist_v_sin_o_des){
                nv.offsetX=Math.round(no.offsetX-no.width/2+nv.width/2); 
              } else {
                nv.offsetX=Math.round(no.offsetX+no.width/2-nv.width/2); 
              } 
            }
        
   
          }
          // in basso 
          if(dist_v_des_o_sin>=0 && dist_v_sin_o_des<=0 && dist_v_bott_o_bott<=0 && dist_v_bott_o_top>=0){
            if(dist_v_des_o_des>=0 || dist_v_sin_o_sin<=0){
              nv.offsetY=Math.round(no.offsetY+ no.height/2-nv.height/2);
              if(dist_v_des_o_sin<-1*dist_v_sin_o_des){
                nv.offsetX=Math.round(no.offsetX-no.width/2-nv.width/2); 
              } else {
                nv.offsetX=Math.round(no.offsetX+no.width/2+nv.width/2); 
              }
            } else {
              nv.offsetY=Math.round(no.offsetY-no.height/2-nv.height/2);
              if(dist_v_des_o_sin<-1*dist_v_sin_o_des){
                 nv.offsetX=Math.round(no.offsetX-no.width/2+nv.width/2); 
              } else {
                nv.offsetX=Math.round(no.offsetX+no.width/2-nv.width/2); 
              } 
            }
          }
         
       
        }

        if( no.addInfo && no.addInfo.type && no.addInfo.type=='cella' && nv.addInfo && nv.addInfo.type && nv.addInfo.type=='cella'){
          if(no.offsetX<nv.offsetX){
            no=this.selectedItem.diagram.selectedItems.nodes[1];
            nv=this.selectedItem.diagram.selectedItems.nodes[0];
          
          }
          let collegamento=false;
          let latocollegato=this.getLatoCollegato2(no,nv);
       
          if(!latocollegato) {
           latocollegato=this.getLatoCollegato2(nv,no);
          }
          if(!latocollegato) {
            return;
          }
          
        
          let checkSpessore13=true;
          this.cC.elencoCelle.forEach((c:any)=>{
              if(c.id==no.addInfo.id && c.spessore==13){
                if(latocollegato=='lato_retro' || latocollegato=='lato_fronte' ){
                  if(no.width!=nv.width){
                    checkSpessore13=false;
                  }
                }
                if(latocollegato=='lato_sn' || latocollegato=='lato_ds' ){
                  if(no.height!=nv.height){
                    checkSpessore13=false;
                  }
                }
              }
              if(c.id==nv.addInfo.id && c.spessore==13){
                if(latocollegato=='lato_retro' || latocollegato=='lato_fronte' ){
                  if(nv.width!=nv.width){
                    checkSpessore13=false;
                  }
                }
                if(latocollegato=='lato_sn' || latocollegato=='lato_ds' ){
                  if(nv.height!=nv.height){
                    checkSpessore13=false;
                  }
                }
              }
          });
          if(!checkSpessore13) {
            return;
          }
          this.cC.elencoCelle.forEach((c:any)=>{
              if(c.id==no.addInfo.id){
                c.celleCollegate.forEach((ccol:any)=>{
                  if(ccol.cellaCollegataId==nv.addInfo.id){
                    collegamento=true;
                  }
                })
              }
          });
          if(!collegamento){
            this.mS.currCellaInd=no.addInfo.cellaIndex;
            this.mS.cellaCollegataInd=nv.addInfo.cellaIndex;
            this.addRemoveCollegamentoCelle(latocollegato,this.cC.elencoCelle[this.mS.currCellaInd],this.cC.elencoCelle[this.mS.cellaCollegataInd],true);
            this.addRemoveCollegamentoCelle(latocollegato,this.cC.elencoCelle[this.mS.cellaCollegataInd],this.cC.elencoCelle[this.mS.currCellaInd],true);
          } 
          this.mS.currCellaInd=no.addInfo.cellaIndex;
          this.mS.cellaCollegataInd=nv.addInfo.cellaIndex;
          this.mS.currCollegamento=this.cC.elencoCelle[this.mS.currCellaInd].celleCollegate.filter((x:any)=> x.cellaCollegataId==this.cC.elencoCelle[this.mS.cellaCollegataInd].id)[0];
          // sync solo se già attivo: se attivo=false non chiamare collegaCelle
          // (cancellerebbe i link appena creati / quelli inattivi in attesa del check)
          if (this.mS.currCollegamento?.attivo) {
            this.collegaCelle(
              this.cC.elencoCelle[this.mS.currCellaInd],
              this.cC.elencoCelle[this.mS.cellaCollegataInd],
            );
          }
          
        }
        
      }
      
     
      if(this.selectedItem.diagram.selectedItems.nodes.length==1){
      
       let n=this.selectedItem.diagram.selectedItems.nodes[0];
       if(n.addInfo && n.addInfo.type){
        if(n.addInfo.type=='cella'){
          this.mS.onChangeSpessore(this.mS.cellaDati,this.mS.lang);
          this.mS.currCellaInd=n.addInfo.cellaIndex;
          this.bringCellaSopraAltreCelle(n);
          if(this.mS.userCellePreConf() && this.cC.elencoCelle[this.mS.currCellaInd].scaffaliCellePreconf){
            this.changeScaffaliCellePreConf(this.cC.elencoCelle[this.mS.currCellaInd]);
            this.setScaffaliCellePreConf(this.cC.elencoCelle[this.mS.currCellaInd]);
          }
          
        }
      
        if(n.addInfo.type=='pareti' && !this.mS.userCellePreConf()){
          let currCella=this.cC.elencoCelle[n.addInfo.cellaCollegataInd];
          if(currCella.pannellicustom && currCella.pannellicustom.length>0){
            if(currCella.pannellicustom[n.addInfo.cellaCollegataLato][n.addInfo.currPannelloInd]){
                  this.mS.currPannelloInd=n.addInfo.currPannelloInd;
                  this.mS.currPannelloCellaInd=n.addInfo.cellaCollegataInd;
                  this.mS.currPannelloCellaLato=n.addInfo.cellaCollegataLato;
            } else {
              let pc=this.mS.initPannelloCustom(n.addInfo.currPannelloInd,currCella.spessore,currCella.finitura);
              currCella.pannellicustom[n.addInfo.cellaCollegataLato][n.addInfo.currPannelloInd]=pc;
              this.mS.currPannelloInd=n.addInfo.currPannelloInd;
              this.mS.currPannelloCellaInd=n.addInfo.cellaCollegataInd;
              this.mS.currPannelloCellaLato=n.addInfo.cellaCollegataLato;  
            }
          }
          
        }

        if(n.addInfo.type=='angolare'){
          this.mS.currAngolareAngolo=n.addInfo.currAngolareCellaLato;
          this.mS.currAngolareCellaInd=n.addInfo.cellaCollegataInd;
        }
        
      
        if(n.addInfo.type=='scaffale'){
          //   this.mS.currScaffaleInd=n.addInfo.currScaffaleInd;
             this.cC.elencoScaffali.forEach((scaffale:any,ind:number)=>{
               if(scaffale.id==n.addInfo.id){
                 this.mS.currScaffaleInd=ind;
               }
             });
             if(this.mS.currScaffaleInd==-1){
              this.mS.currScaffaleInd=0; 
             }
             this.mS.currScaffaleCellaInd=n.addInfo.currScaffaleCellaInd;
         }
        
        if(n.addInfo.type=='freeblock'){
          if(n.addInfo.hasOwnProperty('freeBlockInd') ){
           
            this.cC.elencoFreeBlocks.forEach((freeBlock:any,ind:number)=>{
              if(freeBlock.id==n.addInfo.id){
                this.mS.currFreeBlockInd=ind;
              }
            });
            if(this.mS.currFreeBlockInd==-1){
             this.mS.currFreeBlockInd=0; 
            }
            this.mS.currrFreeBlockCellaLato=n.addInfo.cellaCollegataLato;
          }
      
        }
        if(n.addInfo.type=='impiantoRemoto'){
      
          if(n.addInfo.hasOwnProperty('impiantoRemotoInd') ){       
            this.mS.currImpiantoInd=n.addInfo.impiantoRemotoInd;
            this.mS.currimpiantiRemotiTipo=n.addInfo.title;
            this.mS.loadcurrImpiantoRemotoOptionms(this.mS.currimpiantiRemotiTipo,this.cC);
          }
        }
 
        if(n.addInfo.type=='dropin'){
          this.mS.currDropinInd=n.addInfo.dropinInd;
        }

        if(n.addInfo.type=='porta'){
      
          if(n.addInfo.cellaCollegataInd>=0 && this.cC.elencoCelle 
            && this.cC.elencoCelle[n.addInfo.cellaCollegataInd]){
              // porte normali
            if(!n.addInfo.portaDivisorio && this.cC.elencoCelle[n.addInfo.cellaCollegataInd].elencoPorte 
              && n.addInfo.id && n.addInfo.id!=''){
              this.cC.elencoCelle[n.addInfo.cellaCollegataInd].elencoPorte.forEach((x:any,ind:number)=>{
                if(x.id==n.addInfo.id){
                  this.mS.cellaCollegataInd=n.addInfo.cellaCollegataInd;
                  this.mS.currPortaId=n.addInfo.id;
                  this.mS.currPortaInd=ind;
                }
              });
            }
              // porte divisorio
            if(n.addInfo.portaDivisorio){
              this.mS.portaDivisorio=true;
            
              this.cC.elencoCelle[n.addInfo.cellaCollegataInd].divisori.forEach((x:any,ind:number)=>{
                if(x.id==n.addInfo.id){
                  this.mS.cellaCollegataInd=n.addInfo.cellaCollegataInd;
                  this.mS.currPortaId=n.addInfo.id;
                  this.mS.currPortaInd=ind;
                }
              });
            }
            this.mS.changeConfigurataPorta(null,this.cC.elencoCelle[this.mS.cellaCollegataInd],this.cC.elencoCelle[this.mS.cellaCollegataInd].elencoPorte[this.mS.currPortaInd]);
          } else { // porta scollegata
            this.cC.elencoPorteScollegate.forEach((x:any,ind:number)=>{
                if(x.id==n.addInfo.id){
                  this.mS.currPortaScollegataInd=ind;
                }
              });
          }
        }
       }
      }
    }
    this.getTooltipNodes();
  }

  addRemoveCollegamentoCelle(latocollegato:any,c1:any,c2:any,add=true){
    
    c1.celleCollegate.forEach((coll:any,ind:number)=>{
      if(coll.cellaCollegataId==c2.id){
        c1.celleCollegate.splice(ind,1);
      }
    });

    c1.celleCollegate.push({
      attivo:false,
      cellaCollegataId:c2.id,
      tipoCollegamento:'',
      latocollegato:latocollegato,
      distLato:0,
      larghezza:0
    });
  
  }

  detectCellaEndMove(position:any,idCella:string){
    (this.diagram as Diagram).nodes.forEach((node:any)=>{
      // riposiziona freeblock

      if(node.addInfo.type=='freeblock' && node.addInfo.hasOwnProperty('currFreeBlockCellaId') && node.addInfo.currFreeBlockCellaId==idCella){
        if(node.addInfo.currrFreeBlockCellaLato=='lato_sn'){
          node.offsetX=position.offsetX-Math.round(position.width/2)-Math.round(node.width/2);
          node.offsetY=position.offsetY+Math.round(position.height/2)-Math.round(node.height/2)-node.addInfo.currrFreeBlockCellaDistLato;
        }
        if(node.addInfo.currrFreeBlockCellaLato=='lato_ds'){
          node.offsetX=position.offsetX+Math.round(position.width/2)+Math.round(node.width/2);
          node.offsetY=position.offsetY+Math.round(position.height/2)-Math.round(node.height/2)-node.addInfo.currrFreeBlockCellaDistLato;
        }
        if(node.addInfo.currrFreeBlockCellaLato=='lato_retro'){
          node.offsetX=position.offsetX-Math.round(position.width/2)+Math.round(node.width/2)+node.addInfo.currrFreeBlockCellaDistLato;
          node.offsetY=position.offsetY-Math.round(position.height/2)-Math.round(node.height/2);
        }
        if(node.addInfo.currrFreeBlockCellaLato=='lato_fronte'){
          node.offsetX=position.offsetX-Math.round(position.width/2)+Math.round(node.width/2)+node.addInfo.currrFreeBlockCellaDistLato;
          node.offsetY=position.offsetY+Math.round(position.height/2)+Math.round(node.height/2);
        }
      } 
      if(node.addInfo.type=='divisorioorizz' && node.addInfo.hasOwnProperty('cellaCollegataId')  && node.addInfo.cellaCollegataId==idCella){
          node.offsetX=position.offsetX-Math.round(position.width/2)+Math.round(node.width/2);
          node.offsetY=position.offsetY+Math.round(position.height/2)+Math.round(node.height/2)-node.addInfo.distLato;
      }
      if(node.addInfo.type=='divisoriovert' && node.addInfo.hasOwnProperty('cellaCollegataId')  && node.addInfo.cellaCollegataId==idCella){
          node.offsetX=position.offsetX+Math.round(position.width/2)-Math.round(node.width/2)-node.addInfo.distLato;
          node.offsetY=position.offsetY+Math.round(position.height/2)-Math.round(node.height/2);
      }
      if(node.addInfo.type=='porta' && node.addInfo.hasOwnProperty('cellaCollegataId')  && node.addInfo.cellaCollegataId==idCella){
        if(node.addInfo.cellaCollegataLato=='lato_sn'){
          node.offsetX=position.offsetX-Math.round(position.width/2)-Math.round(node.width/2);
          node.offsetY=position.offsetY+Math.round(position.height/2)-Math.round(node.height/2)-node.addInfo.distSnPorta;
        }
        if(node.addInfo.cellaCollegataLato=='lato_ds'){
          node.offsetX=position.offsetX+Math.round(position.width/2)+Math.round(node.width/2);
          node.offsetY=position.offsetY+Math.round(position.height/2)-Math.round(node.height/2)-node.addInfo.distSnPorta;
        }
        if(node.addInfo.cellaCollegataLato=='lato_retro'){
          node.offsetX=position.offsetX-Math.round(position.width/2)+Math.round(node.width/2)+node.addInfo.distSnPorta;
          node.offsetY=position.offsetY-Math.round(position.height/2)-Math.round(node.height/2);
        }
        if(node.addInfo.cellaCollegataLato=='lato_fronte'){
          node.offsetX=position.offsetX-Math.round(position.width/2)+Math.round(node.width/2)+node.addInfo.distSnPorta;
          node.offsetY=position.offsetY+Math.round(position.height/2)+Math.round(node.height/2);
        }
      } 
      if(node.addInfo.type=='scaffale' && node.addInfo.hasOwnProperty('cellaCollegataId')  && node.addInfo.cellaCollegataId==idCella){
         node.offsetX=position.offsetX-Math.round(position.width/2)+node.addInfo.cellaCollegataOffsetX+Math.round(node.width/2);
         node.offsetY=position.offsetY-Math.round(position.height/2)+node.addInfo.cellaCollegataOffsetY+Math.round(node.height/2);
      } 
    });
     
  }

  
  resetScaffaliPreconf(cella:any){
    this.cC.elencoScaffali=[];
    let nodestoRemove:any=[];
    (this.diagram as Diagram).nodes.forEach((node:any)=>{
      if(node.addInfo.type=='scaffale'){
        nodestoRemove.push(node);
      }
    });
    nodestoRemove.forEach((node:any)=>{
      (this.diagram as Diagram).remove(node);
      this.diagram.dataBind();
    });
    this.cC.elencoScaffali=[]; 
    cella.scaffaliCellePreconfCodice='';
    cella.scaffaliCellePreconfTipoOptions=[];
    cella.scaffaliCellePreconf=false;
  }
  
  changeModPorta(event:any,cellaDati:any,porta:any,divisorio:string='',distPorta:any=null){
    this.mS.changeModelloPorta(event,cellaDati,porta,divisorio,distPorta);
    
  }

  resetModelloPorta(cella:any){
    cella.elencoPorte.forEach((p:any)=>{
      this.changeModPorta(null,cella,p);
    });
  }
  
  changeIngombri(cella:any){
   
    if(this.mS.userCellePreConf()){
        this.resetScaffaliPreconf(cella);
    }
    
    if(cella.spessore==13){
     cella.ingombroY=Math.round(cella.ingombroY/40)*40;
    } else {
      cella.ingombroY=Math.round(cella.ingombroY/20)*20;
    }
    cella.ingombroX=Math.round(cella.ingombroX/20)*20;

    (this.diagram as Diagram).nodes.forEach((cellaNode:any)=>{
      if(cellaNode.addInfo.type=='cella' && cellaNode.addInfo.id==cella.id){
        cellaNode.width=cella.ingombroX;
        cellaNode.height=cella.ingombroY;

        cellaNode.offsetX+=cellaNode.offsetX+cellaNode.width-Math.round((cellaNode.offsetX+cellaNode.width)/20)*20;
        cellaNode.offsetY+=cellaNode.offsetY+cellaNode.height-Math.round((cellaNode.offsetY+cellaNode.height)/20)*20;
        (this.diagram as Diagram).dataBind();
        (this.diagram as Diagram).nodes.forEach((n:any)=>{
          if(n.addInfo.type=='porta' && n.addInfo.cellaCollegataId==cella.id){
            let args={
              state: 'Completed',
              source:{
                width:cellaNode.width,
                height:cellaNode.height,
                offsetX:cellaNode.offsetX,
                offsetY:cellaNode.offsetY,
              },
              oldValue:{
                offsetX:cellaNode.offsetX,
                offsetY:cellaNode.offsetY,
              },
              newValue:{
                offsetX:cellaNode.offsetX,
                offsetY:cellaNode.offsetY,
              }
            };
            this.positionChange(args);
          
          }
        });
      }
    });
    if(cella.ingombroX>320 && cella.ingombroY<=320){
      cella.ruotasoffitto=true;
      cella.ruotaPavimento=true;
    }
  }


  sizeChange(args: any) {

        if(this.selectedItem.diagram.selectedItems.nodes.length> 1 ){
           args.cancel= true;
           return;
        }
        if(this.mS.disabledMoveOrResize(this.cC,this.selectedItem.diagram.selectedItems.nodes[0],args)){
          args.cancel=true;
          return;
        }
      


        this.selectedItem.preventPropertyChange = true;
        this.selectedItem.nodeProperties.width = (Math.round(args.newValue.width / 100) * 100);
        this.selectedItem.nodeProperties.height = (Math.round(args.newValue.height / 100) * 100);

        
        if(this.mS.currScaffaleInd>=0){
          if(this.selectedItem.diagram.selectedItems.nodes[0].addInfo.title.indexOf('R')>0){
            this.cC.elencoScaffali[this.mS.currScaffaleInd].width=this.selectedItem.diagram.selectedItems.nodes[0].height;
          } else {
            this.cC.elencoScaffali[this.mS.currScaffaleInd].width=this.selectedItem.diagram.selectedItems.nodes[0].width;
          }
        }
       
        if (args.state === 'Completed') {

         
            if(this.mS.currCellaInd>=0){
               if(this.cC.elencoCelle[this.mS.currCellaInd].spessore==13){
                this.selectedItem.diagram.selectedItems.nodes[0].height= (Math.round(args.source.height/40) *40);
                this.selectedItem.nodeProperties.height = (Math.round(args.source.height/40) *40);
              } else {
                this.selectedItem.diagram.selectedItems.nodes[0].width = (Math.round(args.newValue.width / 20) * 20);
                this.selectedItem.diagram.selectedItems.nodes[0].height = (Math.round(args.newValue.height / 20) * 20);
                if(this.mS.userCellePreConf()){
               
                  this.resetScaffaliPreconf(this.cC.elencoCelle[this.mS.currCellaInd]);
                }
              }
              this.cC.elencoCelle[this.mS.currCellaInd].ingombroX=this.selectedItem.diagram.selectedItems.nodes[0].width;
              this.cC.elencoCelle[this.mS.currCellaInd].ingombroY=this.selectedItem.diagram.selectedItems.nodes[0].height;
               if(this.cC.elencoCelle[this.mS.currCellaInd].ingombroX>320 && this.cC.elencoCelle[this.mS.currCellaInd].ingombroY<=320){
                this.cC.elencoCelle[this.mS.currCellaInd].ruotasoffitto=true;
                this.cC.elencoCelle[this.mS.currCellaInd].ruotaPavimento=true;
              }
              this.removeMisure();
              this.detectCellaEndMove({
                offsetX:args.source.offsetX, offsetY:args.source.offsetY,
                width:args.source.width, height:args.source.height
              },this.selectedItem.diagram.selectedItems.nodes[0].addInfo.id );
              
              this.cC.elencoCelle[this.selectedItem.diagram.selectedItems.nodes[0].addInfo.cellaIndex].elencoPorte.forEach((p:any,ind:number)=>{
                this.recalcDistPortaOptions(this.cC.elencoCelle[this.selectedItem.diagram.selectedItems.nodes[0].addInfo.cellaIndex],p);
              });
            }
            this.selectedItem.isModified = true;
            this.selectedItem.preventPropertyChange = false;
            if(this.mS.currScaffaleInd>=0){
              this.changeScaffale(this.cC.elencoScaffali[this.mS.currScaffaleInd]);
            }
            
        }
   
        
    };

  
  public refreshNodes(reset=false){

    if(reset){
        while (this.diagram.nodes.length > 0) {
                  this.diagram.remove(this.diagram.nodes[0]);
              }
        while (this.diagram.connectors.length > 0) {
            this.diagram.remove(this.diagram.connectors[0]);
        }
    }
    if(this.cC.diagram){
      this.diagram.loadDiagram(JSON.parse(this.cC.diagram)); 
     
     
    } else {
     
      
     // CASO IN CUI SONO NELLE PReCONFIGURATE DAGARD
      this.cC.elencoCelle.forEach((c:any,ind:number)=>{
            let copyCella = (JSON.parse(JSON.stringify(this.mS.nodeCella)));
            copyCella.addInfo.cellaIndex=ind;
            copyCella.offsetX=300;
            copyCella.offsetY=200;
            copyCella.width=c.ingombroX;
            copyCella.height=c.ingombroY;
            copyCella.addInfo.nodeWidth=c.ingombroX;
            copyCella.addInfo.nodeHeight=c.ingombroY;
            copyCella.shape.content=this.mS.setCellaContent(c,this.cC.elencoCelle);
            copyCella.addInfo.id=c.id;
            this.diagram.add(copyCella);  
            this.addToLayer(copyCella);
            // aggiunge porta
            let copyPorta = (JSON.parse(JSON.stringify(this.mS.nodePortaDS)));
            copyPorta.offsetX=copyCella.offsetX;
            copyPorta.offsetY=Math.round(copyCella.offsetY+copyCella.height/2+copyPorta.height/2);
            this.diagram.add(copyPorta);  
            //this.addToLayer(copyPorta);
            
         //   this.mS.addPorta(c,'lato_fronte',this.prev,copyPorta);
            let args={
              oldValue:{
                offsetX:copyPorta.offsetX,
                offsetY:copyPorta.offsetY,
              }
            };
            this.diagram.dataBind();
            (this.diagram as Diagram).nodes.forEach((node:any)=>{
              if(node.addInfo.type=='porta'){
                (this.diagram as Diagram).select([node]);
                this.checkPositionNode(node, args);
                
              }
            });
            (this.diagram as Diagram).nodes.forEach((node:any)=>{
              if(node.addInfo.type=='cella'){
                (this.diagram as Diagram).select([node]);
              }
            });
            setTimeout(() => {
              this.draw3D(false,true);
            },2000);
      
      });
      
    }
  if(!this.mS.userCellePreConf()){
    setTimeout(() => {
      this.mostraNascondi(['cella','porta','scaffale','impiantoRemoto','freeblock','divisorioorizz','divisoriovert'],true,true);
          this.draw3D(false,false);
          this.diagram.fitToPage({ mode: 'Page', region: 'Content',
              margin: { left: 100, right: 100, top: 100, bottom: 100 },canZoomIn: true
          });
          this.diagram.scrollSettings.horizontalOffset = 0;
          this.diagram.scrollSettings.verticalOffset = 0;
          //  this.diagram.zoomTo((0.3/this.diagram.scrollSettings.currentZoom)-1);
    },1000);
  } 
 

  }
  getMaxIngombro(){
    if(this.mS.userCellePreConf()){
      return 400;
    } else {
      return 36000;
    }
  }
  getMinIngombro(){
  if(this.mS.userCellePreConf()){
      return 120;
    } else {
      return 40;
    }
  }

  addToLayer(node:any){ 
     this.diagram!.layers[0].visible=true;
     this.diagram!.layers[1].visible=false;
     this.diagram.moveObjects([node.id],'visibleLayer');
  }

  mostraNascondi(what:string[],visible:boolean,hideAllOther:boolean=false){
    let nsV:any=[];
    let nsH:any=[];
    (this.diagram as Diagram).nodes.forEach((node:any)=>{
        if(what.includes(node.addInfo.type)){
          nsV.push(node.id);
        } else {
          let layer = this.diagram.layers.find((l:any) => l.id === node.layerId);
          if (layer && layer.visible) {
              nsH.push(node.id);
          }
        }
    });
    if(visible){
      this.diagram.moveObjects(nsV,'visibleLayer');
    } else {
      this.diagram.moveObjects(nsV,'hiddenLayer');
    }
    if(hideAllOther && nsH.length>0){
          this.diagram.moveObjects(nsH,'hiddenLayer');
    }
    this.diagram!.layers[0].visible=true;
    this.diagram!.layers[1].visible=false;
        
  }
  
  hideShowElements(){
   
      let lvl='';
      var currNode:any=null;
      if(this.currentLevel==this.lang.el('Mostra celle')){
        this.mostraNascondi(['cella','porta','scaffale','impiantoRemoto','freeblock','divisorioorizz','divisoriovert'],true,true);
        lvl='celle';
      }
      if(this.currentLevel==this.lang.el('Mostra pavimento')){
        this.mostraNascondi(['pavimento'],true,true);
        lvl='pavimento';
      }
      if(this.currentLevel==this.lang.el('Mostra soffitto')){
        this.mostraNascondi(['soffitto'],true,true);
        lvl='soffitto';
      }
      if(this.currentLevel==this.lang.el('Mostra pareti')){
        this.mostraNascondi(['porta','parete','scaffale',],true,true);
        lvl='pareti';
      
      }
  
   
      if(lvl=='pareti'){
     //   this.removePareti();   
      //  this.removeMisure();
      }
      this.addPointsToConfig();
      this.cC.elencoCelle.forEach((c:any)=>{
        this.mS.cellaDati=c;
        (this.diagram as Diagram).nodes.forEach((node:any)=>{
            if(node.addInfo.type=='cella' && node.addInfo.id==c.id){
              currNode=node;
            }
        });
         
        this.mS.objCella={
          w:this.mS.cellaDati.ingombroY,
          h:this.mS.cellaDati.altezza,
          d:this.mS.cellaDati.ingombroX,
          spessore:this.mS.cellaDati.spessore,
          cappucci:[],
          angolari:[]
        };
      
        this.mS.getObj(this.cC);

        if(lvl=='pareti' && currNode){
          this.drawPareti(this.mS.cellaDati,currNode,currNode.addInfo.cellaIndex);
        }
        if(lvl=='soffitto' && currNode){
          this.drawSoffitto(this.mS.cellaDati,currNode,currNode.addInfo.cellaIndex);
        }
        if(lvl=='pavimento' && currNode){
          this.drawPavimento(this.mS.cellaDati,currNode,currNode.addInfo.cellaIndex);
        }
      });
    }

    drawPavimento(currCella:any,node:any,currCellaInd:number){
    let pannello = (JSON.parse(JSON.stringify(this.mS.nodePannello)));
      if(currCella.finitura!='STANDARD'){
        pannello.shape.content=this.mS.pannelloInoxContent;
      }
      let xPannello=node.offsetX-Math.round(node.width/2);
      let zPannello=node.offsetY-Math.round(node.height/2);
    
      this.mS.objPavimento.pannelli.forEach((p:any,ind:number) => {
        pannello.width=p.w;
        pannello.height=p.h;
        pannello.addInfo.type='pavimento';

        this.addPannello(currCellaInd,pannello,xPannello+Math.round(pannello.width/2),zPannello+Math.round(pannello.height/2));
        xPannello=xPannello+pannello.width;
          
      
      });

    }

    drawSoffitto(currCella:any,node:any,currCellaInd:number){
      let pannello = (JSON.parse(JSON.stringify(this.mS.nodePannello)));
      if(currCella.finitura!='STANDARD'){
        pannello.shape.content=this.mS.pannelloInoxContent;
      }
      let xPannello=node.offsetX-Math.round(node.width/2);
      let zPannello=node.offsetY-Math.round(node.height/2);
    
      this.mS.objSoffitto.pannelli.forEach((p:any,ind:number) => {
    
        pannello.width=p.w;
        pannello.height=p.h;
        pannello.addInfo.type='soffitto';
        if(!this.mS.cellaDati.ruotasoffitto){
          if(p.z && p.z>0){
            zPannello=node.offsetY-Math.round(node.height/2)+p.z;
           this.addPannello(currCellaInd,pannello,xPannello+Math.round(pannello.width/2),zPannello+Math.round(pannello.height/2));
          } else {
           zPannello=node.offsetY-Math.round(node.height/2);
            this.addPannello(currCellaInd,pannello,xPannello+Math.round(pannello.width/2),zPannello+Math.round(pannello.height/2));
            xPannello+=p.w;
          }
        }else {
          if(p.x && p.x>0){
            xPannello=node.offsetX-Math.round(node.width/2)+p.x;
            this.addPannello(currCellaInd,pannello,xPannello+Math.round(pannello.width/2),zPannello+Math.round(pannello.height/2));
          } else {
            xPannello=node.offsetX-Math.round(node.width/2);
            this.addPannello(currCellaInd,pannello,xPannello+Math.round(pannello.width/2),zPannello+Math.round(pannello.height/2));
            zPannello+=p.h;
          }
        }
      });

    }

    drawPareti(currCella:any,node:any,currCellaInd:number){

          let pannello = (JSON.parse(JSON.stringify(this.mS.nodePannello)));
          let pannelloOrizz = (JSON.parse(JSON.stringify(this.mS.nodePannelloOrizz)));
     
          if(currCella.finitura!='STANDARD'){
            pannello.shape.content=this.mS.pannelloInoxContent;
            pannelloOrizz.shape.content=this.mS.pannelloInoxContent;
          }
          let x=node.offsetX-Math.round(node.width/2);
          let y=node.offsetY-Math.round(node.height/2);
          // ANGOLARI
          let angolare1= (JSON.parse(JSON.stringify(this.mS.nodeAngolare)));
          let angolare2= (JSON.parse(JSON.stringify(this.mS.nodeAngolare)));
          let angolare3= (JSON.parse(JSON.stringify(this.mS.nodeAngolare)));
          let angolare4= (JSON.parse(JSON.stringify(this.mS.nodeAngolare)));
          if(currCella.angolaricustom && currCella.angolaricustom['sinistraretro']){
               if(currCella.angolaricustom['sinistraretro'].finitura!='STANDARD'){
                  angolare1.shape.content=this.mS.angolareInoxContent;
               }
          }
          // sinistraretro
          if(currCella.combinata=='cellacombinatatop' || currCella.combinata=='cellacombinataleft') {
            this.addAngolare(currCellaInd,angolare1,x,y,'sinistraretro');
          }  else {
            this.addAngolare(currCellaInd,angolare1,x,y,'sinistraretro');
          }  
           
          x=node.offsetX+Math.round(node.width/2);
          y=node.offsetY-Math.round(node.height/2);
          if(currCella.angolaricustom && currCella.angolaricustom['destraretro']){
              if(currCella.angolaricustom['destraretro'].finitura!='STANDARD'){
                angolare2.shape.content=this.mS.angolareInoxContent;
              }
          }  
          // destraretro  
          if(currCella.combinata=='cellacombinatatop' || currCella.combinata=='cellacombinataright') {
            this.addAngolare(currCellaInd,angolare2,x,y,'destraretro');
          }  else {
            this.addAngolare(currCellaInd,angolare2,x,y,'destraretro');
          }  
           
          x=node.offsetX-Math.round(node.width/2);
          y=node.offsetY+Math.round(node.height/2);
          if(currCella.angolaricustom && currCella.angolaricustom['sinistrafronte']){
            if(currCella.angolaricustom['sinistrafronte'].finitura!='STANDARD'){
              angolare3.shape.content=this.mS.angolareInoxContent;
            }
          }    
          // sinistrafronte
          if(currCella.combinata=='cellacombinatabottom' || currCella.combinata=='cellacombinataleft') {
              this.addAngolare(currCellaInd,angolare3,x,y,'sinistrafronte');
          }  else {
              this.addAngolare(currCellaInd,angolare3,x,y,'sinistrafronte');
          }  
          x=node.offsetX+Math.round(node.width/2);
          y=node.offsetY+Math.round(node.height/2);
          if(currCella.angolaricustom && currCella.angolaricustom['destrafronte']){
            if(currCella.angolaricustom['destrafronte'].finitura!='STANDARD'){
              angolare4.shape.content=this.mS.angolareInoxContent;
            }
          }   
         // destrafronte
          if(currCella.combinata=='cellacombinatabottom' || currCella.combinata=='cellacombinataright') {
             this.addAngolare(currCellaInd,angolare4,x,y,'destrafronte');
          }  else {
            this.addAngolare(currCellaInd,angolare4,x,y,'destrafronte');
          }   
          // FRONTE
           x=node.offsetX-Math.round(node.width/2);
           y=node.offsetY+Math.round(node.height/2);
          this.mS.objFronte.pannelli.filter((x:any)=>!x.sopraporta).forEach((p:any,ind:number) => {
            pannelloOrizz.width=p.w;
            if(currCella.pannellicustom && currCella.pannellicustom['fronte'][ind]){
              p.d=currCella.pannellicustom['fronte'][ind].spessore;
            }
              if(p.porta){
              pannelloOrizz.shape.content=this.mS.pannelloPortaContent;
            } else {
              pannelloOrizz.shape.content=currCella.finitura!='STANDARD' ? this.mS.pannelloInoxContent: this.mS.pannelloPlasticContent;
            }
            this.addPannello(currCellaInd,pannelloOrizz,x+Math.round(pannelloOrizz.width/2),y+Math.round(p.d/2),'fronte',ind,p.fittizio);
            x+=p.w;
          });
          // DIVISORI
          this.mS.objDivisori.forEach((d:any)=>{
            if(d.type=='divisorioorizz'){
              x=d.x-Math.round(d.w/2);
              y=d.y;
            } else {
              x=d.x;
              y=d.y+Math.round(d.w/2);
            }
            d.pannelli.forEach((p:any,ind:number) => {
              if(d.type=='divisorioorizz'){
                pannelloOrizz.width=p.w;
                if(p.porta){
                  pannelloOrizz.shape.content=this.mS.pannelloPortaContent;
                } else {
                  pannelloOrizz.shape.content=currCella.finitura!='STANDARD' ? this.mS.pannelloInoxContent: this.mS.pannelloPlasticContent;
                }
                this.addPannello(currCellaInd,pannelloOrizz,x+Math.round(pannelloOrizz.width/2),y-Math.round(p.d/2),d.type,ind);
                x+=p.w;
              } else {
                pannello.height=p.w;
                if(p.porta){
                  pannello.shape.content=this.mS.pannelloPortaContent;
                } else {
                  pannello.shape.content=currCella.finitura!='STANDARD' ? this.mS.pannelloInoxContent: this.mS.pannelloPlasticContent;
                }
                this.addPannello(currCellaInd,pannello,x-p.d+Math.round(pannello.width/2),y-Math.round(pannello.height/2),d.type,ind);
                y-=p.w;
              }
              
            });
          });
          // RETRO
          x=node.offsetX-Math.round(node.width/2);
          y=node.offsetY-Math.round(node.height/2);
          this.mS.objRetro.pannelli.filter((x:any)=>!x.sopraporta).forEach((p:any,ind:number) => {
            pannelloOrizz.width=p.w;
            if(currCella.pannellicustom && currCella.pannellicustom['retro'][ind]){
              p.d=currCella.pannellicustom['retro'][ind].spessore;
            }
            if(p.porta){
              pannelloOrizz.shape.content=this.mS.pannelloPortaContent;
            } else {
              pannelloOrizz.shape.content=currCella.finitura!='STANDARD' ? this.mS.pannelloInoxContent: this.mS.pannelloPlasticContent;
            }
            this.addPannello(currCellaInd,pannelloOrizz,x+Math.round(pannelloOrizz.width/2),y-Math.round(p.d/2),'retro',ind,p.fittizio);
         
            x+=p.w;
          });


          // SINISTRA
          x=node.offsetX-Math.round(node.width/2);
          y=node.offsetY+Math.round(node.height/2);
          this.mS.objLatSin.pannelli.filter((x:any)=>!x.sopraporta).forEach((p:any,ind:number) => {
            pannello.height=p.w;
            if(currCella.pannellicustom && currCella.pannellicustom['sinistra'][ind]){
              p.d=currCella.pannellicustom['sinistra'][ind].spessore;
            }
            if(p.porta){
              pannello.shape.content=this.mS.pannelloPortaContent;
            } else {
               pannello.shape.content=currCella.finitura!='STANDARD' ? this.mS.pannelloInoxContent: this.mS.pannelloPlasticContent;
            }
            this.addPannello(currCellaInd,pannello,x-p.d+Math.round(pannello.width/2),y-Math.round(pannello.height/2),'sinistra',ind,p.fittizio);
            y-=p.w;
          });
          // DESTRA
          x=node.offsetX+Math.round(node.width/2);
          y=node.offsetY+Math.round(node.height/2);
          this.mS.objLatDs.pannelli.filter((x:any)=>!x.sopraporta).forEach((p:any,ind:number) => {
            pannello.height=p.w;
            if(currCella.pannellicustom && currCella.pannellicustom['destra'][ind]){
              p.d=currCella.pannellicustom['destra'][ind].spessore;
            }
            if(p.porta){
              pannello.shape.content=this.mS.pannelloPortaContent;
            } else {
              pannello.shape.content=currCella.finitura!='STANDARD' ? this.mS.pannelloInoxContent: this.mS.pannelloPlasticContent;
            }
            this.addPannello(currCellaInd,pannello,x+Math.round(p.d/2),y-Math.round(pannello.height/2),'destra',ind,p.fittizio);
            
             y-=p.w;
          });
    
    }
    

    addAngolare(currCellaInd:number,ang:any,x:number,y:number,lato:string='',ind:number=-1){
      ang.addInfo.cellaCollegataInd=currCellaInd;
      ang.addInfo.currAngolareCellaLato=lato;
      ang.id= 'n'+uuidv4();
      ang.offsetX=x;
      ang.offsetY=y;
      (this.diagram as Diagram).add(ang);
      this.addToLayer(ang);
    }

    addPannello(currCellaInd:number,pannello:any,x:number,y:number,lato:string='',ind:number=-1,fittizio=false){
      if(fittizio) return;
      pannello.addInfo.cellaCollegataInd=currCellaInd;
      pannello.addInfo.cellaCollegataLato=lato;
      pannello.addInfo.currPannelloInd=ind;
      pannello.id= 'n'+uuidv4();
      pannello.offsetX=x;
      pannello.offsetY=y;
      (this.diagram as Diagram).add(pannello);
      this.addToLayer(pannello);
    }
 
    removePareti(){
      let nodeList:NodeModel[]=[];
      let cNode:any=undefined;
      (this.diagram as Diagram).nodes.forEach((node:any)=>{
    //    if(node.addInfo.type=='pareti' && node.addInfo.cellaIndex==this.mS.currCellaInd){
        if(node.addInfo.type=='pareti'  ){
          nodeList.push(node);
        }
     //       if(node.addInfo.type=='cella' && node.addInfo.cellaIndex==this.mS.currCellaInd){
   //           cNode=node;
     //       }
        
     
      });
      if(nodeList.length>0){
        (this.diagram as Diagram).select(nodeList);
        (this.diagram as Diagram).remove();
   //     (this.diagram as Diagram).select([cNode]);
      }
   
       
    }
 
    mandatoryImpiantoNonValida(opt:string){
      
      this.mS.impiantoRemotoOpzioni.forEach((x:any)=>{
        x.items.foreach((item:any)=>{
          if(item.value==opt){
            if(item.nonComp){
            }
          }
        });
      });
     
    }

    whatsSelected(tiposel=''){
      
      
      if(tiposel=='portascollegata'){
          return this.selectedItem.diagram.selectedItems.nodes.length==1
          && this.mS.currPortaScollegataInd>=0 
      }
      if(tiposel=='minicella'){
        return this.selectedItem.diagram.selectedItems.nodes.length==1 
        && this.cC.elencoCelle 
        && this.cC.elencoCelle.length>0 
        && this.mS.currCellaInd>=0
        && this.cC.elencoCelle[this.mS.currCellaInd].isMiniCella;
      }
     
      if(tiposel=='collegate'){
          return this.selectedItem.diagram.selectedItems.nodes.length==2 
          && this.mS.currCellaInd>=0 
          && this.mS.cellaCollegataInd>=0 ;
      }
     
      
      if(tiposel=='impiantiremoti'){
        return this.selectedItem.diagram.selectedItems.nodes.length==1
        && this.mS.currImpiantoInd>=0 
        && this.mS.currimpiantiRemotiTipo!='' ;
      }
      if(tiposel=='combinata'){
        return this.selectedItem.diagram.selectedItems.nodes.length==2 
        && this.mS.currCellaInd>=0 
        && this.mS.cellaCombinataInd>=0 ;
      }
  
      if(tiposel=='pannellopareti'){
        return this.selectedItem.diagram.selectedItems.nodes.length==1 
        && this.mS.currPannelloInd>=0;
      }
      if(tiposel=='angolare'){
        return this.selectedItem.diagram.selectedItems.nodes.length==1 
        && this.mS.currAngolareAngolo 
        && this.mS.currAngolareAngolo!='' 
        && this.mS.currAngolareCellaInd>=0;
      }

      if(tiposel=='freeblock'){
        return this.selectedItem.diagram.selectedItems.nodes.length==1 
        && this.cC.elencoFreeBlocks 
        && this.cC.elencoFreeBlocks.length>0 
        && this.mS.currFreeBlockInd>=0;
      }
      if(tiposel=='duescaffali'){

        return this.selectedItem.diagram.selectedItems.nodes.length==2 
        && this.cC.elencoScaffali
        && this.cC.elencoScaffali.length>0 
        && this.mS.currScaffaleInd>=0;
      }
      if(tiposel=='scaffale'){
   
        return this.selectedItem.diagram.selectedItems.nodes.length==1 
        && this.cC.elencoScaffali
        && this.cC.elencoScaffali.length>0
        && this.mS.currScaffaleInd>=0;
      }
      if(tiposel=='dropin'){
          return this.selectedItem.diagram.selectedItems.nodes.length==1 
        && this.cC.elencoDropin 
        && this.cC.elencoDropin.length>0 
        && this.mS.currDropinInd>=0;
      }
      if(tiposel=='cella'){
        return this.selectedItem.diagram.selectedItems.nodes.length==1 
        && this.cC.elencoCelle 
        && this.cC.elencoCelle.length>0 
        && this.mS.currCellaInd>=0
        && !this.cC.elencoCelle[this.mS.currCellaInd].isMiniCella;
      }
       if(tiposel=='porta'){
        return this.selectedItem.diagram.selectedItems.nodes.length==1 
        && this.cC.elencoCelle 
        && this.cC.elencoCelle.length>=0 
        && this.mS.cellaCollegataInd>=0
        && this.mS.currPortaId!=''
        && this.mS.currPortaInd>=0;
      }
      if(tiposel=='divisorio'){
       
        return (this.selectedItem.diagram.selectedItems.nodes.length==2 
        && this.cC.elencoCelle 
        && this.cC.elencoCelle.length>0 
        && this.mS.currCellaInd>=0
        && this.mS.currCellaSucc>=0) || (this.selectedItem.diagram.selectedItems.nodes.length==1 && this.mS.portaDivisorio);
      }
    }
   
    refreshCollegamento(){

     
      let cella1=this.cC.elencoCelle[this.mS.currCellaInd];
      let cella2=this.cC.elencoCelle[this.mS.cellaCollegataInd];
      
      if(cella1.id==this.diagram.selectedItems.nodes[0].addInfo.id){
        this.mS.setCollegamentoCella(cella1,cella2,this.diagram.selectedItems.nodes[0],this.diagram.selectedItems.nodes[1],this.cC.elencoCelle);
       } else {
        this.mS.setCollegamentoCella(cella1,cella2,this.diagram.selectedItems.nodes[1],this.diagram.selectedItems.nodes[0],this.cC.elencoCelle);
      }

      // Dopo i link: ridisegna i contorni SVG (non toccare le unite con setCellaContent).
      this.updateHtmlNodesOuterBorders();
      
      this.diagram.dataBind();

    }

    
  collegaCelle(cella1:any,cella2:any){

    // accetta celle o nodi diagramma
    const id1 = cella1?.id ?? cella1?.addInfo?.id;
    const id2 = cella2?.id ?? cella2?.addInfo?.id;
    const c1 =
      (this.cC.elencoCelle || []).find((c: any) => c.id == id1) || cella1;
    const c2 =
      (this.cC.elencoCelle || []).find((c: any) => c.id == id2) || cella2;
    if (!c1?.id || !c2?.id || !this.mS.currCollegamento) {
      return;
    }

    // disattiva "Celle unite" → elimina del tutto il collegamento da entrambe le celle
    if(!this.mS.currCollegamento.attivo){
      c1.celleCollegate = (c1.celleCollegate || []).filter(
        (c: any) => c.cellaCollegataId != c2.id,
      );
      c2.celleCollegate = (c2.celleCollegate || []).filter(
        (c: any) => c.cellaCollegataId != c1.id,
      );
      this.mS.collegamentoCellaOptions=[];
      // stub distaccato per il binding del checkbox (non è più in celleCollegate)
      this.mS.currCollegamento = {
        attivo: false,
        cellaCollegataId: c2.id,
        tipoCollegamento: this.mS.currCollegamento.tipoCollegamento || '',
        latocollegato: this.mS.currCollegamento.latocollegato || '',
        distLato: 0,
        larghezza: 0,
      };
      this.updateHtmlNodesOuterBorders();
      this.diagram.dataBind();
      return;
    }

    // attiva: se il link era stato cancellato, lo ricrea su entrambe le celle
    const lato = this.mS.currCollegamento.latocollegato || '';
    if (!(c1.celleCollegate || []).some((c: any) => c.cellaCollegataId == c2.id)) {
      this.addRemoveCollegamentoCelle(lato, c1, c2, true);
    }
    if (!(c2.celleCollegate || []).some((c: any) => c.cellaCollegataId == c1.id)) {
      this.addRemoveCollegamentoCelle(lato, c2, c1, true);
    }
    // rivaluta riferimento dopo eventuale recreate
    this.mS.currCollegamento =
      (c1.celleCollegate || []).find((x: any) => x.cellaCollegataId == c2.id) ||
      this.mS.currCollegamento;
    this.mS.currCollegamento.attivo = true;

    this.mS.collegamentoCellaOptions=[];

   
    if(
      ( (this.mS.currCollegamento.latocollegato=='lato_fronte' || this.mS.currCollegamento.latocollegato=='lato_retro')
        && (c1.ingombroX!=c2.ingombroX)
      ) ||
      ( (this.mS.currCollegamento.latocollegato=='lato_sn' || this.mS.currCollegamento.latocollegato=='lato_ds')
        && (c1.ingombroY!=c2.ingombroY)
      )) {
       this.mS.collegamentoCellaOptions.push({
          value: 'combinate',
          label: this.lang.el('Con set accoppiamento')
        });
      this.mS.collegamentoCellaOptions.push({
          value: 'collegateDivisorio',
          label: this.lang.el('Collegate con divisorio')
        });
      this.mS.collegamentoCellaOptions.push({
          value: 'unite',
          label: this.lang.el('Unite')
        });

      } else {

        this.mS.collegamentoCellaOptions.push({
          value: 'combinate',
          label: this.lang.el('Con set accoppiamento')
        });
     
        this.mS.collegamentoCellaOptions.push({
          value: 'collegateDivisorio',
          label: this.lang.el('Collegate con divisorio')
        });
        this.mS.collegamentoCellaOptions.push({
          value: 'unite',
          label: this.lang.el('Unite')
        });


      }
      
      if(c1.spessore==13 || c2.spessore==13  ){
        this.mS.collegamentoCellaOptions=[];
        this.mS.collegamentoCellaOptions.push({
          value: 'collegateDivisorio',
          label: this.lang.el('Collegate con divisorio')
        });
      }
      if(c1.celleCollegate){
          c1.celleCollegate.forEach((c:any,ind:number)=>{
          if(c.cellaCollegataId==c2.id){
            c1.celleCollegate[ind].attivo=true;
          }
        });
      }
      if(c2.celleCollegate){
        c2.celleCollegate.forEach((c:any,ind:number)=>{
          if(c.cellaCollegataId==c1.id){
            c2.celleCollegate[ind].attivo=true;
          }
        });
      }

      this.refreshCollegamento();

  }

  refreshDiagram(value:any,propertyName:string){


      switch ( propertyName ) {
        /*
      case 'tipoCollegamento':

        if(value=='unite'){
          let comb:any=this.diagram.selectedItems.nodes[0];
          let cella:any=this.diagram.selectedItems.nodes[1];
          if(this.diagram.selectedItems.nodes[1].addInfo.subtype){
             comb=this.diagram.selectedItems.nodes[1];
             cella=this.diagram.selectedItems.nodes[0];
          }

          switch(this.mS.cellaCombinataLatoCollegato){
            case 'lato_fronte':
              this.cC.elencoCelle[this.mS.cellaCombinataInd].distLato=Math.round(comb.offsetX-comb.width/2)-Math.round(cella.offsetX-cella.width/2);
              comb.offsetY-=this.cC.elencoCelle[this.mS.cellaCombinataInd].spessore;
              break;
            case 'lato_retro':
              this.cC.elencoCelle[this.mS.cellaCombinataInd].distLato=Math.round(comb.offsetX-comb.width/2)-Math.round(cella.offsetX-cella.width/2);
              comb.offsetY+=this.cC.elencoCelle[this.mS.cellaCombinataInd].spessore;
              break;
            case 'lato_sn':
              this.cC.elencoCelle[this.mS.cellaCombinataInd].distLato=Math.round(cella.offsetY+cella.height/2)-Math.round(comb.offsetY+comb.height/2);
              comb.offsetX+=this.cC.elencoCelle[this.mS.cellaCombinataInd].spessore;
              break;
            case 'lato_ds':
              this.cC.elencoCelle[this.mS.cellaCombinataInd].distLato=Math.round(cella.offsetY+cella.height/2)-Math.round(comb.offsetY+comb.height/2);
              comb.offsetX-=this.cC.elencoCelle[this.mS.cellaCombinataInd].spessore;
              break;
          }
           
          this.diagram.dataBind();
        }


        break;
        */
      case 'scaffaleBloccato':
        /*
          this.selectedItem.diagram.selectedItems.nodes.forEach((nn:any)=>{
            this.cC.elencoScaffali.forEach((sc:any,ind:number)=>{
              if(sc.id==nn.addInfo.id){
                this.cC.elencoScaffali[ind].scaffaliUniti=this.cC.elencoScaffali[this.mS.currScaffaleInd].scaffaliUniti;
              }
            });
          });
          this.diagram.dataBind();
          */
          break;
      case 'spessorepannello':
          if(this.selectedItem.diagram.selectedItems.nodes[0].addInfo.cellaCollegataLato=='retro' || this.selectedItem.diagram.selectedItems.nodes[0].addInfo.cellaCollegataLato=='fronte' ){
            this.selectedItem.diagram.selectedItems.nodes[0].height=value;
          } else {
            this.selectedItem.diagram.selectedItems.nodes[0].width=value;
          }
          this.diagram.dataBind();
          break;
      case 'widthScaffale':
          if(this.selectedItem.diagram.selectedItems.nodes[0].addInfo.title.indexOf('R')>0){
            let delta=Math.round((this.selectedItem.diagram.selectedItems.nodes[0]['height']-value)/2);
            this.selectedItem.diagram.selectedItems.nodes[0]['offsetY']-=delta;
            this.selectedItem.diagram.selectedItems.nodes[0]['height']=value;
          } else {
            let delta=Math.round((this.selectedItem.diagram.selectedItems.nodes[0]['width']-value)/2);
            this.selectedItem.diagram.selectedItems.nodes[0]['offsetX']-=delta;
            this.selectedItem.diagram.selectedItems.nodes[0]['width']=value;
          }
          this.diagram.dataBind();
          break;
      case 'finiturapannello':
          this.selectedItem.diagram.selectedItems.nodes[0].shape.content=this.mS.setPannelloContent( value);
          this.diagram.dataBind();
          break;
      case 'finitura':
      case 'spessore':
          this.selectedItem.diagram.selectedItems.nodes[0].shape.content=this.mS.setCellaContent(this.cC.elencoCelle[this.mS.currCellaInd], this.cC.elencoCelle);
          this.diagram.dataBind();
          break;
      case 'divisorioCella':
          if(this.cC.elencoCelle[this.mS.currCellaInd].divisorioCella=='' 
            || !this.cC.elencoCelle[this.mS.cellaCollegataInd].cellaUnita
          ){
            return;
          }

          let primoNodo:any=this.selectedItem.diagram.selectedItems.nodes[0];
          let secondoNodo:any=this.selectedItem.diagram.selectedItems.nodes[1];
          
          if(secondoNodo.addInfo.id==this.cC.elencoCelle[this.mS.currCellaInd].id){
            primoNodo=this.selectedItem.diagram.selectedItems.nodes[1];
            secondoNodo=this.selectedItem.diagram.selectedItems.nodes[0];
          }
         
          if(this.cC.elencoCelle[this.mS.currCellaInd].divisorioCella!='conPorta'){
            // cerca se deve rimuovere nodo porta
              (this.diagram as Diagram).nodes.forEach((node:any,indCella:number)=>{
               if(node.addInfo.type=='porta'&& node.addInfo.cellaCollegataId==primoNodo.addInfo.id  && node.addInfo.portaDivisorio){
                this.diagram.remove(node); 
               }
            });
          }
          if(this.cC.elencoCelle[this.mS.currCellaInd].divisorioCella=='conPorta'){
            let p:any=this.mS.addPortaDivisorio(
                          this.mS.currCellaInd,
                          primoNodo,
                          this.mS.currLatoDivisorio,this.mS.currCellaInd,this.prev);
           
            this.diagram.add(p);  
            this.addToLayer(p); 
            let nodoPorta:any=(this.diagram as DiagramComponent).nodes[(this.diagram as DiagramComponent).nodes.length-1];
            if(this.mS.currLatoDivisorio=='lato_sn'){
              (this.diagram as DiagramComponent).rotate(nodoPorta,90);
            }
            if(this.mS.currLatoDivisorio=='lato_ds'){    
              (this.diagram as DiagramComponent).rotate(nodoPorta,270);
            }
            if(this.mS.currLatoDivisorio=='lato_retro'){
              (this.diagram as DiagramComponent).rotate(nodoPorta,180);
            }
            if(this.cC.elencoCelle[this.mS.currCellaInd].portaDivisorio.ruota180gradi){
              (this.diagram as DiagramComponent).rotate(nodoPorta,180);            
              if(this.mS.currLatoDivisorio=='lato_ds'){    
                 (this.diagram as Diagram).nodes.forEach((node:any,indCella:number)=>{
                  if(node.addInfo.type=='cella' && node.addInfo.id==nodoPorta.addInfo.cellaCollegataId){
                      nodoPorta.offsetX=Math.round(node.offsetX+node.width/2+nodoPorta.width/2); 
                  }
                });
              }
              if(this.mS.currLatoDivisorio=='lato_sn'){    
                 (this.diagram as Diagram).nodes.forEach((node:any,indCella:number)=>{
                  if(node.addInfo.type=='cella' && node.addInfo.id==nodoPorta.addInfo.cellaCollegataId){
                      nodoPorta.offsetX=Math.round(node.offsetX-node.width/2+nodoPorta.width/2); 
                  }
                });
              }
              if(this.mS.currLatoDivisorio=='lato_fronte'){    
                 (this.diagram as Diagram).nodes.forEach((node:any,indCella:number)=>{
                  if(node.addInfo.type=='cella' && node.addInfo.id==nodoPorta.addInfo.cellaCollegataId){
                      nodoPorta.offsetY=Math.round(node.offsetY+node.height/2+nodoPorta.height/2); 
                  }
                });
              }
              if(this.mS.currLatoDivisorio=='lato_retro'){    
                 (this.diagram as Diagram).nodes.forEach((node:any,indCella:number)=>{
                  if(node.addInfo.type=='cella' && node.addInfo.id==nodoPorta.addInfo.cellaCollegataId){
                      nodoPorta.offsetY=Math.round(node.offsetY+node.height/2-nodoPorta.height/2); 
                  }
                });
              }
            }
            (this.diagram as DiagramComponent).nodes[(this.diagram as DiagramComponent).nodes.length-1].constraints=NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize;
         
          }
          primoNodo.shape.content=this.mS.setCellaContent(this.cC.elencoCelle[this.mS.currCellaInd],this.cC.elencoCelle);
          secondoNodo.shape.content=this.mS.setCellaContent(this.cC.elencoCelle[this.mS.currCellaSucc],this.cC.elencoCelle);
          this.diagram.dataBind();          
          break;
      default: 
          this.selectedItem.diagram.selectedItems.nodes[0][propertyName]=value;
          this.diagram.dataBind();
          break;
    }
  }

  getWidthScaffale(width:number,Profondita:number,altezza:number|null=null){
    let sd=this.scaffaliData.filter((x)=>
      x.Profondita == Profondita &&
      x.Larghezza == width &&
      (altezza==null || x.Altezza == altezza)
    );
    // fallback senza altezza (compat)
    if ((!sd || sd.length===0) && altezza!=null) {
      sd=this.scaffaliData.filter((x)=>x.Profondita ==Profondita && x.Larghezza == width);
    }
    return sd[0];
  }
    


  changeAllineamentoScaffale(){
    let cella:any=null;
    if(this.selectedItem.diagram.selectedItems.nodes[0].addInfo.cellaCollegataId!=''){
      (this.diagram as Diagram).nodes.forEach((c:any)=>{
          if(c.addInfo.type=='cella' && !c.addInfo.subtype){
           cella=c;
          }
        });
      switch(this.allineamentoScaffale){
        case 'left':
          this.selectedItem.diagram.selectedItems.nodes[0].offsetX=Math.round(cella.offsetX-cella.width/2+this.selectedItem.diagram.selectedItems.nodes[0].width/2);
          break;
        case 'right':
          this.selectedItem.diagram.selectedItems.nodes[0].offsetX=Math.round(cella.offsetX+cella.width/2-this.selectedItem.diagram.selectedItems.nodes[0].width/2);
          break;
        case 'center':
          this.selectedItem.diagram.selectedItems.nodes[0].offsetX=cella.offsetX;
          break;
        case 'top':
          this.selectedItem.diagram.selectedItems.nodes[0].offsetY=Math.round(cella.offsetY-cella.height/2+this.selectedItem.diagram.selectedItems.nodes[0].height/2);
          break;
        case 'bottom':
          this.selectedItem.diagram.selectedItems.nodes[0].offsetY=Math.round(cella.offsetY+cella.height/2-this.selectedItem.diagram.selectedItems.nodes[0].height/2);
          break;
      }
    }
  }
  
  public changeScaffale(scaffale:any,combscelta:number[]=[]){
       

    let cl=0;
    let stop=false;
    let node=this.selectedItem.diagram.selectedItems.nodes[0];
    let initLarg=node.addInfo.nodeWidth;
    let scaffaleSingle=false;
    let profondita=37;
    let objScaffale:any=null;
    let largOpt=this.mS.scaffLlargh37;
    scaffale.elenco=[];
    if(!node.addInfo){
      return;
    }
    if(node.addInfo.title.indexOf('R')>=0){
      if(node.addInfo.nodeWidth==47){
        profondita=47;
        largOpt=this.mS.scaffLlargh47;
      }
    
      if(node.addInfo.nodeWidth==56){
        profondita=56;
        largOpt=this.mS.scaffLlargh56;
      }
    } else {
      if(node.addInfo.nodeHeight==37){
        profondita=37;
        largOpt=this.mS.scaffLlargh37;
      }
    
      if(node.addInfo.nodeHeight==47){
        profondita=47;
        largOpt=this.mS.scaffLlargh47;
      }
    
      if(node.addInfo.nodeHeight==56){
        profondita=56;
        largOpt=this.mS.scaffLlargh56;
      }
    }

    const altScaff = scaffale.altezza || 167;
    const shelves = largOpt
      .map((lung: number) => {
        const obj = this.getWidthScaffale(lung, profondita, altScaff);
        return obj ? { lung, larghezzaReale: obj.LarghezzaReale } : null;
      })
      .filter((s): s is { lung: number; larghezzaReale: number } => s !== null);
    const larghezzaSpalla = shelves.length
      ? this.getWidthScaffale(shelves[0].lung, profondita, altScaff)?.LarghezzaSpalla ?? 0
      : 0;

    let combinazione = this.mS.findBestScaffaleCombination(
      scaffale.width,
      shelves,
      larghezzaSpalla
    );

    scaffale.elenco=[];
    if(combscelta.length==0){
      combscelta=combinazione;
    }
    if(combscelta.length==0){
      return;
    }
    combscelta.forEach((s:any)=>{
      let ispresent=false;
      scaffale.elenco.forEach((ele:any,ind:number)=>{
        if(ele.lung==s){
          scaffale.elenco[ind].qty++;
          ispresent=true;
          objScaffale=ele.scaffale;
        }
      });
      if(!ispresent){
        objScaffale=this.getWidthScaffale(s,profondita, altScaff);
        scaffale.elenco.push({
            lung:s,
            qty:1,
            scaffale:objScaffale
        })
      }
      cl+=objScaffale.LarghezzaReale;
    });  

    cl+=objScaffale.LarghezzaSpalla;
    scaffale.width=cl;

    this.refreshDiagram(cl,'widthScaffale');
/*

      
      if(scaffale.width<=largOpt[largOpt.length-1]){
        scaffaleSingle=true;
      }
      if(scaffale.width<largOpt[0]){
        if(node.addInfo.title.indexOf('R')>0){
           scaffale.width=largOpt[0];
        } else {
           scaffale.width=largOpt[0];
        }
       
      }
      if(node.addInfo.title.indexOf('R')>0){
        objScaffale=this.getWidthScaffale(node.addInfo.nodeHeight,profondita);
      } else {
        objScaffale=this.getWidthScaffale(node.addInfo.nodeWidth,profondita);
      }
      if(!objScaffale){
      }
      initLarg=objScaffale.Larghezza;
      while (!stop){
        if(cl+initLarg<=scaffale.width){
          let isSet=false;
          scaffale.elenco.forEach((s:any,ind:number)=>{
            if(s.lung==initLarg){
              isSet=true;
              scaffale.elenco[ind].qty++;
            }
          })
          if(!isSet){
            scaffale.elenco.push({
              lung:initLarg,
              qty:1,
              scaffale:objScaffale
            });
          }
              
          if(scaffaleSingle){
            cl+=objScaffale.Larghezza;
          } else {
             cl+=objScaffale.LarghezzaReale+objScaffale.LarghezzaSpalla;
          }
          
          
        } else {
          stop=true;
        }
      }
      if(cl<scaffale.width){
        stop=false;
        let indLarg=largOpt.length-1;
        while (indLarg>=0){
          let obj=this.getWidthScaffale(largOpt[indLarg],profondita);
          let lar:number=obj.Larghezza;
          if(scaffale.width >= cl + lar){
            let isSet=false;
            scaffale.elenco.forEach((s:any,ind:number)=>{
              if(s.lung==lar){
                isSet=true;
                scaffale.elenco[ind].qty++;
              }
            });
            if(!isSet){
              scaffale.elenco.push({
                lung:lar,
                qty:1,
                scaffale:obj
              });
            }
            cl+=obj.LarghezzaReale+objScaffale.LarghezzaSpalla;
          } 
          indLarg--;
        }
       
      }
        */
    
    }

  checkFormIsValid(){

    this.errorMessage=this.mS.formCellaIsValid(this.cC);
    if(this.errorMessage.length>0){
      this.showError=true;
      return false;
    }
    return true;
  }

  stampaTavole(){
    if(!this.checkFormIsValid()){
      return;
    }
    let esistepavimento=false;
    this.cC.elencoCelle.forEach((c:any,ind:number)=>{
      if(c.pavimenti){
        esistepavimento=true;
      }
     });
     if(esistepavimento){
      this.tipodistampaList=[
        {
          label:this.lang.el('Tutto'),
          value:'all'
        },
        {
          label:this.lang.el('Pareti'),
          value:'pareti'
        },
        {
          label:this.lang.el('Pavimento'),
          value:'pavimento'
        },
        {
          label:this.lang.el('Soffitto'),
          value:'soffitto'
        }
      ];
     } else {
      this.tipodistampaList=[
        {
          label:this.lang.el('Tutto'),
          value:'all'
        },
        {
          label:this.lang.el('Pareti'),
          value:'pareti'
        },
        {
          label:this.lang.el('Soffitto'),
          value:'soffitto'
        }
      ];
     }

    
    this.showDialogPrint=true;
  }

  draw3D(save=false,refreshDistinta=true){

    (this.diagram as Diagram).nodes.forEach((node:any)=>{
      if(node.addInfo.type=='impiantoRemoto'){
          this.mS.currImpiantoInd=node.addInfo.impiantoRemotoInd;
          this.mS.currimpiantiRemotiTipo=node.addInfo.title;
          this.mS.loadcurrImpiantoRemotoOptionms(this.mS.currimpiantiRemotiTipo,this.cC);
      }
    });
    
    if(!this.checkFormIsValid()){
      return;
    }

    
    let ingombri=this.mS.calcIngombri(this.diagram);
    this.cC.elencoCelle.forEach((c:any,ind:number)=>{
      c.elencoPorte.forEach((p:any)=>{
        if(p.versoAperturaPorta==2){
          p.tipoApertura='SX';
        }
        if(p.versoAperturaPorta==1){
          p.tipoApertura='DX';
        }
      });
      (this.diagram as Diagram).nodes.forEach((node:any)=>{
        if(node.addInfo.id== c.id){
            c.offsetY3d=Math.round(node.offsetY-node.height/2-ingombri.minY);
            c.offsetX3d=Math.round(node.offsetX-node.width/2-ingombri.minX);
        }
      });
    });
    this.addPointsToConfig();
    
    if(save){
          this.messageEvent.emit({what:'draw3DandSave'});
    } else {
      if(refreshDistinta){
         this.messageEvent.emit({what:'draw3D'});
      } else {
         this.messageEvent.emit({what:'draw3DNoRefresh'});
      }
       
    } 
  }

  checkOnCelle(x1:number,y1:number){
    let pt1={x:x1+5,y:y1-5};
    let pt2={x:x1+5,y:y1+5};
    let pt3={x:x1-5,y:y1+5};
    let pt4={x:x1-5,y:y1-5};
    let contaInside=0;

    this.cC.elencoPunti.forEach((c:any)=>{
      if(pt1.x>=c.x1 && pt1.x<=c.x2 && pt1.y>=c.y1 && pt1.y<=c.y2 ){
        contaInside++;
      }
      if(pt2.x>=c.x1 && pt2.x<=c.x2 && pt2.y>=c.y1 && pt2.y<=c.y2 ){
        contaInside++;
      }
      if(pt3.x>=c.x1 && pt3.x<=c.x2 && pt3.y>=c.y1 && pt3.y<=c.y2 ){
        contaInside++;
      }
      if(pt4.x>=c.x1 && pt4.x<=c.x2 && pt4.y>=c.y1 && pt4.y<=c.y2 ){
        contaInside++;
      }
    });
    if(contaInside==3){
      return true;
    }
    return false;
  }

  coppiaAngoliNovanta(lato:string,cella:any,startLeft:number,distanza:number){

    let pts=this.cC.elencoPunti.filter((x:any)=> x.id==cella.id);
    let pt1:any={};
    let pt2:any={};
    if(lato=='lato_fronte'){
      pt1={x:pts[0].x1+startLeft,y:pts[0].y2};
      pt2={x:pts[0].x1+distanza,y:pts[0].y2};
    }
    if(lato=='lato_retro'){
      pt1={x:pts[0].x1+startLeft,y:pts[0].y1};
      pt2={x:pts[0].x1+distanza,y:pts[0].y1};
    }
    if(lato=='lato_sn'){
      pt1={x:pts[0].x1,y:pts[0].y2-startLeft};
      pt2={x:pts[0].x1,y:pts[0].y2-distanza};
    }
    if(lato=='lato_ds'){
      pt1={x:pts[0].x2,y:pts[0].y2-startLeft};
      pt2={x:pts[0].x2,y:pts[0].y2-distanza};
     
    }
    if(this.checkOnCelle(pt1.x,pt1.y)){
         this.cC.elencoAngoli.push({
          id:cella.id,
          x:pt1.x,
          y:pt1.y
        });
      }
      if(this.checkOnCelle(pt2.x,pt2.y)){
         this.cC.elencoAngoli.push({
          id:cella.id,
          x:pt2.x,
          y:pt2.y
        });
      }
      /*
    if(this.checkOnCelle(pt1.x,pt1.y) && this.checkOnCelle(pt2.x,pt2.y)){
       this.cC.elencoAngoli.push({
        id:cella.id,
        x:pt1.x,
        y:pt1.y,
        segmento:true
      });
      this.cC.elencoAngoli.push({
        id:cella.id,
        x:pt2.x,
        y:pt2.y,
        segmento:true
      });
    } else {
      if(this.checkOnCelle(pt1.x,pt1.y)){
         this.cC.elencoAngoli.push({
          id:cella.id,
          x:pt1.x,
          y:pt1.y,
          segmento:false
        });
      }
      if(this.checkOnCelle(pt2.x,pt2.y)){
         this.cC.elencoAngoli.push({
          id:cella.id,
          x:pt2.x,
          y:pt2.y,
          segmento:false
        });
      }
    }
      */
  }

public  addPointsToConfig(){
    this.cC.elencoPunti=[];
    this.cC.elencoAngoli=[];
    (this.diagram as Diagram).nodes.filter((x:any)=>x.addInfo.type=='cella').forEach((node:any)=>{
      this.cC.elencoPunti.push(
        {
          id:node.addInfo.id,
          x1:Math.round(node.offsetX-node.width/2),
          y1:Math.round(node.offsetY-node.height/2),
          x2:Math.round(node.offsetX+node.width/2),
          y2:Math.round(node.offsetY+node.height/2)
        });
    });
        
    this.cC.elencoCelle.forEach((cellaDati:any)=>{
      // =================
      // FRONTE
      // =================
      let startLeft=0;
      let elementiLato=this.mS.getElementiLato('lato_fronte',this.cC,cellaDati);
      let elementiFiltered=elementiLato.filter((x:any)=>x.larghezza>0 || x.distanzaSn>0);
      if(cellaDati.celleCollegate.filter((x:any)=>x.attivo && x.latocollegato=='lato_fronte'  
        &&  !x.latocombinato ).length==0){
        elementiFiltered.forEach((p:any)=>{     
          if(p.distanzaSn>0){
            this.coppiaAngoliNovanta('lato_fronte',cellaDati,startLeft,p.distanzaSn);
          }
          startLeft=p.distanzaSn+p.larghezza;
        });
      }
      if(startLeft<cellaDati.ingombroX && (elementiLato.length==0 || elementiFiltered.length>0)){
        this.coppiaAngoliNovanta('lato_fronte',cellaDati,startLeft,cellaDati.ingombroX-startLeft);
      }
      // =================
      // RETRO
      // =================
      startLeft=0;
      elementiLato=this.mS.getElementiLato('lato_retro',this.cC,cellaDati);
      elementiFiltered=elementiLato.filter((x:any)=>x.larghezza>0 || x.distanzaSn>0);
      if(cellaDati.celleCollegate.filter((x:any)=>x.attivo && x.latocollegato=='lato_retro'  
        &&  !x.latocombinato ).length==0){
        elementiFiltered.forEach((p:any)=>{
          if(p.distanzaSn>0){
           this.coppiaAngoliNovanta('lato_retro',cellaDati,startLeft,p.distanzaSn);
          }
          startLeft=p.distanzaSn+p.larghezza;
        });
      }
      if(startLeft<cellaDati.ingombroX && (elementiLato.length==0 || elementiFiltered.length>0)){
        this.coppiaAngoliNovanta('lato_retro',cellaDati,startLeft,cellaDati.ingombroX-startLeft);
      }
      // =================
      // LAT SIN
      // =================
      startLeft=0;
      elementiLato=this.mS.getElementiLato('lato_sn',this.cC,cellaDati);
      elementiFiltered=elementiLato.filter((x:any)=>x.larghezza>0 || x.distanzaSn>0);
      if(cellaDati.celleCollegate.filter((x:any)=>x.attivo && x.latocollegato=='lato_sn'  
      &&  !x.latocombinato ).length==0){
        elementiFiltered.forEach((p:any)=>{
          if(p.distanzaSn>0){
             this.coppiaAngoliNovanta('lato_sn',cellaDati,startLeft,p.distanzaSn);
          }
          startLeft=p.distanzaSn+p.larghezza;
        });
      }  
      if(startLeft<cellaDati.ingombroY && (elementiLato.length==0 || elementiFiltered.length>0)){
        this.coppiaAngoliNovanta('lato_sn',cellaDati,startLeft,cellaDati.ingombroY-startLeft);
      }
      // =================
      // LAT DS
      // =================
      startLeft=0;
      elementiLato=this.mS.getElementiLato('lato_ds',this.cC,cellaDati);
      elementiFiltered=elementiLato.filter((x:any)=>x.larghezza>0 || x.distanzaSn>0);
      if(cellaDati.celleCollegate.filter((x:any)=>x.attivo && x.latocollegato=='lato_ds'  
      &&  !x.latocombinato ).length==0){
        elementiFiltered.forEach((p:any)=>{
          if(p.distanzaSn>0){
             this.coppiaAngoliNovanta('lato_ds',cellaDati,startLeft,p.distanzaSn);
          }
          startLeft=p.distanzaSn+p.larghezza;
        });
      }
      if(startLeft<cellaDati.ingombroY && (elementiLato.length==0 || elementiFiltered.length>0)){

        this.coppiaAngoliNovanta('lato_ds',cellaDati,startLeft,cellaDati.ingombroY-startLeft);
      }
    });

  }

  editDescription(){
    this.showEditDesc=true;
  }
  confermaDescrTecnica(){
    this.showEditDescTecnica=false;
  }
  
  mostraElencoScaffali(){
    this.elencoScaffali=[];
    let node=this.selectedItem.diagram.selectedItems.nodes[0];
    let largOpt=this.mS.scaffLlargh37;
    if(node.addInfo.title.indexOf('R')>=0){
      if(node.addInfo.nodeWidth==47){
        this.profonditaScaffale='47';
        largOpt=this.mS.scaffLlargh47;
      }
    
      if(node.addInfo.nodeWidth==56){
        this.profonditaScaffale='56';
        largOpt=this.mS.scaffLlargh56;
      }
    } else {
      if(node.addInfo.nodeHeight==37){
        this.profonditaScaffale='37';
        largOpt=this.mS.scaffLlargh37;
      }
    
      if(node.addInfo.nodeHeight==47){
        this.profonditaScaffale='47';
        largOpt=this.mS.scaffLlargh47;
      }
    
      if(node.addInfo.nodeHeight==56){
       this.profonditaScaffale='56';
        largOpt=this.mS.scaffLlargh56;
      }
    }
    largOpt.forEach((opt:any)=>{
      let presente=false;
      this.cC.elencoScaffali[this.mS.currScaffaleInd].elenco.filter((x:any)=>x.lung==opt).forEach((s:any)=>{
          presente=true;
          this.elencoScaffali.push({
            lung:opt,
            qty:s.qty
          });
      });
      if(!presente){
        this.elencoScaffali.push({
            lung:opt,
            qty:0
        });
      }
    });
    this.changeLunghScaffale();
    this.showEditScaffali=true;
  }

  changeLunghScaffale(){
    let tot=0;
    this.elencoScaffali.forEach((opt:any)=>{
      tot+=opt.lung*opt.qty;
    });
    this.lunghtotscaffali=tot;
  }

  confermaDistintaScaffali(){
    let comb:number[]=[];
    this.cC.elencoScaffali[this.mS.currScaffaleInd].elenco=[];
    this.elencoScaffali.forEach((opt:any)=>{
      for(let k=0;k<opt.qty;k++){
        comb.push(opt.lung);
      }
    });
    this.changeScaffale(this.cC.elencoScaffali[this.mS.currScaffaleInd],comb);
    this.showEditScaffali=false;
  }

  confermaDescr(){
     this.showEditDesc=false;
  }

  annullaEditor(){
     this.confirmationService.confirm({
            message: this.lang.el('Le modifiche in corso verranno perse. Si conferma?'),
            header: this.lang.el('Conferma'),
            closeOnEscape: true,
            icon: 'pi pi-exclamation-triangle',
            rejectLabel:this.lang.el('Annulla'),
            acceptLabel:this.lang.el('Conferma'),
            accept: () => {
              window.location.reload();
            },
            reject: () => {
              
            },
    });
   
  }

  saveCella(){


    if(!this.checkFormIsValid()){
      return;
    }
    this.cC.diagram= this.diagram.saveDiagram();
    this.draw3D(true,true); // aggiorna distinta e salva
    /*
    this.cC['logged_user_id']=this.globalService.getUser().id;
    this.cC.opp_id=this.prev.id;
    this.cC.distinta=this.mS.distintaData;
    this.cC.diagram= this.diagram.saveDiagram();
    let params={
      rigaCella:this.cC
    }
    
    this.apiService.post('app/opportunity_cella_update2',params).subscribe(data => {
      this.addSingle('success', this.lang.el('Successo'), this.lang.el('Configurazione salvata'));
    
        this.tipoStampa='pareti';
        this.formatoStampa='A4';
        this.creaPDF2('PDF',data.Result);
    
   
      });
    */
  }
  
  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }
 

  addLineaMisura(misura:string,x1:number,y1:number,x2:number,y2:number,delta:number,lato:string){
   
    if(!this.pdfIsPrinting){
      let c: ConnectorModel = {
            id: 'n'+uuidv4(),
            type: 'Straight',
            constraints:~NodeConstraints.Select,
            addInfo:{  type:'misura' },
            style: {strokeColor: 'blue'},
            sourcePoint: { x: x1, y:y1 },
            targetPoint: { x: x2, y: y2 },
            targetDecorator:{ shape: "None"}
        };
        (this.diagram as Diagram).add(c);
        if(lato=='lato_sn'){
          let tt:any={
              id: 'n'+uuidv4(),
              constraints:~NodeConstraints.Select,
              addInfo:{  type:'misura' },
              offsetX: x1,
              style: {color: 'blue',fill:'transparent'},
              offsetY: Math.round(y1+(y2-y1)/2),
              shape: { type: 'Text', content:misura}
          };
          (this.diagram as Diagram).add(tt);
          (this.diagram as Diagram).rotate(tt,-90);

          let l1: ConnectorModel = {
            id: 'n'+uuidv4(),
            type: 'Straight',
            constraints:~NodeConstraints.Select,
            style: {strokeColor: 'blue'},
            addInfo:{  type:'misura' },
            sourcePoint: { x: x1-Math.round(delta/5), y:y1 },
            targetPoint: { x: x1+Math.round(-delta/5+delta*0.6), y: y1 },
            targetDecorator:{ shape: "None"}
          };
          (this.diagram as Diagram).add(l1);
          let l2: ConnectorModel = {
            id: 'n'+uuidv4(),
            type: 'Straight',
            constraints:~NodeConstraints.Select,
            style: {strokeColor: 'blue'},
            addInfo:{  type:'misura' },
            sourcePoint: { x: x1-Math.round(delta/5), y:y2 },
            targetPoint: { x: x1+Math.round(-delta/5+delta*0.6), y: y2 },
            targetDecorator:{ shape: "None"}
          };
          (this.diagram as Diagram).add(l2);

        }


        if(lato=='lato_ds'){
          let tt:any={
              id: 'n'+uuidv4(),
              addInfo:{  type:'misura' },
              constraints:~NodeConstraints.Select,
              offsetX: x1,
              style: {color: 'blue',fill:'transparent'},
              offsetY: Math.round(y1+(y2-y1)/2),
              shape: { type: 'Text', content:misura}
          };
          (this.diagram as Diagram).add(tt);
          (this.diagram as Diagram).rotate(tt,-90);
          let l1: ConnectorModel = {
            id: 'n'+uuidv4(),
            type: 'Straight',
            style: {strokeColor: 'blue'},
            constraints:~NodeConstraints.Select,
            addInfo:{  type:'misura' },
            sourcePoint: { x: x1+Math.round(delta/5), y:y1 },
            targetPoint: { x: x1+Math.round(delta/5)-delta*0.6, y: y1 },
            targetDecorator:{ shape: "None"}
          };
          (this.diagram as Diagram).add(l1);
          let l2: ConnectorModel = {
            id: 'n'+uuidv4(),
            type: 'Straight',
            style: {strokeColor: 'blue'},
            constraints:~NodeConstraints.Select,
            addInfo:{  type:'misura' },
            sourcePoint: { x: x1+Math.round(delta/5), y:y2 },
            targetPoint: { x: x1+Math.round(delta/5)-delta*0.6, y: y2 },
            targetDecorator:{ shape: "None"}
          };
          (this.diagram as Diagram).add(l2);
        }


        if(lato=='lato_retro'){
          let tt:any={
              id: 'n'+uuidv4(),
              addInfo:{  type:'misura' },
              offsetX: Math.round(x1+(x2-x1)/2),
              constraints:~NodeConstraints.Select,
              style: {color: 'blue',fill:'transparent'},
              offsetY: y1,
              shape: { type: 'Text', content:misura}
          };
          (this.diagram as Diagram).add(tt);

          

          let l1: ConnectorModel = {
            id: 'n'+uuidv4(),
            type: 'Straight',
            style: {strokeColor: 'blue'},
            addInfo:{  type:'misura' },
            constraints:~NodeConstraints.Select,
            sourcePoint: { x: x1, y:y1-Math.round(delta/5) },
            targetPoint: { x: x1, y: y1-Math.round(delta/5)+delta*0.6 },
            targetDecorator:{ shape: "None"}
          };
          (this.diagram as Diagram).add(l1);
          let l2: ConnectorModel = {
            id: 'n'+uuidv4(),
            type: 'Straight',
            constraints:~NodeConstraints.Select,
            style: {strokeColor: 'blue'},
            addInfo:{  type:'misura' },
            sourcePoint: { x: x2, y:y1-Math.round(delta/5) },
            targetPoint: { x: x2, y: y1-Math.round(delta/5)+delta*0.6 },
            targetDecorator:{ shape: "None"}
          };
          (this.diagram as Diagram).add(l2);
        }
        if(lato=='lato_fronte'){
          let tt:any={
              id: 'n'+uuidv4(),
              addInfo:{  type:'misura' },
              constraints:~NodeConstraints.Select,
              offsetX: Math.round(x1+(x2-x1)/2),
              style: {color: 'blue',fill:'transparent'},
              offsetY: y2,
              shape: { type: 'Text', content:misura}
          };
          (this.diagram as Diagram).add(tt);
          let l1: ConnectorModel = {
            id: 'n'+uuidv4(),
            type: 'Straight',
            constraints:~NodeConstraints.Select,
            style: {strokeColor: 'blue'},
            addInfo:{  type:'misura' },
            sourcePoint: { x: x1, y:y1+Math.round(delta/5) },
            targetPoint: { x: x1, y: y1+Math.round(delta/5)-delta*0.6 },
            targetDecorator:{ shape: "None"}
          };
          (this.diagram as Diagram).add(l1);
          let l2: ConnectorModel = {
            id: 'n'+uuidv4(),
            constraints:~NodeConstraints.Select,
            type: 'Straight',
            style: {strokeColor: 'blue'},
            addInfo:{  type:'misura' },
            sourcePoint: { x: x2, y:y1+Math.round(delta/5) },
            targetPoint: { x: x2, y: y1+Math.round(delta/5)-delta*0.6 },
            targetDecorator:{ shape: "None"}
          };
          (this.diagram as Diagram).add(l2);
        }
        (this.diagram as Diagram).dataBind();
    } else {
      /*
      if(lato=='lato_sn'){
        this.drawMisuraSinistra(this.pdfStartX*this.pdfProp,this.pdfStartY*this.pdfProp,this.pdfProp,y2-y1);
        this.pdfStartY+=y2-y1;
      }
      if(lato=='lato_fronte'){
        this.drawMisureSotto(this.pdfStartX*this.pdfProp,this.pdfStartY*this.pdfProp,this.pdfProp,x2-x1,y2-y1);
        
      }
*/
      
    }
  }

  addPannelloMisura(x:number,y:number,w:number,h:number,misura:string,angle:number){
     let tt:any={
          id: 'n'+uuidv4(),
          addInfo:{  type:'misura' },
          constraints:~NodeConstraints.Select,
          offsetX: x,
          width:w,
          height:h,
          style: {color: 'blue',fill:'transparent'},
          offsetY: y,
          shape: { type: 'HTML', content:'<div style="background-color:#EFEFEF;text-align:center;width:100%;height:12px;color:Blue;">'+misura+'</div>'}
      };
      (this.diagram as Diagram).add(tt);
      if(angle!=0){
         (this.diagram as Diagram).rotate(tt,angle); 
      }
  }

  addMisureCella(n:any){
    
    const delta=50;
    const delta2=15;
    let celleCollegate:any=[];
    let misuraX=Math.round(n.width+3)+'';
    let misuraY=Math.round(n.height+3)+'';
    let volume=n.width*n.height;
    this.addPointsToConfig();
    this.cC.elencoCelle.forEach((c:any)=>{
      if(c.id==n.addInfo.id){
        this.mS.cellaDati=c;
        this.mS.objCella={
            w:this.mS.cellaDati.ingombroY,
            h:this.mS.cellaDati.altezza,
            d:this.mS.cellaDati.ingombroX,
            spessore:this.mS.cellaDati.spessore,
            cappucci:[],
            angolari:[]
          };
        this.mS.getObj(this.cC);
        celleCollegate=c.celleCollegate;
        volume*=c.altezza/1000000;
      }     
    });
    
    if(celleCollegate.filter((x:any)=>x.attivo && x.latocollegato=='lato_sn').length==0){
      this.addLineaMisura(misuraY,n.offsetX-n.width/2-delta,n.offsetY-n.height/2,n.offsetX-n.width/2-delta,n.offsetY+n.height/2,delta,'lato_sn');
    }
    if(celleCollegate.filter((x:any)=>x.attivo && x.latocollegato=='lato_ds').length==0){
      this.addLineaMisura(misuraY,n.offsetX+n.width/2+delta,n.offsetY-n.height/2,n.offsetX+n.width/2+delta,n.offsetY+n.height/2,delta,'lato_ds');
    }
    if(celleCollegate.filter((x:any)=>x.attivo && x.latocollegato=='lato_retro').length==0){
      this.addLineaMisura(misuraX,n.offsetX-n.width/2,n.offsetY-n.height/2-delta,n.offsetX+n.width/2,n.offsetY-n.height/2-delta,delta,'lato_retro');
    }
    if(celleCollegate.filter((x:any)=>x.attivo && x.latocollegato=='lato_fronte').length==0){
      this.addLineaMisura(misuraX,n.offsetX-n.width/2,n.offsetY+n.height/2+delta,n.offsetX+n.width/2,n.offsetY+n.height/2+delta,delta,'lato_fronte');
    }
    if(!this.pdfIsPrinting){
      if(n.annotations[0]){
         n.annotations[0].content=this.lang.el('vol.')+ Math.round(volume*100)/100;
      }
     
      if(this.currentLevel==this.lang.el('Mostra pareti')){
        let x=n.offsetX-Math.round(n.width/2);
        let y=n.offsetY+Math.round(n.height/2);
        if(celleCollegate.filter((x:any)=>x.attivo && x.latocollegato=='lato_fronte').length==0){
          this.mS.objFronte.pannelli.forEach((p:any,ind:number) => {
            let misura=Math.round(p.w)+'';
            if(!p.fittizio){
              this.addPannelloMisura(x+p.w/2,y+delta2,p.w,p.d,misura,0);
            }
            if(!p.sopraporta){
              x+=p.w;
            }
          });
        }
        x=n.offsetX-Math.round(n.width/2);
        y=n.offsetY-Math.round(n.height/2);
        if(celleCollegate.filter((x:any)=>x.attivo && x.latocollegato=='lato_retro').length==0){
          this.mS.objRetro.pannelli.forEach((p:any,ind:number) => {
            let misura=Math.round(p.w)+'';
            if(!p.fittizio){
             this.addPannelloMisura(x+p.w/2,y-delta2,p.w,p.d,misura,0);
            }
            if(!p.sopraporta){
              x+=p.w;
            }
            
          });
        }
        
      

        x=n.offsetX-Math.round(n.width/2);
        y=n.offsetY+Math.round(n.height/2);
        if(celleCollegate.filter((x:any)=>x.attivo && x.latocollegato=='lato_sn').length==0){
          this.mS.objLatSin.pannelli.forEach((p:any,ind:number) => {
            let misura=Math.round(p.w)+'';
            if(!p.fittizio){
               this.addPannelloMisura(x-delta2,y-p.w/2,p.w,p.d,misura,-90);
            }
            if(!p.sopraporta){
              y-=p.w;
            }
          });
        }
        x=n.offsetX+Math.round(n.width/2);
        y=n.offsetY+Math.round(n.height/2);

        if(celleCollegate.filter((c:any)=>c.attivo && c.latocollegato=='lato_ds').length==0){
          this.mS.objLatDs.pannelli.forEach((p:any,ind:number) => {

            let misura=Math.round(p.w)+'';
            if(!p.fittizio){
               this.addPannelloMisura(x+delta2,y-p.w/2,p.w,p.d,misura,-90);
            }
            if(!p.sopraporta){
              y-=p.w;
            }
          });
        }
      }
    }
  }

  mostraMisurePerCombinate(){
    // esistono combinate
        let ingombri=this.mS.calcIngombri(this.diagram);
        let cellaNonComb:any=null;
      
        
        (this.diagram as Diagram).nodes.forEach((c:any)=>{
          if(c.addInfo.type=='cella' && !c.addInfo.subtype){
           cellaNonComb=c;
          }
        });

        if(!cellaNonComb){
          return;
        }
        let arrmisure:any=this.getMisureLatoComb();
   
        let delta=50;
        let deltax=ingombri.minX-delta;

        // LATO SN
        let sy=Math.round(cellaNonComb.offsetY-cellaNonComb.height/2);
        let w=0;
        if(arrmisure['lato_sn'].length>0){
          w=arrmisure['lato_sn'][0].y-sy;
        } else{
          w=cellaNonComb.height;
        }
        this.addLineaMisura(Math.round(w)+'',deltax,sy,deltax,sy+w,delta,'lato_sn');
        sy+=w;
        arrmisure['lato_sn'].forEach((l:any,ind:number)=>{
          w=l.w;
          this.addLineaMisura(Math.round(w)+'',deltax,sy,deltax,sy+w,delta,'lato_sn');
          sy=l.y+l.w;
          if(ind<arrmisure['lato_sn'].length-1){
            w=arrmisure['lato_sn'][ind+1].y-sy;
            this.addLineaMisura(Math.round(w)+'',deltax,sy,deltax,sy+w,delta,'lato_sn');
            sy=arrmisure['lato_sn'][ind+1].y;
          }
        })
        if(arrmisure['lato_sn'].length>0){
          w=Math.round(cellaNonComb.offsetY+cellaNonComb.height/2)-sy;
          this.addLineaMisura(Math.round(w)+'',deltax,sy,deltax,sy+w,delta,'lato_sn');
        }
        // LATO DS
        deltax=ingombri.maxX+delta;
        sy=Math.round(cellaNonComb.offsetY-cellaNonComb.height/2);
        w=0;
        if(arrmisure['lato_ds'].length>0){
          w=arrmisure['lato_ds'][0].y-sy;
        } else{
          w=cellaNonComb.height;
        }
        this.addLineaMisura(Math.round(w)+'',deltax,sy,deltax,sy+w,delta,'lato_ds');
        sy+=w;
        arrmisure['lato_ds'].forEach((l:any,ind:number)=>{
          w=l.w;
          this.addLineaMisura(Math.round(w)+'',deltax,sy,deltax,sy+w,delta,'lato_ds');
          sy=l.y+l.w;
          if(ind<arrmisure['lato_ds'].length-1){
            w=arrmisure['lato_ds'][ind+1].y-sy;
            this.addLineaMisura(Math.round(w)+'',deltax,sy,deltax,sy+w,delta,'lato_ds');
            sy=arrmisure['lato_ds'][ind+1].y;
          }
        })
        if(arrmisure['lato_ds'].length>0){
          w=Math.round(cellaNonComb.offsetY+cellaNonComb.height/2)-sy;
          this.addLineaMisura(Math.round(w)+'',deltax,sy,deltax,sy+w,delta,'lato_ds');
        }
        // LATO FRONTE
        let deltay=ingombri.maxY+delta;
        let sx=Math.round(cellaNonComb.offsetX-cellaNonComb.width/2);
        w=0;
        if(arrmisure['lato_fronte'].length>0){
          w=arrmisure['lato_fronte'][0].x-sx;
        } else{
          w=cellaNonComb.width;
        }
        this.addLineaMisura(Math.round(w)+'',sx,deltay,sx+w,deltay,delta,'lato_fronte');
        sx+=w;
        arrmisure['lato_fronte'].forEach((l:any,ind:number)=>{
          w=l.w;
          this.addLineaMisura(Math.round(w)+'',sx,deltay,sx+w,deltay,delta,'lato_fronte');
          sx=l.x+l.w;
          if(ind<arrmisure['lato_fronte'].length-1){
            w=arrmisure['lato_fronte'][ind+1].x-sx;
            this.addLineaMisura(Math.round(w)+'',sx,deltay,sx+w,deltay,delta,'lato_fronte');
            sx=arrmisure['lato_fronte'][ind+1].x;
          }
        })
        if(arrmisure['lato_fronte'].length>0){
          w=Math.round(cellaNonComb.offsetX+cellaNonComb.width/2)-sx;
          this.addLineaMisura(Math.round(w)+'',sx,deltay,sx+w,deltay,delta,'lato_fronte');
        }
        // LATO RETRO
        deltay=ingombri.minY-delta;
        sx=Math.round(cellaNonComb.offsetX-cellaNonComb.width/2);
        w=0;
        if(arrmisure['lato_retro'].length>0){
          w=arrmisure['lato_retro'][0].x-sx;
        } else{
          w=cellaNonComb.width;
        }
        this.addLineaMisura(Math.round(w)+'',sx,deltay,sx+w,deltay,delta,'lato_retro');
        sx+=w;
        arrmisure['lato_retro'].forEach((l:any,ind:number)=>{
          w=l.w;
          this.addLineaMisura(Math.round(w)+'',sx,deltay,sx+w,deltay,delta,'lato_retro');
          sx=l.x+l.w;
          if(ind<arrmisure['lato_retro'].length-1){
            w=arrmisure['lato_retro'][ind+1].x-sx;
            this.addLineaMisura(Math.round(w)+'',sx,deltay,sx+w,deltay,delta,'lato_retro');
            sx=arrmisure['lato_retro'][ind+1].x;
          }
        })
        if(arrmisure['lato_retro'].length>0){
          w=Math.round(cellaNonComb.offsetX+cellaNonComb.width/2)-sx;
          this.addLineaMisura(Math.round(w)+'',sx,deltay,sx+w,deltay,delta,'lato_retro');
        }
  }

  

  showHideMostraMisure(){

    if(!this.checkFormIsValid()){
      return;
    }
    if(this.mostraMisure){
      this.currentLevel=this.lang.el('Mostra pareti');
   
    
     let nodi:any[]=[];
      (this.diagram as Diagram).nodes.forEach((c:any)=>{
        if(c.addInfo.type=='cella'){
          nodi.push(c);
        }
      });
      this.hideShowElements();
      nodi.forEach((x:any)=>{
        this.addMisureCella(x);
      });
     
    } else {
        this.removeMisure();
        this.currentLevel=this.lang.el('Mostra celle');
        this.hideShowElements();
          
      this.bringToFront(null);
    
    }
  }

  getMisureLatoComb(){
    let arrc:any={
      lato_sn:[],
      lato_ds:[],
      lato_fronte:[],
      lato_retro:[],
    };
    (this.diagram as Diagram).nodes.forEach((c:any)=>{
      if(c.addInfo.type=='cella' && c.addInfo.subtype ){
        let w:number=0;
        let x:number=0;
        let y:number=0;
        let lato:string='';
        switch(c.addInfo.subtype){
          case 'cellacombinatatop':
            w=c.width;
            lato='lato_fronte';
            x=Math.round(c.offsetX-c.width/2);
            y=Math.round(c.offsetY-c.height/2);
            break;
        case 'cellacombinatabottom':
            w=c.width;
            lato='lato_retro';
            x=Math.round(c.offsetX-c.width/2);
            y=Math.round(c.offsetY-c.height/2);
            break;
        case 'cellacombinataleft':
            w=c.height;
            lato='lato_ds';
            x=Math.round(c.offsetX-c.width/2);
            y=Math.round(c.offsetY-c.height/2);
            break;
        case 'cellacombinataright':
            w=c.height;
            lato='lato_sn';
            x=Math.round(c.offsetX-c.width/2);
            y=Math.round(c.offsetY-c.height/2);
            break;
        }
       
        arrc[lato].push({
          w:w,
          x:x,
          y:y,
        });
      }
    });
    arrc['lato_sn'].sort((a:any, b:any) => (a.s > b.s ? -1 : 1));
    arrc['lato_ds'].sort((a:any, b:any) => (a.s > b.s ? -1 : 1));
    arrc['lato_fronte'].sort((a:any, b:any) => (a.s > b.s ? -1 : 1));
    arrc['lato_retro'].sort((a:any, b:any) => (a.s > b.s ? -1 : 1));
    return arrc;
  }

  removeMisure(){
    let nl:any=[];
      (this.diagram as Diagram).nodes.forEach((c:any)=>{
        if(c.addInfo.type=='misura'){
          nl.push(c);
        }
        if(c.addInfo.type=='cella'){
          if(c.annotations.length>0)
            c.annotations[0].content='';
        }
        
      });
      nl.forEach((n:any)=>{
          (this.diagram as Diagram).remove(n);
      })
      for (let i = 0; i < this.diagram.connectors.length; i++) {
        let connector = this.diagram.connectors[i];
        if (connector.sourceID === '' || connector.targetID === '') {
            this.diagram.remove(connector);
          --i;
        }
      }
  }

  public getCommandManagerSettings(): CommandManagerModel {
    let commandManager: CommandManagerModel = {
      commands: [{
        name: 'DeleteNode',
        canExecute: function () {
          let diagram = (document.getElementById('diagram') as any).ej2_instances[0]
          if (diagram.selectedItems.nodes.length > 0 || diagram.selectedItems.connectors.length > 0) {
            return true;
          }
          return false;
        },
        execute: (): void => {
        let diagram = (document.getElementById('diagram') as any).ej2_instances[0];
        let isScaffale=false;
        diagram.selectedItems.nodes.forEach((n:any)=>{
          if(n.addInfo.type=='scaffale'){
            isScaffale=true;
          }
        });
     //   if(!this.mS.userCellePreConf() || isScaffale){
      if(!this.mS.userCellePreConf() ){
         if(this.diagram.selectedItems.nodes.length>1){
          return;
         } 
         this.confirmationService.confirm({
            message: this.lang.el('Si conferma la cancellazione?'),
            header: this.lang.el('Conferma'),
            closeOnEscape: true,
            icon: 'pi pi-exclamation-triangle',
            rejectLabel:this.lang.el('Annulla'),
            acceptLabel:this.lang.el('Conferma'),
            accept: () => {
              let selectedNodes =[...this.diagram.selectedItems.nodes];
           
              for (let x = 0; x < selectedNodes.length; x++) {
                switch(selectedNodes[x].addInfo.type)
                {
                  case 'divisorioorizz':
                  case 'divisoriovert':
                    for(let j=0;j<this.cC.elencoCelle.length;j++){
                      this.cC.elencoCelle[j].divisori.forEach((p:any,ind:number)=>{
                        if(p.id==selectedNodes[x].addInfo.id){
                          this.cC.elencoCelle[j].divisori.splice(ind,1);
                        }
                      });
                    }
                    this.diagram.remove(selectedNodes[x]);
                    break;
                  case 'cella':
                    for(let j=0;j<this.cC.elencoCelle.length;j++){
                      if(this.cC.elencoCelle[j].id==selectedNodes[x].addInfo.id){
                          this.cC.elencoCelle.splice(j,1);
                      }
                    }
                    this.diagram.remove(selectedNodes[x]);
                    break;
                  case 'freeblock':
                   for(let j=0;j<this.cC.elencoFreeBlocks.length;j++){
                      if(this.cC.elencoFreeBlocks[j].id==selectedNodes[x].addInfo.id){
                          this.cC.elencoFreeBlocks.splice(j,1);
                      }
                    }
                    this.diagram.remove(selectedNodes[x]);
                    break;
                  case 'dropin':
                   for(let j=0;j<this.cC.elencoDropin.length;j++){
                      if(this.cC.elencoDropin[j].id==selectedNodes[x].addInfo.id){
                          this.cC.elencoDropin.splice(j,1);
                      }
                    }
                    this.diagram.remove(selectedNodes[x]);
                    break;
                  case 'impiantoRemoto':
                       for(let j=0;j<this.cC.elencoImpiantiRemoti.length;j++){
                      if(this.cC.elencoImpiantiRemoti[j].id==selectedNodes[x].addInfo.id){
                          this.cC.elencoImpiantiRemoti.splice(j,1);
                      }
                    }
                    this.diagram.remove(selectedNodes[x]);
                    break;  
                  case 'scaffale':
                   for(let j=0;j<this.cC.elencoScaffali.length;j++){
                      if(this.cC.elencoScaffali[j].id==selectedNodes[x].addInfo.id){
                          this.cC.elencoScaffali.splice(j,1);
                      }
                    }
                    this.diagram.remove(selectedNodes[x]);
                    break;
                  case 'porta':
                    if(selectedNodes[x].addInfo.portaDivisorio){
                      this.mS.message=this.lang.el('Porta divisorio: impossibile cancellare');
                      break;
                    }
                    for(let j=0;j<this.cC.elencoCelle.length;j++){
                      this.cC.elencoCelle[j].elencoPorte.forEach((p:any,ind:number)=>{
                        if(p.id==selectedNodes[x].addInfo.id){
                          this.cC.elencoCelle[j].elencoPorte.splice(ind,1);
                        }
                      });
                     
                    }
                     this.cC.elencoPorteScollegate.forEach((p:any,ind:number)=>{
                        if(p.id==selectedNodes[x].addInfo.id){
                          this.cC.elencoPorteScollegate.splice(ind,1);
                        }
                      });
                    this.diagram.remove(selectedNodes[x]);
                    break;
                }
              }
            },
            reject: () => {
              
            },
          });
    
        }
          
        },
        gesture: {
          key: Keys.Delete,

        }
      }]

    }
    return commandManager;
  };

  
  


  public creaPDF2(what='PDF',sendToServer=null){


    this.pdfOrdDxf=what; 
    let cx=10;
    let cy=10;
    let maxW=0;
    let maxH=0;
    this.pdfIsPrinting=true;

    if(sendToServer){
        let esisteCella=false;
        (this.diagram as Diagram).nodes.forEach((node:any)=>{
          if(node.addInfo.type=='cella'){
            esisteCella=true;
          }
        });
        if(!esisteCella){
            setTimeout(() => {
              window.location.reload();
            }, 1100);
            return;
        }
    }
    if(this.tipoStampa=='all' && what=='PDF' && this.formatoStampa=='a4'){
      this.formatoStampa='a3';
    }
    this.pdf= new JSPDF.jsPDF('l','mm',this.formatoStampa);
    this.dxf = new DxfWriter(); 
    this.dxf.setUnits('Centimeters'); 
    let paginaW=this.pdf.internal.pageSize.getWidth();
    let paginaH=this.pdf.internal.pageSize.getHeight();
    this.pdf.setLineWidth(.05);
    let ingombri=this.mS.calcIngombri(this.diagram);  
    maxW=ingombri.maxX-ingombri.minX;
    maxH=ingombri.maxY-ingombri.minY;



    this.showDialogPrint=false;
    if(what=='PDF'){
      this.pdfProp=paginaW/maxW*0.5;
      if(paginaW/maxW>paginaH/maxH){
        this.pdfProp=paginaH/maxH*0.5;
      }
    } else {
      this.pdfProp=1;
    }
    
  
    cy=(paginaH/this.pdfProp-maxH)/2.5;
    cx=(paginaW/this.pdfProp-maxW)/2;
    
    let cxIni=(paginaW/this.pdfProp-maxW)/2;
    let cyIni=(paginaH/this.pdfProp-maxH)/2.5;
    if(this.tipoStampa=='all'){
    
      paginaW=paginaW/2;
      paginaH=paginaH/2;  
      if(what=='PDF'){
        if(this.formatoStampa=='a3'){
          this.pdfProp=paginaW/maxW*0.47;
          if(paginaW/maxW>paginaH/maxH){
            this.pdfProp=paginaH/maxH*0.47;
          }
        } else {
          this.pdfProp=paginaW/maxW*0.57;
          if(paginaW/maxW>paginaH/maxH){
            this.pdfProp=paginaH/maxH*0.57;
          }
        }
        cy=(paginaH/this.pdfProp-maxH)/1.5;
        cx=(paginaW/this.pdfProp-maxW)/2;
      
        cxIni=(paginaW/this.pdfProp-maxW)/2;
        cyIni=(paginaH/this.pdfProp-maxH)/1.5;
      } 
      
    
    
      this.disegnaPdf2('pareti',paginaW,maxH,cx,cy,ingombri);
      if(what=='PDF'){
        cx=cxIni+(this.pdf.internal.pageSize.getWidth()/2)/this.pdfProp;
        cy=cyIni;
      } else {
        cx=cxIni+maxW*2;
        cy=cyIni;
      }
      this.disegnaPdf2('soffitto',paginaW,maxH,cx,cy,ingombri);
      if(what=='PDF'){
        cx=cxIni;
        cy=cyIni+(this.pdf.internal.pageSize.getHeight()/2.5)/this.pdfProp;
      } else {
        cx=cxIni;
        cy=cyIni+maxH*2;
      }
      this.disegnaPdf2('pavimento',paginaW,maxH,cx,cy,ingombri);

    }

    if(this.tipoStampa=='soffitto'){
      this.disegnaPdf2('soffitto',paginaW,maxH,cx,cy,ingombri);
    }
    if(this.tipoStampa=='pavimento'){
      this.disegnaPdf2('pavimento',paginaW,maxH,cx,cy,ingombri);
    }

    if(this.tipoStampa=='pareti'){
      if(sendToServer){
        this.disegnaPdf2('pareti',paginaW,maxH,cx,cy,ingombri,false);
      } else {
        this.disegnaPdf2('pareti',paginaW,maxH,cx,cy,ingombri);
      }
    
    }

    if(what=='PDF'){
      if(sendToServer){
    //      this.saving=true;
          const pdfBlob = this.pdf.output('blob');
          const formData = new FormData();
          formData.append('file', pdfBlob, 'documento.pdf');
          this.apiService.uploadpost('app/upploadpianta/'+sendToServer,formData).subscribe((data:any)=>{
            // this.saving=false;
            setTimeout(() => {
              this.mS.isSaving=false;
              window.location.reload();
            }, 1000);
          });
      } else {
        this.drawCartiglio(this.formatoStampa);
        this.pdf.save(this.lang.el('Tavole disegni')+'.pdf');
      }
    
    } else {
     
      this.downloadDxfFile(this.dxf.toDxfString(), 'dxffile.dxf');
    }
   
    this.pdfIsPrinting=false;

  }

  
public disegnaPdf2(what:string,paginaW:number,paginaH:number,startx:number,starty:number,ingombri:any,stampaTitolo=true){
 
    let label:string='';
    let cx:number=0;
    let cy:number=0;
    let nodoCella:any=null;
    let misura:any={
      cx:startx,
      cy:starty
    };
    // check se esiste pavimento
    let esistepavimento=false;
    this.cC.elencoCelle.forEach((c:any,ind:number)=>{
      if(c.pavimenti){
        esistepavimento=true;
      }
     });

    if(what=='pavimento' && !esistepavimento){
      return;
    }
    switch (what){
      case 'soffitto':
        label=this.lang.el('Piano soffitto');
        break;
      case 'pavimento':
        label=this.lang.el('Piano pavimento');
        break;
      case 'pareti':
        label=this.lang.el('Piano pareti');
        break;
    }
    if(!stampaTitolo){
      label='';
    }
    this.pdf.setFont("courier");
    this.pdf.setFontSize(12).setFont(undefined, 'normal').text(label,startx*this.pdfProp,starty*this.pdfProp-12,{
      align: 'left'
    });
    
    this.addPointsToConfig();
    this.celleCollegateList=[];
    this.cC.elencoCelle.forEach((c:any,ind:number)=>{

      this.mS.cellaDati=c;

      if(what!='pavimento' || this.mS.cellaDati.pavimenti){
     

        (this.diagram as Diagram).nodes.forEach((node:any)=>{
          if(node.addInfo.type=='cella' && node.addInfo.id==c.id){
            cx=startx+Math.round(node.offsetX-node.width/2)-ingombri.minX;
            cy=starty+Math.round(node.offsetY-node.height/2)-ingombri.minY;
            nodoCella=node;
          }
        });
        
        if(ind==0){
          misura.larg=c.ingombroX;
          misura.alt=c.ingombroY;
        }
        
      
        this.mS.cellaDati.celleCollegate.forEach((c:any)=>{
          if(!c.latocombinato && c.tipoCollegamento!='unite' && c.latocollegato=='lato_fronte'){
            cy-=(3+this.mS.cellaDati.spessore);   
          }
          if(!c.latocombinato && c.tipoCollegamento!='unite' && c.latocollegato=='lato_retro'){
            cy+=(3+this.mS.cellaDati.spessore);   
          }
          if(!c.latocombinato && c.tipoCollegamento!='unite' && c.latocollegato=='lato_sn'){
            cx+=(this.mS.cellaDati.spessore+3);
          }
          if(!c.latocombinato && c.tipoCollegamento!='unite' && c.latocollegato=='lato_ds'){
            cx-=(this.mS.cellaDati.spessore+3);
          }
        });


        if((this.mS.cellaDati)&&(this.mS.cellaDati.ingombroX>0)&&(this.mS.cellaDati.altezza>0)&&(this.mS.cellaDati.ingombroY>0)){
          this.mS.objCella={
                w:this.mS.cellaDati.ingombroY,
                h:this.mS.cellaDati.altezza,
                d:this.mS.cellaDati.ingombroX,
                spessore:this.mS.cellaDati.spessore,
                cappucci:[],
                angolari:[]
              };
          this.mS.getObj(this.cC);
          switch (what){
            case 'soffitto':
              this.disegnaPdfCellaSoffitto2(cx,cy,nodoCella,startx,starty,paginaH);
              break;
            case 'pavimento':

              this.disegnaPdfCellaPavimento2(cx,cy,nodoCella,startx,starty,paginaH);
              break;
            case 'pareti':
              this.disegnaPdfCellaPareti(cx,cy,nodoCella,startx,starty,paginaH);
              break;
          }
        }
      }
      
    });
   
    if(false){ 
      let legendaSotto=true;
      let legendaSin=true;
      (this.diagram as Diagram).nodes.forEach((node:any)=>{
        if(node.addInfo.type=='cella' && node.addInfo.id==this.mS.cellaDati.id){
          this.pdfStartX=startx+Math.round(node.offsetX-node.width/2)-ingombri.minX;
          this.pdfStartY=starty+Math.round(node.offsetY-node.height/2)-ingombri.minY;
          let cellaH=node.height;
          let cellaW=node.width;
          this.mS.cellaDati.celleCollegate.forEach((c:any)=>{
            if(c.latocollegato=='lato_fronte'){
              legendaSotto=false;
            }
          
            if(c.latocollegato=='lato_sn'){
            legendaSin=false;
            }
          });
          if(legendaSotto){
            this.drawMisureSotto(this.pdfStartX*this.pdfProp,this.pdfStartY*this.pdfProp,this.pdfProp,cellaW);
          }
          if(legendaSin){
            this.drawMisuraSinistra(startx*this.pdfProp,this.pdfStartY*this.pdfProp,this.pdfProp,cellaH);
          }
        }
      });
     }

  }

  getIdCollegatiRicorsivi(elencoCelle: any[], startId: number): number[] {
  // 1. Crea una mappa per accesso rapido O(1)
  const mappaCelle = new Map(elencoCelle.map(c => [c.id, c.celleCollegate.filter((x:any)=>x.tipoCollegamento=='unite')]));
  
  const visitati = new Set<number>();
  const daVisitare = [startId];

  while (daVisitare.length > 0) {
    const attualeId = daVisitare.pop()!;
    
    if (!visitati.has(attualeId)) {
      visitati.add(attualeId);
      
      // Recupera i collegamenti dalla mappa
      const collegamenti = mappaCelle.get(attualeId) || [];
      for (const connessione of collegamenti) {
        if (!visitati.has(connessione.cellaCollegataId)) {
          daVisitare.push(connessione.cellaCollegataId);
        }
      }
    }
  }

 
  return Array.from(visitati);
}


  disegnaPdfCellaPareti(cx:number,cy:number,nodoCella:any,startx:number,starty:number,paginaH:number){
    var marg=1.5;
    let testo='';
    let testoVol='';
    let testoPav='';

    if(!this.celleCollegateList.includes(this.mS.cellaDati.id)){

      let uniteArr=this.getIdCollegatiRicorsivi(this.cC.elencoCelle,this.mS.cellaDati.id);
      let vol=0;
      uniteArr.forEach((u:any)=>{
        let cCell=this.cC.elencoCelle.filter((c:any)=>c.id==u)[0];

        testo=this.lang.el('Alt.:')+cCell.altezza+' '+this.lang.el('Spess.:')+cCell.spessore;
        if(cCell.pavimenti){
          const finOpt=this.mS.finituraPavimentoOptions.find((o:any)=>o.value===this.mS.cellaDati.finituraPavimento);
          testoPav=this.lang.el('Pav.:')+(finOpt?finOpt.label:this.mS.cellaDati.finituraPavimento);
        }
        if(cCell.vespaio){
          testoPav+=' '+this.lang.el('Passo vespaio.:')+cCell.passo;
        }
        vol+=((cCell.ingombroX+3)*(cCell.ingombroY+3)*(cCell.altezza+3)/1000000);
      });
      testoVol=this.lang.el('Vol.:')+vol.toFixed(2)+'m^3';
    
      
      this.celleCollegateList=[...this.celleCollegateList,...uniteArr]; 
    }

    var context = this.pdf.context2d;
    if(this.mS.objCella.spessore==13){
      marg=0;
    } 
    context.lineWidth =.1;
    this.pdf.setFontSize(8).setFont(undefined, 'normal');
    let dim=this.pdf.getTextDimensions('1200');
    let factor=this.pdfProp;
    let primoPannSpessore=0;
    let ultimoPannSpessore=0;
    let curx=(cx-(this.mS.cellaDati.spessore)/2)*factor;
    let cury=(cy+(this.mS.cellaDati.spessore)/2)*factor;

    

    curx=(cx+(marg+this.mS.cellaDati.spessore)/2)*factor;
    cury=(cy-(marg+this.mS.cellaDati.spessore)/2)*factor;
    if(testo!=''){
      let dimtesto=this.pdf.getTextDimensions(testo);
      this.pdf.text(testo,curx+this.mS.cellaDati.ingombroX*factor/2-dimtesto.w/2,cury+this.mS.cellaDati.ingombroY*factor/2,{
            align: 'left',
        });
      
      if(testoPav!=''){
        dimtesto=this.pdf.getTextDimensions(testoPav);
        this.pdf.text(testoPav,curx+this.mS.cellaDati.ingombroX*factor/2-dimtesto.w/2,cury+dimtesto.h*2+this.mS.cellaDati.ingombroY*factor/2,{
            align: 'left',
        });
      }  
    
      dimtesto=this.pdf.getTextDimensions(testoVol);
      this.pdf.text(testoVol,curx+this.mS.cellaDati.ingombroX*factor/2-dimtesto.w/2,cury+dimtesto.h*4+this.mS.cellaDati.ingombroY*factor/2,{
            align: 'left',
        });
      
    }
    this.mS.objRetro.pannelli.forEach((p:any,ind:number) => {
      if(!p.fittizio){
        if(ind==0){
          primoPannSpessore=p.d;
        }
        ultimoPannSpessore=p.d;
        

        this.doRect(curx,cury,p.w*factor,p.d*factor);
        if(this.pdfOrdDxf=='PDF'){
          let dim=this.pdf.getTextDimensions((p.w*10).toString());
          this.pdf.text((p.w*10).toString(),curx+p.w*factor/2-dim.w/2,cury-dim.h,{
              align: 'left',
          });
        } else {
          let dim={
            h:5,
            w:0.65*(p.w*10).toString().length*5
          }
          this.dxf.drawText(curx+p.w*factor/2-dim.w/2,-cury+2*dim.h,5,0,(p.w*10).toString());
        }
      
        if(p.fb){
          this.doRectArr(curx,cury-40*factor,80*factor,40*factor,false,true,p.fbCode);
          this.doRectArr(curx,cury,80*factor,this.mS.cellaDati.spessore*factor,true,false);
          this.doRectArr(curx+5*factor,cury,70*factor,30*factor);
        }
       
        if(p.porta){       
       
              let deltaP=0;
              let luce=p.w;
              if(p.porta.luceNetta && p.porta.luceNetta!=''){
                let t=parseInt(p.porta.luceNetta.split('X')[0]);
                deltaP=(p.w-t)/2;
                luce=t;
              }

              if(p.porta.versoAperturaPorta!=2){
                let manigliaw=p.w*factor/8;
                let manigliah=p.w*factor/30;
                this.doRect(curx,cury,p.w*factor,-1*p.d*factor);
                this.doRect(curx+(deltaP+luce)*factor-manigliaw,cury-1*p.d*factor,manigliaw,-manigliah);
                if(!p.porta.scorrevole){
                  this.doArc(curx+deltaP*factor, cury, luce*factor,-1*Math.PI/2,0);
                  this.doLine(curx+deltaP*factor,cury,curx+deltaP*factor,cury-luce*factor);
                }
              } else {
                let manigliaw=p.w*factor/8;
                let manigliah=p.w*factor/30;
                this.doRect(curx,cury,p.w*factor,-1*p.d*factor);
                this.doRect(curx+(deltaP)*factor,cury-1*p.d*factor,manigliaw,-manigliah);
                if(!p.porta.scorrevole){
                  this.doArc(curx+(deltaP+luce)*factor, cury, luce*factor,-1*Math.PI,-1*Math.PI/2);
                  this.doLine(curx+(deltaP+luce)*factor,cury,curx+(deltaP+luce)*factor,cury-luce*factor);
                }
            }
            let testoprta=p.porta.luceNetta;
            let dim=this.pdf.getTextDimensions(testoprta);
            this.pdf.text(testoprta,curx+p.w*factor/2-dim.w/2,cury-p.w/6*factor-dim.h,{
                align: 'left',
            });
          }
        
      }
      if(!p.sopraporta){
        curx+=p.w*factor;
      }
      
    });

    curx=(cx+(marg+this.mS.cellaDati.spessore)/2)*factor;;
    cury=(cy+marg+(marg+this.mS.cellaDati.spessore)/2)*factor+this.mS.objCella.w*factor;
    this.drawMisureSotto((cx+(this.mS.cellaDati.spessore)/2)*factor,(starty+paginaH)*factor,this.pdfProp,this.mS.cellaDati.ingombroX+3);
    this.mS.objFronte.pannelli.forEach((p:any) => {
      if(!p.fittizio){
        this.doRect(curx,cury,p.w*factor,p.d*factor);
        if(this.pdfOrdDxf=='PDF'){
          let dim=this.pdf.getTextDimensions((p.w*10).toString());
          this.pdf.text((p.w*10).toString(),curx+p.w*factor/2-dim.w/2,cury+dim.h*marg,{
              align: 'left',
          });
        } else {
          let dim={
            h:5,
            w:0.65*(p.w*10).toString().length*5
          }
          this.dxf.drawText(curx+p.w*factor/2-dim.w/2,-cury-3.5*dim.h,5,0,(p.w*10).toString());
        }
        
        if(p.fb){
      
          this.doRectArr(curx,cury,80*factor,40*factor,false,true,p.fbCode);
          this.doRectArr(curx,cury,80*factor,this.mS.cellaDati.spessore*factor,true,false);
          this.doRectArr(curx+5*factor,cury-30*factor,70*factor,30*factor);
        }
       
        if(p.porta){
          let deltaP=0;
          let luce=p.w;
          if(p.porta.luceNetta && p.porta.luceNetta!=''){
            let t=parseInt(p.porta.luceNetta.split('X')[0]);
            deltaP=(p.w-t)/2;
            luce=t;
          }
        
          if(p.porta.versoAperturaPorta!=2){
            let manigliaw=p.w*factor/8;
            let manigliah=p.w*factor/30;
            this.doRect(curx,cury+p.d*factor,p.w*factor,p.d*factor);
            this.doRect(curx+deltaP*factor,cury+1*p.d*factor*2,manigliaw,manigliah);
            if(!p.porta.scorrevole){
              this.doArc(curx+(deltaP+luce)*factor, cury+1*p.d*factor, luce*factor,Math.PI/2,Math.PI);
              this.doLine(curx+(deltaP+luce)*factor,cury+p.d*factor,curx+(deltaP+luce)*factor,cury+1*p.d*factor+luce*factor);
            }
          } else {
            let manigliaw=p.w*factor/8;
            let manigliah=p.w*factor/20;
            this.doRect(curx,cury+p.d*factor,p.w*factor,p.d*factor);
            this.doRect(curx+(deltaP+luce)*factor-manigliaw,cury+p.d*factor*2,manigliaw,manigliah);
            if(!p.porta.scorrevole){
              this.doArc(curx+deltaP*factor, cury+p.d*factor, luce*factor,0,Math.PI/2);
              this.doLine(curx+deltaP*factor,cury+p.d*factor,curx+deltaP*factor,cury+p.d*factor+luce*factor);
            }
          }
          let testoprta=p.porta.luceNetta;
          let dim=this.pdf.getTextDimensions(testoprta);
          this.pdf.text(testoprta,curx+p.w*factor/2-dim.w/2,cury+p.w/3*factor-dim.h,{
              align: 'left',
          });
        }
      }
      if(!p.sopraporta){
         curx+=p.w*factor;
      }
     
    });
    
    
    curx=(cx-(marg+this.mS.cellaDati.spessore)/2)*factor;
    cury=(cy+(marg+this.mS.cellaDati.spessore)/2)*factor+this.mS.objCella.w*factor;
    this.drawMisuraSinistra(startx*factor,(cy+(this.mS.cellaDati.spessore)/2)*factor,this.pdfProp,this.mS.cellaDati.ingombroY+3);
    this.mS.objLatSin.pannelli.forEach((p:any) => {
      if(!p.fittizio){
        this.doRect(curx,cury,p.d*factor,-p.w*factor);
        
        if(this.pdfOrdDxf=='PDF'){
          let dim=this.pdf.getTextDimensions((p.w*10).toString());
          this.pdf.text((p.w*10).toString(),curx-dim.h,cury+dim.w/2-p.w*factor/2,{
              align: 'left',
              angle:90
          });
        } else {
          let dim={
            h:5,
            w:0.65*(p.w*10).toString().length*5
          }
          this.dxf.drawText(curx-1.5*dim.h,-cury+p.w/2-dim.w,5,90,(p.w*10).toString());
        }

        if(p.fb){
          this.doRectArr(curx-40*factor,cury-80*factor,40*factor,80*factor,false,true,p.fbCode,true);
          
          this.doRectArr(curx,cury-80*factor,this.mS.cellaDati.spessore*factor,80*factor,true,false);
          this.doRectArr(curx+this.mS.cellaDati.spessore*factor,cury-80*factor+5*factor,30*factor,70*factor);
        }
       
        if(p.porta){
        
            let deltaP=0;
            let luce=p.w;
            if(p.porta.luceNetta && p.porta.luceNetta!=''){
              let t=parseInt(p.porta.luceNetta.split('X')[0]);
              deltaP=(p.w-t)/2;
              luce=t;
            }
            if(p.porta.versoAperturaPorta!=2){
              let manigliaw=p.w*factor/8;
              let manigliah=p.w*factor/30;
              this.doRect(curx,cury,-p.d*factor,-p.w*factor);
              this.doRect(curx-p.d*factor,cury-(deltaP+luce)*factor,-manigliah,manigliaw);
              if(!p.porta.scorrevole){
                this.doArc(curx, cury-deltaP*factor, luce*factor,-1*Math.PI,-1*Math.PI/2);
                this.doLine(curx,cury-deltaP*factor,curx-luce*factor,cury-deltaP*factor);
              }
            } else {
              let manigliaw=p.w*factor/8;
              let manigliah=p.w*factor/30;
              this.doRect(curx,cury,-p.d*factor,-p.w*factor);
              this.doRect(curx-p.d*factor,cury-(deltaP)*factor-manigliaw,-manigliah,manigliaw);
              if(!p.porta.scorrevole){
                this.doArc(curx, cury-(deltaP+luce)*factor, luce*factor,Math.PI/2,Math.PI);
                this.doLine(curx,cury-(deltaP+luce)*factor,curx-luce*factor,cury-(deltaP+luce)*factor);
              }
          }
          let testoprta=p.porta.luceNetta;
          let dim=this.pdf.getTextDimensions(testoprta);
          this.pdf.text(testoprta,curx-p.w/5*factor,cury+p.w*factor/2-dim.w/2,{
              align: 'left',
              angle:90
          });
        }
      }

      if(!p.sopraporta){
        cury-=p.w*factor;
      }
   
    });

 
  
    curx=(cx+marg+(marg+this.mS.cellaDati.spessore)/2)*factor+this.mS.objCella.d*factor;
    cury=(cy+(marg+this.mS.cellaDati.spessore)/2)*factor+this.mS.objCella.w*factor;

    this.mS.objLatDs.pannelli.forEach((p:any) => {
      if(!p.fittizio){
        this.doRect(curx,cury,p.d*factor,-p.w*factor);
        if(this.pdfOrdDxf=='PDF'){
          let dim=this.pdf.getTextDimensions((p.w*10).toString());
          this.pdf.text((p.w*10).toString(),curx+dim.h*marg,cury+dim.w/2-p.w*factor/2,{
              align: 'left',
              angle:90
          });
        } else {
          let dim={
            h:5,
            w:0.65*(p.w*10).toString().length*5
          }
          this.dxf.drawText(curx+4.5*dim.h,-cury+p.w/2-dim.w,5,90,(p.w*10).toString());
        }

        if(p.fb){
          this.doRectArr(curx,cury-80*factor,40*factor,80*factor,false,true,p.fbCode,true);
          this.doRectArr(curx,cury-80*factor,this.mS.cellaDati.spessore*factor,80*factor,true,false);
          this.doRectArr(curx-30*factor,cury-80*factor+5*factor,30*factor,70*factor);
        }
       
        if(p.porta){
            let deltaP=0;
            let luce=p.w;
            if(p.porta.luceNetta && p.porta.luceNetta!=''){
              let t=parseInt(p.porta.luceNetta.split('X')[0]);
              deltaP=(p.w-t)/2;
              luce=t;
            }
      
          if(p.porta.versoAperturaPorta!=2){
              let manigliaw=p.w*factor/8;
              let manigliah=p.w*factor/30;
              this.doRect(curx+p.d*factor,cury,p.d*factor,-p.w*factor);
              this.doRect(curx+p.d*factor+p.d*factor,cury-deltaP*factor,-manigliah,manigliaw);
              if(!p.porta.scorrevole){
                this.doArc(curx+p.d*factor, cury-(deltaP+luce)*factor, luce*factor,0,Math.PI/2);
                this.doLine(curx+p.d*factor,cury-(deltaP+luce)*factor,curx+luce*factor+p.d*factor,cury-(deltaP+luce)*factor);
              }
            } else {
              let manigliaw=p.w*factor/8;
              let manigliah=p.w*factor/30;
              this.doRect(curx+p.d*factor,cury,p.d*factor,-p.w*factor);
              this.doRect(curx+p.d*factor+p.d*factor,cury-(deltaP+luce)*factor,-manigliah,manigliaw);
              if(!p.porta.scorrevole){
                this.doArc(curx+p.d*factor, cury-deltaP*factor, luce*factor,-1*Math.PI/2,0);
                this.doLine(curx+p.d*factor,cury-deltaP*factor,curx+luce*factor+p.d*factor,cury-deltaP*factor);
              }
          }
          let testoprta=p.porta.luceNetta;
          let dim=this.pdf.getTextDimensions(testoprta);
          this.pdf.text(testoprta,curx+p.w/3*factor,cury+p.w*factor/2-dim.w/2,{
              align: 'left',
              angle:90
          });
        }
      }
      if(!p.sopraporta){
        cury-=p.w*factor;
      }
    });

    curx=cx*factor;
    cury=cy*factor;

    this.mS.objCella.objDivisori.forEach((d:any)=>{
      if(d.type!='divisorioorizz'){
        curx+=d.z*factor;
        cury+=this.mS.cellaDati.ingombroY*factor;
      } else {
        cury+=(this.mS.cellaDati.ingombroY-d.x)*factor;
      }
      if(d.type!='divisorioorizz'){
        d.pannelli.forEach((p:any) => {
          if(!p.fittizio){
            this.doRect(curx,cury,p.d*factor,-p.w*factor);
            let dim=this.pdf.getTextDimensions((p.w*10).toString());
            this.pdf.text((p.w*10).toString(),curx+dim.h*marg,cury+dim.w/2-p.w*factor/2,{
                align: 'left',
                angle:90
            });
            
            if(p.porta){
              if(p.porta.lato_porta=='lato_sn'){
                if(p.porta){
                 
                    let deltaP=0;
                    let luce=p.w;
                    if(p.porta.luceNetta && p.porta.luceNetta!=''){
                      let t=parseInt(p.porta.luceNetta.split('X')[0]);
                      deltaP=(p.w-t)/2;
                      luce=t;
                    }
                    if(p.porta.versoAperturaPorta!=2){
                      let manigliaw=p.w*factor/8;
                      let manigliah=p.w*factor/30;
                      this.doRect(curx-p.d*factor,cury,-p.d*factor,-p.w*factor);
                      this.doRect(curx-p.d*factor-p.d*factor,cury-deltaP*factor,-manigliah,manigliaw);
                      if(!p.porta.scorrevole){
                        this.doArc(curx-p.d*factor, cury-deltaP*factor, luce*factor,-1*Math.PI,-1*Math.PI/2);
                        this.doLine(curx-p.d*factor,cury-deltaP*factor,curx-luce*factor-p.d*factor,cury-deltaP*factor);
                      }
                    } else {
                      let manigliaw=p.w*factor/8;
                      let manigliah=p.w*factor/30;
                      this.doRect(curx-p.d*factor,cury,-p.d*factor,-p.w*factor);
                      this.doRect(curx-p.d*factor-p.d*factor,cury-(deltaP+luce)*factor,-manigliah,manigliaw);
                      if(!p.porta.scorrevole){
                        this.doArc(curx-p.d*factor, cury-(deltaP+luce)*factor, luce*factor,Math.PI/2,Math.PI);
                        this.doLine(curx-p.d*factor,cury-(deltaP+luce)*factor,curx-luce*factor-p.d*factor,cury-(deltaP+luce)*factor);
                      }
                  }
                }
              }
              if(p.porta.lato_porta=='lato_ds'){
                  let deltaP=0;
                  let luce=p.w;
                  if(p.porta.luceNetta && p.porta.luceNetta!=''){
                    let t=parseInt(p.porta.luceNetta.split('X')[0]);
                    deltaP=(p.w-t)/2;
                    luce=t;
                  }
            
                  if(p.porta.versoAperturaPorta!=2){
                    let manigliaw=p.w*factor/8;
                    let manigliah=p.w*factor/30;
                    this.doRect(curx+p.d*factor,cury,p.d*factor,-p.w*factor);
                    this.doRect(curx+p.d*factor+p.d*factor,cury-deltaP*factor,-manigliah,manigliaw);
                    if(!p.porta.scorrevole){
                      this.doArc(curx+p.d*factor, cury-(deltaP+luce)*factor, luce*factor,0,Math.PI/2);
                      this.doLine(curx+p.d*factor,cury-(deltaP+luce)*factor,curx+luce*factor+p.d*factor,cury-(deltaP+luce)*factor);
                    }
                  } else {
                    let manigliaw=p.w*factor/8;
                    let manigliah=p.w*factor/30;
                    this.doRect(curx+p.d*factor,cury,p.d*factor,-p.w*factor);
                    this.doRect(curx+p.d*factor+p.d*factor,cury-(deltaP+luce)*factor,-manigliah,manigliaw);
                    if(!p.porta.scorrevole){
                      this.doArc(curx+p.d*factor, cury-deltaP*factor, luce*factor,-1*Math.PI/2,0);
                      this.doLine(curx+p.d*factor,cury-deltaP*factor,curx+luce*factor+p.d*factor,cury-deltaP*factor);
                    }
                }     
              }
            }
          }
          if(!p.sopraporta){
            cury-=p.w*factor;
          }
        });      
        
      } else { // DIVISORIO ORIZZ
          d.pannelli.forEach((p:any) => {
          if(!p.fittizio){
            this.doRect(curx,cury,p.w*factor,p.d*factor);
            let dim=this.pdf.getTextDimensions((p.w*10).toString());
            this.pdf.text((p.w*10).toString(),curx+p.w*factor/2-dim.w/2,cury+dim.h*marg,{
                align: 'left',
            });
            if(p.porta){
              if(p.porta.lato_porta=='lato_fronte'){
                let deltaP=0;
                let luce=p.w;
                if(p.porta.luceNetta && p.porta.luceNetta!=''){
                  let t=parseInt(p.porta.luceNetta.split('X')[0]);
                  deltaP=(p.w-t)/2;
                  luce=t;
                }
              
                if(p.porta.versoAperturaPorta!=2){
                  let manigliaw=p.w*factor/8;
                  let manigliah=p.w*factor/30;
                  this.doRect(curx,cury+p.d*factor,p.w*factor,p.d*factor);
                  this.doRect(curx+deltaP,cury+1*p.d*factor*2,manigliaw,manigliah);
                  if(!p.porta.scorrevole){
                    this.doArc(curx+(deltaP+luce)*factor, cury+1*p.d*factor, luce*factor,Math.PI/2,Math.PI);
                    this.doLine(curx+(deltaP+luce)*factor,cury+p.d*factor,curx+(deltaP+luce)*factor,cury+1*p.d*factor+luce*factor);
                  }
                } else {
                  let manigliaw=p.w*factor/8;
                  let manigliah=p.w*factor/20;
                  this.doRect(curx,cury+p.d*factor,p.w*factor,p.d*factor);
                  this.doRect(curx+(deltaP+luce)*factor-manigliaw,cury+p.d*factor*2,manigliaw,manigliah);
                  if(!p.porta.scorrevole){
                    this.doArc(curx+deltaP, cury+p.d*factor, luce*factor,0,Math.PI/2);
                    this.doLine(curx+deltaP,cury+p.d*factor,curx+deltaP,cury+p.d*factor+luce*factor);
                  }
                }
                
              }
              if(p.porta.lato_porta=='lato_retro'){
              
                let deltaP=0;
                let luce=p.w;
                if(p.porta.luceNetta && p.porta.luceNetta!=''){
                  let t=parseInt(p.porta.luceNetta.split('X')[0]);
                  deltaP=(p.w-t)/2;
                  luce=t;
                }

                if(p.porta.versoAperturaPorta!=2){
                  let manigliaw=p.w*factor/8;
                  let manigliah=p.w*factor/30;
                  this.doRect(curx,cury,p.w*factor,-1*p.d*factor);
                  this.doRect(curx+(deltaP+luce)*factor-manigliaw,cury-1*p.d*factor,manigliaw,-manigliah);
                  if(!p.porta.scorrevole){
                    this.doArc(curx+deltaP*factor, cury-1*p.d*factor, luce*factor,-1*Math.PI/2,0);
                    this.doLine(curx+deltaP*factor,cury-1*p.d*factor,curx+deltaP,cury-1*p.d*factor-luce*factor);
                  }
                } else {
                  let manigliaw=p.w*factor/8;
                  let manigliah=p.w*factor/30;
                  this.doRect(curx,cury-1*p.d*factor,p.w*factor,-1*p.d*factor);
                  this.doRect(curx+deltaP*factor,cury-1*p.d*factor*2,manigliaw,-manigliah);
                  if(!p.porta.scorrevole){
                    this.doArc(curx+(deltaP+luce)*factor, cury-1*p.d*factor, luce*factor,-1*Math.PI,-1*Math.PI/2);
                    this.doLine(curx+(deltaP+luce)*factor,cury-1*p.d*factor,curx+(deltaP+luce)*factor,cury-1*p.d*factor-luce*factor);
                  }
                }
                
              }
            }
          }
          if(!p.sopraporta){
            curx+=p.w*factor; 
          }
        });     
      }
    });
  
    // SCAFFALI
    if(!this.mS.userCellePreConf()){
      this.cC.elencoScaffali.forEach((scaffale:any,ind:number)=>{
        curx=cx;
        cury=cy;
        (this.diagram as Diagram).nodes.filter((x:any)=>x.addInfo.id==scaffale.id).forEach((scnode:any)=>{
          let offX=0;
          let offY=0;
          if( (this.diagram as Diagram).nodes.filter((x:any)=>x.addInfo.id==scnode.addInfo.cellaCollegataId 
          && x.addInfo.id==this.mS.cellaDati.id).length>0){

            (this.diagram as Diagram).nodes.filter((x:any)=>x.addInfo.id==scnode.addInfo.cellaCollegataId).forEach((cellaC:any)=>{
              offX=scnode.offsetX-Math.round(scnode.width/2)-cellaC.offsetX+Math.round(cellaC.width/2);
              offY=scnode.offsetY-Math.round(scnode.height/2)-cellaC.offsetY+Math.round(cellaC.height/2);
            });
            scaffale.elenco.forEach((singolScaff:any)=>{
              for(let k=0;k<singolScaff.qty;k++){
                if(scnode.width>scnode.height){
                  this.pdfPannello(curx+offX+3,cury+offY+3,singolScaff.scaffale.LarghezzaReale,scnode.height,(singolScaff.scaffale.LarghezzaReale*10).toString()+'x'+(scnode.height*10).toString(),0);
                  curx+=singolScaff.scaffale.LarghezzaReale;
                } else {
                  this.pdfPannello(curx+offX+3,cury+offY+3,scnode.width,singolScaff.scaffale.LarghezzaReale,(scnode.width*10).toString()+'x'+(singolScaff.scaffale.LarghezzaReale*10).toString(),90);
                  cury+=singolScaff.scaffale.LarghezzaReale;
                }
              }
            }); 
          }
        })
      });
    }
   
    curx=cx;
    cury=cy;
    if(primoPannSpessore==0){
      primoPannSpessore= this.mS.objCella.spessore;
      ultimoPannSpessore= this.mS.objCella.spessore;
    }
    
  if(this.mS.disegnaAngolo('w',this.cC)){
    this.pdfAngolo('ss',curx, cury, this.mS.objCella.spessore,nodoCella);
  }
  if(this.mS.disegnaAngolo('wd',this.cC)){
   this.pdfAngolo('sd',curx+this.mS.objCella.d+marg+this.mS.cellaDati.spessore, cury, this.mS.objCella.spessore,nodoCella);
  }
  if(this.mS.disegnaAngolo('d',this.cC)){
    this.pdfAngolo('id',curx+marg+this.mS.cellaDati.spessore+this.mS.objCella.d, cury+marg+this.mS.cellaDati.spessore+this.mS.objCella.w, this.mS.objCella.spessore,nodoCella);
  }
  if(this.mS.disegnaAngolo('0',this.cC)){
    this.pdfAngolo('is',curx, cury+this.mS.objCella.w+marg+this.mS.cellaDati.spessore, this.mS.objCella.spessore,nodoCella);
  }
    
 

  }

  disegnaPdfCellaPavimento2(cx:number,cy:number,nodoCella:any,startx:number,starty:number,paginaH:number){
    var marg=1.5;
    if(this.mS.objCella.spessore==13){
      marg=0;
    } 
    var context = this.pdf.context2d;
    context.lineWidth =.1;

    let dim=this.pdf.getTextDimensions('1200');
    let factor=this.pdfProp;
   
    let curx=cx*factor;
    let cury=(cy-marg)*factor;

    
    curx=(cx+(marg+this.mS.cellaDati.spessore)/2)*factor;
    cury=(cy-(marg+this.mS.cellaDati.spessore)/2)*factor;

  
    this.mS.objRetro.pannelli.forEach((p:any) => {
      if(!p.fittizio){
        this.doRect(curx,cury,p.w*factor,p.d*factor);
      }
      if(!p.sopraporta){
        curx+=p.w*factor;
      }
    });
   
    curx=(cx+(marg+this.mS.cellaDati.spessore)/2)*factor;;
    cury=(cy+marg+(marg+this.mS.cellaDati.spessore)/2)*factor+this.mS.objCella.w*factor;;
    if(this.tipoStampa!='all'){
      this.drawMisureSotto((cx+(this.mS.cellaDati.spessore)/2)*factor,(starty+paginaH)*factor,this.pdfProp,this.mS.cellaDati.ingombroX+3);
    }
    this.mS.objFronte.pannelli.forEach((p:any) => {
      if(!p.fittizio){
        this.doRect(curx,cury,p.w*factor,p.d*factor);
      }
      if(!p.sopraporta){
        curx+=p.w*factor;
      }
    });
  

    curx=(cx-(marg+this.mS.cellaDati.spessore)/2)*factor;;
    cury=(cy+(marg+this.mS.cellaDati.spessore)/2)*factor+this.mS.objCella.w*factor;;
    if(this.tipoStampa!='all'){
      this.drawMisuraSinistra(startx*factor,(cy+(this.mS.cellaDati.spessore)/2)*factor,this.pdfProp,this.mS.cellaDati.ingombroY+3);
    }
    this.mS.objLatSin.pannelli.forEach((p:any) => {
      if(!p.fittizio){
        this.doRect(curx,cury,p.d*factor,-p.w*factor);
      } 
      if(!p.sopraporta){
        cury-=p.w*factor;
      }
    });
  

    
    curx=(cx+marg+(marg+this.mS.cellaDati.spessore)/2)*factor+this.mS.objCella.d*factor;
    cury=(cy+(marg+this.mS.cellaDati.spessore)/2)*factor+this.mS.objCella.w*factor;
    this.mS.objLatDs.pannelli.forEach((p:any) => {
      if(!p.fittizio){
        this.doRect(curx,cury,p.d*factor,-p.w*factor);
      } 
      if(!p.sopraporta){
        cury-=p.w*factor;
      }
    });
   
    curx=cx;
    cury=cy;
  

    if (!this.isPdfAngoloSuGiuntoUniteAFilo('ss')) {
      this.pdfAngolo('ss',curx, cury, this.mS.objCella.spessore,nodoCella);
    }
    if (!this.isPdfAngoloSuGiuntoUniteAFilo('sd')) {
      this.pdfAngolo('sd',curx+this.mS.objCella.d+marg+this.mS.cellaDati.spessore, cury, this.mS.objCella.spessore,nodoCella);
    }
    if (!this.isPdfAngoloSuGiuntoUniteAFilo('id')) {
      this.pdfAngolo('id',curx+marg+this.mS.cellaDati.spessore+this.mS.objCella.d, cury+marg+this.mS.cellaDati.spessore+this.mS.objCella.w, this.mS.objCella.spessore,nodoCella);
    }
    if (!this.isPdfAngoloSuGiuntoUniteAFilo('is')) {
      this.pdfAngolo('is',curx, cury+this.mS.objCella.w+marg+this.mS.cellaDati.spessore, this.mS.objCella.spessore,nodoCella);
    }

    
    curx=(cx+(marg+this.mS.cellaDati.spessore)/2);
    cury=(cy+(marg+this.mS.cellaDati.spessore)/2);
    let last=0;
    let filemultiple=false;
    this.mS.objPavimento.pannelli.forEach((p:any,ind:number) => {    
      if(!p.z || p.z==0){
        filemultiple=true;
      }  
    });
    this.mS.objPavimento.pannelli.forEach((p:any,ind:number) => {    
    if(!p.z){
      p.z=0;
    }  
    if(!this.mS.cellaDati.ruotaPavimento){
      if(p.z==0){
          cury+=last;
      }
      this.pdfPannello(curx+p.z,cury,p.h,p.w,(p.w*10).toString()+'x'+(p.h*10).toString(),0,ind<this.mS.objPavimento.pannelli.length-1 ? 'fronte':'');
      if(filemultiple){
        this.pdfPannello(curx+p.z,cury,p.h,p.w,'',0, 'destro');
      }
      last=p.w;
    } else {
      if(p.z==0){
        curx+=last;
      }
      this.pdfPannello(curx,cury+p.z,p.h,p.w,(p.w*10).toString()+'x'+(p.h*10).toString(),90,ind<this.mS.objPavimento.pannelli.length-1 ? 'destro':'');
      if(filemultiple){
        this.pdfPannello(curx,cury+p.z,p.h,p.w,'',0, 'fronte');
      }
      last=p.h;
    }
    });

    this.disegnaPdfTrattoGiuntoUnite(cx, cy, marg);
  }

  /**
   * Angolo PDF sul giunto unite da non disegnare:
   * - a filo (stessa lunghezza sul lato di unione);
   * - oppure su parete continua (es. L con soli fondi allineati → niente angolare in basso,
   *   resta il 270° sul lato non a filo).
   * Mapping PDF → spigolo viewer: ss→w, sd→wd, is→0, id→d.
   */
  isPdfAngoloSuGiuntoUniteAFilo(angolo: string): boolean {
    const cella = this.mS.cellaDati;
    const posAng =
      angolo === 'ss' ? 'w' : angolo === 'sd' ? 'wd' : angolo === 'is' ? '0' : angolo === 'id' ? 'd' : '';
    if (posAng && this.cC && this.mS.angoloSuGiuntoPareteContinua(posAng, this.cC, cella)) {
      return true;
    }
    const links = (cella?.celleCollegate || []).filter(
      (x: any) => x.attivo && x.tipoCollegamento === 'unite',
    );
    const isAFilo = (latoUnite: string): boolean =>
      links.some((l: any) => {
        if (l.latocollegato !== latoUnite) {
          return false;
        }
        const other = (this.cC?.elencoCelle || []).find(
          (c: any) => c.id == l.cellaCollegataId,
        );
        if (!other) {
          return true;
        }
        const dimThis =
          latoUnite === 'lato_sn' || latoUnite === 'lato_ds'
            ? cella.ingombroY || 0
            : cella.ingombroX || 0;
        const dimOther =
          latoUnite === 'lato_sn' || latoUnite === 'lato_ds'
            ? other.ingombroY || 0
            : other.ingombroX || 0;
        return Math.abs(dimThis - dimOther) < 0.5;
      });
    if ((angolo === 'ss' || angolo === 'is') && isAFilo('lato_sn')) {
      return true;
    }
    if ((angolo === 'sd' || angolo === 'id') && isAFilo('lato_ds')) {
      return true;
    }
    if ((angolo === 'is' || angolo === 'id') && isAFilo('lato_fronte')) {
      return true;
    }
    if ((angolo === 'ss' || angolo === 'sd') && isAFilo('lato_retro')) {
      return true;
    }
    return false;
  }

  /** Tratti contigui di pannelli fittizio (esclusi sopraporta) — stesso criterio delle travi unite. */
  getPdfTrattiFittizioLato(pannelli: any[]): { start: number; len: number }[] {
    const out: { start: number; len: number }[] = [];
    let cursor = 0;
    let runStart = 0;
    let runLen = 0;
    (pannelli || []).forEach((p: any) => {
      if (p?.sopraporta) {
        return;
      }
      const w = Number(p?.w) || 0;
      if (p?.fittizio) {
        if (runLen === 0) {
          runStart = cursor;
        }
        runLen += w;
      } else if (runLen > 0) {
        out.push({ start: runStart, len: runLen });
        runLen = 0;
      }
      cursor += w;
    });
    if (runLen > 0) {
      out.push({ start: runStart, len: runLen });
    }
    return out;
  }

  /**
   * Tratto di unione tra celle unite su soffitto/pavimento.
   * Sempre presente sul contatto fittizio; se len>339 (trave) disegna la trave (doppia linea).
   * Una sola volta per coppia (id minore) per non duplicare.
   */
  disegnaPdfTrattoGiuntoUnite(cx: number, cy: number, marg: number): void {
    const cella = this.mS.cellaDati;
    const links = (cella?.celleCollegate || []).filter(
      (x: any) => x?.attivo && x?.tipoCollegamento === 'unite' && x?.latocollegato,
    );
    if (!links.length) {
      return;
    }
    const factor = this.pdfProp;
    const sp = cella.spessore || 0;
    const ix = cx + (marg + sp) / 2;
    const iy = cy + (marg + sp) / 2;
    const d = this.mS.objCella?.d || 0;
    const w = this.mS.objCella?.w || 0;
    const objFronte = this.mS.objCella?.objFronte || this.mS.objFronte;
    const objRetro = this.mS.objCella?.objRetro || this.mS.objRetro;
    const objLatSin = this.mS.objCella?.objLatSin || this.mS.objLatSin;
    const objLatDs = this.mS.objCella?.objLatDs || this.mS.objLatDs;
    const objByLato = (lato: string) => {
      switch (lato) {
        case 'lato_fronte':
          return objFronte;
        case 'lato_retro':
          return objRetro;
        case 'lato_sn':
          return objLatSin;
        case 'lato_ds':
          return objLatDs;
        default:
          return null;
      }
    };
    const drawSeg = (x1: number, y1: number, x2: number, y2: number, asTrave: boolean) => {
      this.doLine(x1 * factor, y1 * factor, x2 * factor, y2 * factor);
      if (asTrave) {
        const dx = x2 - x1;
        const dy = y2 - y1;
        const len = Math.sqrt(dx * dx + dy * dy) || 1;
        const ox = (-dy / len) * 0.8;
        const oy = (dx / len) * 0.8;
        this.doLine((x1 + ox) * factor, (y1 + oy) * factor, (x2 + ox) * factor, (y2 + oy) * factor);
      }
    };

    links.forEach((link: any) => {
      // evita doppio tratto: disegna solo dalla cella con id minore
      if (link.cellaCollegataId != null && cella.id > link.cellaCollegataId) {
        return;
      }
      const lato = link.latocollegato;
      let tratti = this.getPdfTrattiFittizioLato(objByLato(lato)?.pannelli);
      // fallback: se i fittizio non sono ancora sul lato, usa overlap geometrico / intero lato
      if (!tratti.length) {
        const other = (this.cC?.elencoCelle || []).find((c: any) => c.id == link.cellaCollegataId);
        const lunghLato =
          lato === 'lato_sn' || lato === 'lato_ds' ? w : d;
        const dist = Number(link.distLato) || 0;
        let len = Number(link.larghezza) || 0;
        if (len <= 0 && other) {
          len =
            lato === 'lato_sn' || lato === 'lato_ds'
              ? Math.min(w, other.ingombroY || 0)
              : Math.min(d, other.ingombroX || 0);
        }
        if (len <= 0) {
          len = Math.max(0, lunghLato - dist);
        }
        if (len > 0.5) {
          tratti = [{ start: dist, len }];
        }
      }
      tratti.forEach((tratto) => {
        if (tratto.len <= 0.5) {
          return;
        }
        const asTrave = tratto.len > 339;
        // laterali: cursore pannelli dal fronte (basso) verso retro (alto)
        // fronte/retro: cursore da sn (sinistra) verso ds
        if (lato === 'lato_ds') {
          const x = ix + d;
          drawSeg(x, iy + w - tratto.start, x, iy + w - tratto.start - tratto.len, asTrave);
        } else if (lato === 'lato_sn') {
          const x = ix;
          drawSeg(x, iy + w - tratto.start, x, iy + w - tratto.start - tratto.len, asTrave);
        } else if (lato === 'lato_fronte') {
          const y = iy + w;
          drawSeg(ix + tratto.start, y, ix + tratto.start + tratto.len, y, asTrave);
        } else if (lato === 'lato_retro') {
          const y = iy;
          drawSeg(ix + tratto.start, y, ix + tratto.start + tratto.len, y, asTrave);
        }
      });
    });
  }

 disegnaPdfCellaSoffitto2(cx:number,cy:number,nodoCella:any,startx:number,starty:number,paginaH:number){
    var marg=1.5;
    if(this.mS.objCella.spessore==13){
      marg=0;
    } 
    var context = this.pdf.context2d;
    context.lineWidth =.1;

    let dim=this.pdf.getTextDimensions('1200');
    let factor=this.pdfProp;
    // dopo getObj2 i lati corretti sono su objCella (non this.objRetro legacy)
    const objFronte = this.mS.objCella?.objFronte || this.mS.objFronte;
    const objRetro = this.mS.objCella?.objRetro || this.mS.objRetro;
    const objLatSin = this.mS.objCella?.objLatSin || this.mS.objLatSin;
    const objLatDs = this.mS.objCella?.objLatDs || this.mS.objLatDs;
    const objSoffitto = this.mS.objCella?.objSoffitto || this.mS.objSoffitto;
  
    let curx=cx*factor;
    let cury=(cy-marg)*factor;

    curx=(cx+(marg+this.mS.cellaDati.spessore)/2)*factor;
    cury=(cy-(marg+this.mS.cellaDati.spessore)/2)*factor;
   
    (objRetro?.pannelli || []).forEach((p:any) => {
      if(!p.fittizio){
        this.doRect(curx,cury,p.w*factor,p.d*factor);
      } 
      if(!p.sopraporta){
        curx+=p.w*factor;
      }
    });
  

    curx=(cx+(marg+this.mS.cellaDati.spessore)/2)*factor;;
    cury=(cy+marg+(marg+this.mS.cellaDati.spessore)/2)*factor+this.mS.objCella.w*factor;;
    if(this.tipoStampa!='all'){
      this.drawMisureSotto((cx+(this.mS.cellaDati.spessore)/2)*factor,(starty+paginaH)*factor,this.pdfProp,this.mS.cellaDati.ingombroX+3);
    }
    (objFronte?.pannelli || []).forEach((p:any) => {
      if(!p.fittizio){
        this.doRect(curx,cury,p.w*factor,p.d*factor);
      } 
      if(!p.sopraporta){
        curx+=p.w*factor;
      }
    });
  
    
    curx=(cx-(marg+this.mS.cellaDati.spessore)/2)*factor;;
    cury=(cy+(marg+this.mS.cellaDati.spessore)/2)*factor+this.mS.objCella.w*factor;;
    if(this.tipoStampa!='all'){
      this.drawMisuraSinistra(startx*factor,(cy+(this.mS.cellaDati.spessore)/2)*factor,this.pdfProp,this.mS.cellaDati.ingombroY+3);
    }
    (objLatSin?.pannelli || []).forEach((p:any) => {
      if(!p.fittizio){
        this.doRect(curx,cury,p.d*factor,-p.w*factor);
      
      } 
      if(!p.sopraporta){
        cury-=p.w*factor;
      }
    });
 
  
    
    curx=(cx+marg+(marg+this.mS.cellaDati.spessore)/2)*factor+this.mS.objCella.d*factor;
    cury=(cy+(marg+this.mS.cellaDati.spessore)/2)*factor+this.mS.objCella.w*factor;
    (objLatDs?.pannelli || []).forEach((p:any) => {
      if(!p.fittizio){
        this.doRect(curx,cury,p.d*factor,-p.w*factor);
      } 
      if(!p.sopraporta){
        cury-=p.w*factor;
      }
    });
  
  
    curx=cx;
    cury=cy;
   
    if (!this.isPdfAngoloSuGiuntoUniteAFilo('ss')) {
      this.pdfAngolo('ss',curx, cury, this.mS.objCella.spessore,nodoCella);
    }
    if (!this.isPdfAngoloSuGiuntoUniteAFilo('sd')) {
      this.pdfAngolo('sd',curx+this.mS.objCella.d+marg+this.mS.cellaDati.spessore, cury, this.mS.objCella.spessore,nodoCella);
    }
    if (!this.isPdfAngoloSuGiuntoUniteAFilo('id')) {
      this.pdfAngolo('id',curx+marg+this.mS.cellaDati.spessore+this.mS.objCella.d, cury+marg+this.mS.cellaDati.spessore+this.mS.objCella.w, this.mS.objCella.spessore,nodoCella);
    }
    if (!this.isPdfAngoloSuGiuntoUniteAFilo('is')) {
      this.pdfAngolo('is',curx, cury+this.mS.objCella.w+marg+this.mS.cellaDati.spessore, this.mS.objCella.spessore,nodoCella);
    }

    
    curx=(cx+(marg+this.mS.cellaDati.spessore)/2);
    cury=(cy+(marg+this.mS.cellaDati.spessore)/2);
    let last=0;
    const pannSoff = objSoffitto?.pannelli || [];
    // più colonne (z>0) → tratti verticali tra pannelli; non solo se esiste uno z==0
    const hasCols = pannSoff.some((p: any) => (Number(p.z) || 0) > 0);
    const maxRight = pannSoff.reduce((m: number, p: any) => {
      const z = Number(p.z) || 0;
      const ww = this.mS.cellaDati.ruotasoffitto ? (Number(p.w) || 0) : (Number(p.h) || 0);
      return Math.max(m, z + ww);
    }, 0);
    pannSoff.forEach((p:any,ind:number) => {    
      if(!p.z){
        p.z=0;
       }
      const z = Number(p.z) || 0;
      if(!this.mS.cellaDati.ruotasoffitto){
        if(z==0){
          cury+=last;
        }
        this.pdfPannello(curx+z,cury,p.h,p.w,(p.w*10).toString()+'x'+(p.h*10).toString(),0,ind<pannSoff.length-1 ? 'fronte':'');
        // tratto verticale tra colonne (anche sul bordo destro interno di ogni pannello non ultimo in X)
        if (hasCols && z + (Number(p.h) || 0) < maxRight - 0.5) {
          this.pdfPannello(curx+z,cury,p.h,p.w,'',0, 'destro');
        }
        last=p.w;
      }else {
        if(z==0){
          curx+=last;
        }
        this.pdfPannello(curx,cury+z,p.h,p.w,(p.w*10).toString()+'x'+(p.h*10).toString(),90,ind<pannSoff.length-1 ? 'destro':'');
        if (hasCols && z + (Number(p.w) || 0) < maxRight - 0.5) {
          this.pdfPannello(curx,cury+z,p.h,p.w,'',0, 'fronte');
        }
        last=p.h;
      }
    });

    this.disegnaPdfTrattoGiuntoUnite(cx, cy, marg);
  }



  disegnaPdfCellaPavimento(cx:number,cy:number){
    var context = this.pdf.context2d;
    context.lineWidth =.1;
    let factor=this.pdfProp;

    let ccx=cx;
    let ccy=cy;
    let last=0;
    switch (this.mS.cellaDati.combinata){
      case 'cellacombinatatop':
        ccy+=this.mS.objCella.spessore;
        break;
      case 'cellacombinataleft':
        ccx+=this.mS.objCella.spessore;
        break;   
      case 'cellacombinataright':
        ccx-=this.mS.objCella.spessore;
        break;
      case 'cellacombinatabottom':
        ccy-=this.mS.objCella.spessore;
        break;
    }
      this.mS.objPavimento.pannelli.filter((x:any)=>x.side=='pavimento').forEach((p:any) => {    
        if(!this.mS.cellaDati.ruotaPavimento){
        if(p.z==0){
          ccy+=last;
        }
        this.pdfPannello(ccx+p.z,ccy,p.h,p.w,(p.w*10).toString()+'x'+(p.h*10).toString(),0);
        last=p.w;
      }else {
        if(p.z==0){
          ccx+=last;
        }
        this.pdfPannello(ccx,ccy+p.z,p.w,p.h,(p.w*10).toString()+'x'+(p.h*10).toString(),90);
        last=p.w;
      }
      });
      ccx=cx;
      ccy=cy;
      let ss=0;
      let ww=0;
      let haFittizi=false;
      switch (this.mS.cellaDati.combinata){
        case '':
          //lato retro 
          this.mS.objRetro.pannelli.forEach((p:any)=>{  
            if(p.fittizio && ww>0){
              haFittizi=true;
              this.pdfPannello(ccx+ss,ccy,ww,-1*this.mS.objCella.spessore);
              ss+=ww;
              ww=0;
            } 
            if(p.fittizio){
              ss+=p.w;
            }else{
              ww+=p.w;
            }
          }); 
          if(haFittizi && ww>0){
            this.pdfPannello(ccx+ss,ccy,ww,-1*this.mS.objCella.spessore);
          }
          if(!haFittizi){
            this.pdfPannello(ccx,ccy,this.mS.objCella.d,-1*this.mS.objCella.spessore);
          }
          ss=0;
          ww=0;
          haFittizi=false;
          //lato sn
          this.mS.objLatSin.pannelli.forEach((p:any)=>{  
            if(p.fittizio && ww>0){
              haFittizi=true;
              this.pdfPannello(ccx,ccy+this.mS.objCella.w-ss,-1*this.mS.objCella.spessore,-ww);
              ss+=ww;
              ww=0;
            } 
            if(p.fittizio){
              ss+=p.w;
            }else{
              ww+=p.w;
            }
          }); 
          if(haFittizi && ww>0){
            this.pdfPannello(ccx,ccy+this.mS.objCella.w-ss,-1*this.mS.objCella.spessore,-ww);
          }
          if(!haFittizi){
            this.pdfPannello(ccx,ccy,-1*this.mS.objCella.spessore,this.mS.objCella.w);
          }
          ss=0;
          ww=0;
          haFittizi=false;
          //lato ds
          this.mS.objLatDs.pannelli.forEach((p:any)=>{  
            if(p.fittizio && ww>0){
              haFittizi=true;
              this.pdfPannello(ccx+this.mS.objCella.d,ccy+this.mS.objCella.w-ss,this.mS.objCella.spessore,-ww);
              ss+=ww;
              ww=0;
            } 
            if(p.fittizio){
              ss+=p.w;
            }else{
              ww+=p.w;
            }
          }); 
          if(haFittizi && ww>0){
            this.pdfPannello(ccx+this.mS.objCella.d,ccy+this.mS.objCella.w-ss,this.mS.objCella.spessore,-ww);
          }
          if(!haFittizi){
            this.pdfPannello(ccx+this.mS.objCella.d,ccy,this.mS.objCella.spessore,this.mS.objCella.w);
          }
          ss=0;
          ww=0;
          haFittizi=false;
          //lato fronte
          this.mS.objFronte.pannelli.forEach((p:any)=>{  
            if(p.fittizio && ww>0){
              haFittizi=true;
              this.pdfPannello(ccx+ss,ccy+this.mS.objCella.w,ww,this.mS.objCella.spessore);
              ss+=ww;
              ww=0;
            } 
            if(p.fittizio){
              ss+=p.w;
            }else{
              ww+=p.w;
            }
          }); 
          if(haFittizi && ww>0){
            this.pdfPannello(ccx+ss,ccy+this.mS.objCella.w,ww,this.mS.objCella.spessore);
          }
          if(!haFittizi){
            this.pdfPannello(ccx,ccy+this.mS.objCella.w,this.mS.objCella.d,this.mS.objCella.spessore);
          }
          break;
        case 'cellacombinatatop': 
          //lato ds
          this.pdfPannello(ccx+this.mS.objCella.d,ccy,this.mS.objCella.spessore,this.mS.objCella.w);
          //lato sn
          this.pdfPannello(ccx,ccy,-1*this.mS.objCella.spessore,this.mS.objCella.w);
          //lato fronte
          this.pdfPannello(ccx,ccy+this.mS.objCella.w,this.mS.objCella.d,this.mS.objCella.spessore);
          break;
      case 'cellacombinataleft':
          //lato retro
          this.pdfPannello(ccx,ccy,this.mS.objCella.d,-1*this.mS.objCella.spessore);
          //lato ds
          this.pdfPannello(ccx+this.mS.objCella.d,ccy,this.mS.objCella.spessore,this.mS.objCella.w);

          //lato fronte
          this.pdfPannello(ccx,ccy+this.mS.objCella.w,this.mS.objCella.d,this.mS.objCella.spessore);
          break;
      case 'cellacombinataright':
            //lato retro
          this.pdfPannello(ccx,ccy,this.mS.objCella.d,-1*this.mS.objCella.spessore);
          //lato sn
          this.pdfPannello(ccx,ccy,-1*this.mS.objCella.spessore,this.mS.objCella.w);
          //lato fronte
          this.pdfPannello(ccx,ccy+this.mS.objCella.w,this.mS.objCella.d,this.mS.objCella.spessore);
          break;
      case 'cellacombinatabottom':
          //lato retro
          this.pdfPannello(ccx,ccy,this.mS.objCella.d,-1*this.mS.objCella.spessore);
          //lato ds
          this.pdfPannello(ccx+this.mS.objCella.d,ccy,this.mS.objCella.spessore,this.mS.objCella.w);
          //lato sn
          this.pdfPannello(ccx,ccy,-1*this.mS.objCella.spessore,this.mS.objCella.w);
          break;
      }
      ccx=cx;
      ccy=cy;
  
    
      }

  disegnaPdfCellaSoffitto(cx:number,cy:number){
    var context = this.pdf.context2d;
    context.lineWidth =.1;
    let factor=this.pdfProp;

    let ccx=cx;
    let ccy=cy;
    let last=0;
    this.mS.objSoffitto.pannelli.filter((x:any)=>x.side=='soffitto').forEach((p:any) => {    
      if(!this.mS.cellaDati.ruotasoffitto){
      if(p.z==0){
        ccy+=last;
       }
      this.pdfPannello(ccx+p.z,ccy,p.h,p.w,(p.w*10).toString()+'x'+(p.h*10).toString(),0);
      last=p.w;
    }else {
      if(!p.z){
        p.z=0;
      }
      if(p.z==0){
        ccx+=last;
       }
      this.pdfPannello(ccx,ccy+p.z,p.w,p.h,(p.w*10).toString()+'x'+(p.h*10).toString(),90);
      last=p.w;
    }
    });
    ccx=cx;
    ccy=cy;

    //lato fronte
    this.pdfPannello(ccx,ccy,this.mS.objCella.d,-1*this.mS.objCella.spessore);
    //lato ds
    this.pdfPannello(ccx+this.mS.objCella.d,ccy,this.mS.objCella.spessore,this.mS.objCella.w);
    //lato sn
    this.pdfPannello(ccx,ccy,-1*this.mS.objCella.spessore,this.mS.objCella.w);
    //lato retro
    this.pdfPannello(ccx,ccy+this.mS.objCella.w,this.mS.objCella.d,this.mS.objCella.spessore);

  }



  drawMisuraSinistra(cx:number,cy:number,factor:number,cellaH:number){  
    // misure a destra
    if(this.pdfOrdDxf=='PDF'){
      let deltaX=20; 
      let labelX=6; //cellaH*factor/15;;
      let collLatoSn=false;
      let collLatoDx=false;
      let collLatoRetro=false;
      let collLatoFronte=false;
      
      this.mS.cellaDati.celleCollegate.forEach((c:any)=>{
        if(!c.latocombinato && c.latocollegato=='lato_retro'){
          collLatoRetro=true;
        }
          if(!c.latocombinato && c.latocollegato=='lato_fronte'){
          collLatoFronte=true;
        }
      });
     
      this.doLine(cx-deltaX,cy,cx-deltaX-labelX,cy);
      this.doLine(cx-deltaX,cy-this.mS.objCella.spessore*factor,cx-deltaX-labelX*2,cy-this.mS.objCella.spessore*factor);
      if(!collLatoFronte){
        this.doLine(cx-deltaX,cy+cellaH*factor,cx-deltaX-labelX,cy+cellaH*factor);
        this.doLine(cx-deltaX,cy+cellaH*factor+this.mS.objCella.spessore*factor,cx-deltaX-labelX*2,cy+cellaH*factor+this.mS.objCella.spessore*factor);
        this.legenda_obliqua(cx-deltaX-labelX+deltaX/10,cy+cellaH*factor+this.mS.objCella.spessore*factor/2,labelX,false,(this.mS.objCella.spessore*10).toString());
        this.obliquo(cx-deltaX-labelX+deltaX/10,cy+cellaH*factor,this.mS.objCella.spessore*factor,true);
        this.obliquo(cx-deltaX-labelX*2+deltaX/10,cy+this.mS.objCella.spessore*factor+cellaH*factor,this.mS.objCella.spessore*factor,true);
        this.obliquo(cx-deltaX-labelX+deltaX/10,cy+this.mS.objCella.spessore*factor+cellaH*factor,this.mS.objCella.spessore*factor,true);

      }
      this.doLine(cx-deltaX-labelX+deltaX/10,cy-this.mS.objCella.spessore*factor*2,cx-deltaX-labelX+deltaX/10,cy+cellaH*factor+this.mS.objCella.spessore*factor*2);
      this.doLine(cx-deltaX-labelX*2+deltaX/10,cy-this.mS.objCella.spessore*factor,cx-deltaX-labelX*2+deltaX/10,cy+cellaH*factor+this.mS.objCella.spessore*factor);
      
      this.obliquo(cx-deltaX-labelX+deltaX/10,cy,this.mS.objCella.spessore*factor,true);
      this.obliquo(cx-deltaX-labelX*2+deltaX/10,cy-this.mS.objCella.spessore*factor,this.mS.objCella.spessore*factor,true);
      this.obliquo(cx-deltaX-labelX+deltaX/10,cy-this.mS.objCella.spessore*factor,this.mS.objCella.spessore*factor,true);
      

      this.legenda_obliqua(cx-deltaX-labelX+deltaX/10,cy-this.mS.objCella.spessore*factor/2,labelX,false,(this.mS.objCella.spessore*10).toString());
   
   
      
      this.pdf.setFontSize(8).setFont(undefined, 'normal').text(((cellaH+this.mS.objCella.spessore*2)*10).toString(),cx-deltaX-labelX*2,cy+cellaH*factor/2+this.pdf.getTextWidth(((cellaH+this.mS.objCella.spessore*2)*10).toString())/2,{
              align: 'left',
              angle:90
            });

      this.pdf.setFontSize(8).setFont(undefined, 'normal').text((cellaH*10).toString(),cx-deltaX-labelX,cy+cellaH*factor/2+this.pdf.getTextWidth((cellaH*10).toString())/2,{
              align: 'left',
              angle:90
            });
    } 
  }

  drawMisureSotto(cx:number,cy:number,factor:number,cellaW:number){
  // misure sotto
   if(this.pdfOrdDxf=='PDF'){
      let deltaY=20;
      let labelY=3;
      this.doLine(cx,cy+deltaY,cx,cy+deltaY+labelY+this.mS.objCella.spessore*factor);
      this.doLine(cx-this.mS.objCella.spessore*factor,cy+deltaY,cx-this.mS.objCella.spessore*factor,cy+deltaY+labelY*2);

      this.doLine(cx+cellaW*factor,cy+deltaY,cx+cellaW*factor,cy+deltaY+labelY+this.mS.objCella.spessore*factor);
      this.doLine(cx+cellaW*factor+this.mS.objCella.spessore*factor,cy+deltaY,cx+cellaW*factor+this.mS.objCella.spessore*factor,cy+deltaY+labelY*2+this.mS.objCella.spessore*factor);

      this.doLine(cx-this.mS.objCella.spessore*factor*2,cy+deltaY+labelY,cx+cellaW*factor+this.mS.objCella.spessore*factor*2,cy+deltaY+labelY);
      this.doLine(cx-this.mS.objCella.spessore*factor,cy+deltaY+labelY*2,cx+cellaW*factor+this.mS.objCella.spessore*factor,cy+deltaY+labelY*2);
    
      this.obliquo(cx-this.mS.objCella.spessore*factor,cy+deltaY+labelY,this.mS.objCella.spessore*factor,false);
      this.obliquo(cx,cy+deltaY+labelY,this.mS.objCella.spessore*factor,false);
      this.obliquo(cx-this.mS.objCella.spessore*factor,cy+deltaY+labelY*2,this.mS.objCella.spessore*factor,false);
      
      this.obliquo(cx+this.mS.objCella.spessore*factor+cellaW*factor,cy+deltaY+labelY,this.mS.objCella.spessore*factor,false);
      this.obliquo(cx+cellaW*factor,cy+deltaY+labelY,this.mS.objCella.spessore*factor,false);
      this.obliquo(cx+this.mS.objCella.spessore*factor+cellaW*factor,cy+deltaY+labelY*2,this.mS.objCella.spessore*factor,false);
      
      this.legenda_obliqua(cx-this.mS.objCella.spessore*factor/2,cy+deltaY+labelY,labelY,true,(this.mS.objCella.spessore*10).toString());
      
      this.legenda_obliqua(cx+cellaW*factor+this.mS.objCella.spessore*factor/2,cy+deltaY+labelY,labelY,true,(this.mS.objCella.spessore*10).toString());

      this.pdf.setFontSize(8).setFont(undefined, 'normal').text(((cellaW+this.mS.objCella.spessore*2)*10).toString(),cx+cellaW*factor/2-this.pdf.getTextWidth(((cellaW+this.mS.objCella.spessore*2)*10).toString())/2,cy+deltaY+labelY*2.8,{
              align: 'left'
            });

      this.pdf.setFontSize(8).setFont(undefined, 'normal').text((cellaW*10).toString(),cx+cellaW*factor/2-this.pdf.getTextWidth((cellaW*10).toString())/2,cy+deltaY+labelY*0.8,{
              align: 'left'
            });
    }
  }

  legenda_obliqua(x:number,y:number,l:number,down:boolean,txt:string){
    const dim = this.pdf.getTextDimensions(txt);
    if(down){
      let x2=x+l/2;
      let y2=y+l*2.4;
      this.doLine(x,y,x2,y2);
      this.doLine(x2,y2,x2+l,y2);
      this.pdf.setFontSize(8).setFont(undefined, 'normal').text(txt,x2+l/2-this.pdf.getTextWidth(txt)/2,y2-dim.h*0.2,{
            align: 'left'
          });
    } else {
      let x2=x-l*1.2;
      let y2=y-l/2;
      this.doLine(x,y,x2,y2);
      this.doLine(x2,y2,x2,y2-l);
      this.pdf.setFontSize(8).setFont(undefined, 'normal').text(txt,x2-dim.h*0.5,y2-l/2+this.pdf.getTextWidth(txt)/2,{
          align: 'left',
          angle:90
      });
    }
  }

  obliquo(x:number,y:number,l:number,down:boolean){
    let ll=Math.round(l/2)*0.7;
    if(down){
      this.doLine(x-ll,y-ll,x+ll,y+ll);
    } else {
      this.doLine(x-ll,y+ll,x+ll,y-ll);
    }
  }


  pdfAngolo(angolo:string,cxx:number,cyy:number,spessore:number,nodoCella:any){
    let raggio=1.5;
    let cx=cxx;
    let cy=cyy;
  
    let pareti:any=this.mS.calcNumPareti(angolo);
    if(pareti.numPareti==3){
       switch (spessore){
        case 10:
        case 6:
          switch (pareti.orient){
            case 0: // due archi sotto
              if(angolo=='ss'){
                cx=cxx-(raggio+spessore)/2+pareti.offsetX;
                cy=cyy+(raggio+spessore)/2+pareti.offsetY;
              } 
              if(angolo=='sd'){
                cx=cxx-(raggio+spessore)/2+pareti.offsetX;
                cy=cyy+(raggio+spessore)/2+pareti.offsetY;
              } 
              this.doLine(cx*this.pdfProp,(cy-raggio)*this.pdfProp,cx*this.pdfProp,(cy-spessore-raggio)*this.pdfProp);
              this.doLine(cx*this.pdfProp,(cy-spessore-raggio)*this.pdfProp,(cx+spessore+2*raggio)*this.pdfProp,(cy-spessore-raggio)*this.pdfProp);
              this.doLine((cx+spessore+2*raggio)*this.pdfProp,(cy-spessore-raggio)*this.pdfProp,(cx+spessore+2*raggio)*this.pdfProp,(cy-raggio)*this.pdfProp);
              this.doLine((cx+raggio)*this.pdfProp,cy*this.pdfProp,(cx+raggio+spessore)*this.pdfProp,cy*this.pdfProp);
              this.doArc(cx*this.pdfProp, cy*this.pdfProp, raggio*this.pdfProp,-1*Math.PI/2,0);
              this.doArc((cx+spessore+2*raggio)*this.pdfProp, cy*this.pdfProp, raggio*this.pdfProp,-1*Math.PI,-1*Math.PI/2);
              break;
            case 90:
              cx=cxx+(raggio+spessore)/2+pareti.offsetX;
              cy=cyy-(raggio+spessore)/2+pareti.offsetY;
              this.doLine((cx-raggio)*this.pdfProp,cy*this.pdfProp,(cx-spessore-raggio)*this.pdfProp,cy*this.pdfProp);
              this.doLine((cx-spessore-raggio)*this.pdfProp,cy*this.pdfProp,(cx-spessore-raggio)*this.pdfProp,(cy+spessore+2*raggio)*this.pdfProp);
              this.doLine((cx-spessore-raggio)*this.pdfProp,(cy+spessore+2*raggio)*this.pdfProp,(cx-raggio)*this.pdfProp,(cy+spessore+2*raggio)*this.pdfProp);
              this.doLine(cx*this.pdfProp,(cy+raggio)*this.pdfProp,cx*this.pdfProp,(cy+spessore+raggio)*this.pdfProp);
              this.doArc(cx*this.pdfProp, cy*this.pdfProp, raggio*this.pdfProp,Math.PI/2,Math.PI);
              this.doArc(cx*this.pdfProp, (cy+spessore+2*raggio)*this.pdfProp, raggio*this.pdfProp,-1*Math.PI,-1*Math.PI/2);
              break;
            case -90:
              cx=cxx-(raggio+spessore)/2+pareti.offsetX;
              cy=cyy-(raggio+spessore)/2+pareti.offsetY;
              this.doLine((cx+raggio)*this.pdfProp,cy*this.pdfProp,(cx+spessore+raggio)*this.pdfProp,cy*this.pdfProp);
              this.doLine((cx+spessore+raggio)*this.pdfProp,cy*this.pdfProp,(cx+spessore+raggio)*this.pdfProp,(cy+spessore+2*raggio)*this.pdfProp);
              this.doLine((cx+spessore+raggio)*this.pdfProp,(cy+spessore+2*raggio)*this.pdfProp,(cx+raggio)*this.pdfProp,(cy+spessore+2*raggio)*this.pdfProp);
              this.doLine(cx*this.pdfProp,(cy+raggio)*this.pdfProp,cx*this.pdfProp,(cy+spessore+raggio)*this.pdfProp);
              this.doArc(cx*this.pdfProp, cy*this.pdfProp, raggio*this.pdfProp,0,Math.PI/2);
              this.doArc(cx*this.pdfProp, (cy+spessore+2*raggio)*this.pdfProp, raggio*this.pdfProp,-1*Math.PI/2,0);
              break;
            case 180: // due archi sopra
              if(angolo=='is'){
                cx=cxx-(raggio+spessore)/2+pareti.offsetX;
                cy=cyy-(raggio+spessore)/2+pareti.offsetY;
              } 
              if(angolo=='id'){
                cx=cxx-(raggio+spessore)/2+pareti.offsetX;
                cy=cyy-(raggio+spessore)/2+pareti.offsetY;
              } 
              this.doLine(cx*this.pdfProp,(cy+raggio)*this.pdfProp,cx*this.pdfProp,(cy+spessore+raggio)*this.pdfProp);
              this.doLine(cx*this.pdfProp,(cy+raggio+spessore)*this.pdfProp,(cx+spessore+2*raggio)*this.pdfProp,(cy+spessore+raggio)*this.pdfProp);
              this.doLine((cx+spessore+2*raggio)*this.pdfProp,(cy+spessore+raggio)*this.pdfProp,(cx+spessore+2*raggio)*this.pdfProp,(cy+raggio)*this.pdfProp);
              this.doLine((cx+spessore+raggio)*this.pdfProp,cy*this.pdfProp,(cx+raggio)*this.pdfProp,cy*this.pdfProp);
              this.doArc(cx*this.pdfProp, cy*this.pdfProp, raggio*this.pdfProp,0,Math.PI/2);
              this.doArc((cx+spessore+2*raggio)*this.pdfProp, cy*this.pdfProp, raggio*this.pdfProp,Math.PI/2,Math.PI);              
          
              break;
          }
          break;
        case 13:
          break;
       }
    }
    if(pareti.numPareti==2){
      switch (spessore){
      case 10:
      case 6:
        switch (pareti.angolo){
          case 'ss':
            cx=cxx+(raggio+spessore)/2+pareti.offsetX;
            cy=cyy+(raggio+spessore)/2+pareti.offsetY;
            this.doLine((cx-raggio)*this.pdfProp,cy*this.pdfProp,(cx-spessore-raggio)*this.pdfProp,cy*this.pdfProp);
            this.doLine((cx-spessore-raggio)*this.pdfProp,cy*this.pdfProp,(cx-spessore-raggio)*this.pdfProp,(cy-spessore-raggio)*this.pdfProp);
            this.doLine((cx-spessore-raggio)*this.pdfProp,(cy-spessore-raggio)*this.pdfProp,cx*this.pdfProp,(cy-spessore-raggio)*this.pdfProp);
            this.doLine((cx)*this.pdfProp,(cy-spessore-raggio)*this.pdfProp,(cx)*this.pdfProp,(cy-raggio)*this.pdfProp);
            this.doArc(cx*this.pdfProp, cy*this.pdfProp, raggio*this.pdfProp,-1*Math.PI,-1*Math.PI/2);
            break;
          case 'sd':
            cx=cxx-(raggio+spessore)/2-pareti.offsetX;
            cy=cyy+(raggio+spessore)/2+pareti.offsetY;
            this.doLine(cx*this.pdfProp,(cy-raggio)*this.pdfProp,cx*this.pdfProp,(cy-raggio-spessore)*this.pdfProp);
            this.doLine(cx*this.pdfProp,(cy-raggio-spessore)*this.pdfProp,(cx+spessore+raggio)*this.pdfProp,(cy-spessore-raggio)*this.pdfProp);
            this.doLine((cx+spessore+raggio)*this.pdfProp,(cy-spessore-raggio)*this.pdfProp,(cx+spessore+raggio)*this.pdfProp,cy*this.pdfProp);
            this.doLine((cx+spessore+raggio)*this.pdfProp,cy*this.pdfProp,(cx+raggio)*this.pdfProp,cy*this.pdfProp);
            this.doArc(cx*this.pdfProp, cy*this.pdfProp, raggio*this.pdfProp,-1*Math.PI/2,0);
            break;
          case 'id':
            cx=cxx-(raggio+spessore)/2-pareti.offsetX;
            cy=cyy-(raggio+spessore)/2-pareti.offsetY;
            this.doLine(cx*this.pdfProp,(cy+raggio)*this.pdfProp,cx*this.pdfProp,(cy+raggio+spessore)*this.pdfProp);
            this.doLine(cx*this.pdfProp,(cy+raggio+spessore)*this.pdfProp,(cx+spessore+raggio)*this.pdfProp,(cy+spessore+raggio)*this.pdfProp);
            this.doLine((cx+spessore+raggio)*this.pdfProp,(cy+spessore+raggio)*this.pdfProp,(cx+spessore+raggio)*this.pdfProp,cy*this.pdfProp);
            this.doLine((cx+spessore+raggio)*this.pdfProp,cy*this.pdfProp,(cx+raggio)*this.pdfProp,cy*this.pdfProp);
            this.doArc(cx*this.pdfProp, cy*this.pdfProp, raggio*this.pdfProp,0,Math.PI/2);
            break;
          case 'is':
            cx=cxx+(raggio+spessore)/2+pareti.offsetX;
            cy=cyy-(raggio+spessore)/2-pareti.offsetY;
            this.doLine(cx*this.pdfProp,(cy+raggio)*this.pdfProp,cx*this.pdfProp,(cy+spessore+raggio)*this.pdfProp);
            this.doLine(cx*this.pdfProp,(cy+spessore+raggio)*this.pdfProp,(cx-spessore-raggio)*this.pdfProp,(cy+spessore+raggio)*this.pdfProp);
            this.doLine((cx-spessore-raggio)*this.pdfProp,(cy+spessore+raggio)*this.pdfProp,(cx-spessore-raggio)*this.pdfProp,cy*this.pdfProp);
            this.doLine((cx-spessore-raggio)*this.pdfProp,cy*this.pdfProp,(cx-raggio)*this.pdfProp,cy*this.pdfProp);
            this.doArc(cx*this.pdfProp, cy*this.pdfProp, raggio*this.pdfProp,Math.PI/2,Math.PI);
            break;
        }
        break;
      case 13:
        let ssx=cx-spessore/2;
        let ssy=cy-spessore/2;
        this.doRect(ssx*this.pdfProp,ssy*this.pdfProp,spessore*this.pdfProp,spessore*this.pdfProp);
       /* switch (angolo){
          case 'ss':
            let ssx=cx-spessore/2;
            let ssy=cy-spessore/2;
       
            this.doRect(ssx*this.pdfProp,ssy*this.pdfProp,spessore*this.pdfProp,spessore*this.pdfProp);

            //  this.doLine((cx-spessore/2)*this.pdfProp,(cy-spessore/2)*this.pdfProp,(cx+spessore/2)*this.pdfProp,(cy+spessore/2)*this.pdfProp);
           // this.doLine((cx-spessore/2)*this.pdfProp,cy*this.pdfProp,(cx+spessore/2)*this.pdfProp,(cy-spessore)*this.pdfProp);
           // this.doLine((cx-spessore)*this.pdfProp,(cy-spessore)*this.pdfProp,(cx+spessore/2)*this.pdfProp,(cy-spessore)*this.pdfProp);
           // this.doLine((cx+spessore/2)*this.pdfProp,(cy-spessore)*this.pdfProp,(cx+spessore/2)*this.pdfProp,(cy)*this.pdfProp);
            break;
          case 'sd':
            this.doLine(cx*this.pdfProp,(cy)*this.pdfProp,cx*this.pdfProp,(cy-spessore)*this.pdfProp);
            this.doLine(cx*this.pdfProp,(cy-spessore)*this.pdfProp,(cx+spessore)*this.pdfProp,(cy-spessore)*this.pdfProp);
            this.doLine((cx+spessore)*this.pdfProp,(cy-spessore)*this.pdfProp,(cx+spessore)*this.pdfProp,cy*this.pdfProp);
            this.doLine((cx+spessore)*this.pdfProp,cy*this.pdfProp,(cx)*this.pdfProp,cy*this.pdfProp);
            break;
          case 'id':
            this.doLine(cx*this.pdfProp,(cy)*this.pdfProp,cx*this.pdfProp,(cy+spessore)*this.pdfProp);
            this.doLine(cx*this.pdfProp,(cy+spessore)*this.pdfProp,(cx+spessore)*this.pdfProp,(cy+spessore)*this.pdfProp);
            this.doLine((cx+spessore)*this.pdfProp,(cy+spessore)*this.pdfProp,(cx+spessore)*this.pdfProp,cy*this.pdfProp);
            this.doLine((cx+spessore)*this.pdfProp,cy*this.pdfProp,(cx)*this.pdfProp,cy*this.pdfProp);
            break;
          case 'is':
            this.doLine(cx*this.pdfProp,(cy)*this.pdfProp,cx*this.pdfProp,(cy+spessore)*this.pdfProp);
            this.doLine(cx*this.pdfProp,(cy+spessore)*this.pdfProp,(cx-spessore)*this.pdfProp,(cy+spessore+raggio)*this.pdfProp);
            this.doLine((cx-spessore)*this.pdfProp,(cy+spessore)*this.pdfProp,(cx-spessore)*this.pdfProp,cy*this.pdfProp);
            this.doLine((cx-spessore)*this.pdfProp,cy*this.pdfProp,(cx)*this.pdfProp,cy*this.pdfProp);
            break;
        }
        */
        break;
      }
    }

  }    


  pdfPannello(x:number,y:number,w:number,h:number,testo:string='',angolo:number=0,lato:string='all'){
    if(lato=='all'){
        this.doRect(x*this.pdfProp,y*this.pdfProp,w*this.pdfProp,h*this.pdfProp);
    }
    if(lato=='destro'){
      this.doLine((x+w)*this.pdfProp,(y-1.5)*this.pdfProp,(x+w)*this.pdfProp,(y+h+1.5)*this.pdfProp);
    }
    if(lato=='fronte'){
      this.doLine((x-1.5)*this.pdfProp,(y+h)*this.pdfProp,(x+w+1.5)*this.pdfProp,(y+h)*this.pdfProp);
    }

    
    if(testo!=''){  
      if(this.pdfOrdDxf=='PDF'){
        if(angolo==0){
          this.pdf.setFontSize(8).setFont(undefined, 'normal').text(testo,
            (x+w/2)*this.pdfProp-this.pdf.getTextWidth(testo)/2,
            (y+h/2)*this.pdfProp,{
                align: 'left',
                angle:angolo
          }); 
        } else {
          this.pdf.setFontSize(8).setFont(undefined, 'normal').text(testo,
            (x+w/2)*this.pdfProp,
            (y+h/2)*this.pdfProp+this.pdf.getTextWidth(testo)/2,{
                align: 'left',
                angle:angolo
          }); 
        }
      } else {
          let dim={
            h:5,
            w:0.65*testo.length*5
          }
          this.dxf.drawText((x+w/2)+-dim.w/2,-(y+h/2)+2*dim.h,5,angolo,testo);

      }
    }
  }


public downloadDxfFile(data: string, filename: string) {
    const blob = new Blob([data], { type: 'text/plain' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }

    
  drawCartiglio(formato:string){
    if(formato!='a4' && formato!='a3') {
      return;
    }
    if(this.globalService.societa=='DAGARD'){
      let mw=Math.round(this.pdf.internal.pageSize.getWidth()/20);
      let mh=Math.round(this.pdf.internal.pageSize.getHeight()/20);
      this.pdf.rect(mw, mh, this.pdf.internal.pageSize.getWidth()-mw*2,  this.pdf.internal.pageSize.getHeight()-mh*2);

      let hc=Math.round(this.pdf.internal.pageSize.getHeight()/50);
      let wc=(this.pdf.internal.pageSize.getWidth()-mw*2)/10;

      let cx=mw;
      if( formato=='a3') {
        cx=mw+Math.round((this.pdf.internal.pageSize.getWidth()-mw*2)/2);
        wc=Math.round((this.pdf.internal.pageSize.getWidth()-mw*2)/2)/10;
      }
      // linee orizz
      let cy=this.pdf.internal.pageSize.getHeight()-mh-hc*6.5;
      
      if( formato=='a3') {
        this.pdf.line(cx,cy,cx,cy+hc*6.5);
      }
      this.pdf.line(cx,cy,cx+wc*10,cy);
      cy+=hc;
      this.pdf.line(cx,cy,cx+wc*6,cy);
      cy+=hc;
      this.pdf.line(cx,cy,cx+wc*6,cy);
      cy+=hc;
      this.pdf.line(cx,cy,cx+wc*10,cy);
      cy+=hc;
      this.pdf.line(cx,cy,cx+wc*2,cy);
      this.pdf.line(cx+wc*6,cy,cx+wc*10,cy);
      cy+=hc;
      this.pdf.line(cx,cy,cx+wc*2,cy);
      this.pdf.line(cx+wc*6,cy,cx+wc*10,cy);
      cy+=hc;
      this.pdf.line(cx,cy,cx+wc*10,cy);

      // linee vert
      cy=this.pdf.internal.pageSize.getHeight()-mh-hc*6.5;
      this.pdf.line(cx+wc,cy,cx+wc,cy+hc*4);
      this.pdf.line(cx+wc*2,cy,cx+wc*2,cy+hc*6);
      this.pdf.line(cx+wc*5,cy,cx+wc*5,cy+hc*3);
      this.pdf.line(cx+wc*6,cy,cx+wc*6,cy+hc*6);
      this.pdf.line(cx+wc*8,cy+hc*3,cx+wc*8,cy+hc*4);
      cy=this.pdf.internal.pageSize.getHeight()-mh-hc*6.5;
      this.cellText(this.lang.el('Indice'),cx,cy+hc*2,wc,hc,11);
      this.cellText(this.lang.el('Autore'),cx+wc,cy+hc*2,wc,hc,11);
      this.cellText(this.lang.el('Modifications'),cx+wc*2,cy+hc*2,wc*3,hc,11);
      this.cellText(this.lang.el('Date'),cx+wc*5,cy+hc*2,wc,hc,11);
      this.cellText(this.lang.el('Echelle'),cx,cy+hc*3,wc,hc*0.6,8);
      this.cellText(this.lang.el('Tolérance'),cx+wc,cy+hc*3,wc,hc*0.6,8);  
      this.cellText(this.lang.el('Auteur'),cx+wc*6,cy+hc*3,wc*2,hc*0.6,8);
      this.cellText(this.lang.el('Date'),cx+wc*8,cy+hc*3,wc*2,hc*0.6,8);

      this.cellText('A4',cx+wc*6,cy+hc*4,wc/2,hc,12);
      this.pdf.line(cx+wc*7,cy+hc*4,cx+wc*7,cy+hc*5);
      this.cellText(this.lang.el('Plancia'),cx+wc*7,cy+hc*4,wc,hc*0.6,8);
      this.pdf.line(cx+wc*8,cy+hc*4,cx+wc*8,cy+hc*5);
      this.cellText(this.lang.el('Piano'),cx+wc*8,cy+hc*4,wc,hc*0.6,8);
      this.pdf.line(cx+wc*9,cy+hc*4,cx+wc*9,cy+hc*5);
      this.cellText(this.lang.el('Ind'),cx+wc*9,cy+hc*4,wc,hc*0.6,8);

      this.cellText(this.lang.el('Code'),cx+wc*6,cy+hc*5,wc,hc,11);

      this.cellText(this.lang.el('Ce plan est la propriété de Dagard. Il ne peut être modifié, reproduit ou communiqué à des tiers sans autorisation écrite.'),cx,cy+hc*6,wc*9,hc/2,6);
      this.cellText(this.lang.el('Pagina'),cx+wc*9,cy+hc*6,wc/2,hc/2,8);
    }
    if(this.globalService.societa=='MISA'){
      let mw=Math.round(this.pdf.internal.pageSize.getWidth()/20);
      let mh=Math.round(this.pdf.internal.pageSize.getHeight()/20);
   
      this.pdf.rect(mw, mh, this.pdf.internal.pageSize.getWidth()-mw*2,  this.pdf.internal.pageSize.getHeight()-mh*2);

      let hc=Math.round(this.pdf.internal.pageSize.getHeight()/30);
      let wc=(this.pdf.internal.pageSize.getWidth()-mw*2)/6;

      let cx=mw;
   
      // linee orizz
      let cy=this.pdf.internal.pageSize.getHeight()-mh-hc*2;
     
    
      this.pdf.line(cx,cy,cx+wc*6,cy);
      cy+=hc;
      this.pdf.line(cx+wc*2,cy,cx+wc*6,cy);
      cy+=hc;

      // linee vert
      cy=this.pdf.internal.pageSize.getHeight()-mh-hc*2;
      this.pdf.line(cx+wc*2,cy,cx+wc*2,cy+hc*2);
      this.pdf.line(cx+wc*4,cy,cx+wc*4,cy+hc*2);
      this.pdf.line(cx+wc*3,cy,cx+wc*3,cy+hc);
      this.pdf.line(cx+wc*5,cy,cx+wc*5,cy+hc);

      cy=this.pdf.internal.pageSize.getHeight()-mh-hc*2;
      this.cellText(this.lang.el('Titolo'),cx+wc*2-2,cy,wc,hc,9,'left');
      this.cellText(this.lang.el('ID '+this.prev.id),cx+wc*3-2,cy,wc,hc,9,'left');
      this.cellText(this.lang.el('Data'),cx+wc*4-2,cy,wc,hc,9,'left');
      this.cellText(this.lang.el('Ref. '+this.cC.descrizione),cx+wc*5-2,cy,wc,hc,9,'left');
      if(this.prev.ragSoc && this.prev.ragSoc!=''){
        this.cellText(this.lang.el('Cliente '+this.prev.ragSoc),cx+wc*2-2,cy+hc,wc,hc,9,'left');
      } else {
        this.cellText(this.lang.el('Cliente '+this.prev.accountName),cx+wc*2-2,cy+hc,wc,hc,9,'left');
      }
    
       const base64Img = 'data:image/png;base64,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';
      this.pdf.addImage(base64Img, 'PNG', cx+1, cy+1,wc,wc/428*102);
      
    }
    
  }

  cellText(txt:string,x:number,y:number,w:number,h:number,size:number,align='center'){
    this.pdf.setFont("courier");
    if(align=='center'){
    this.pdf.setFontSize(size).setFont(undefined, 'normal').text(txt,x+w/2-this.pdf.getTextWidth(txt)/2,y+h/1.4,{
            align: 'left'
          });
    } else {
      this.pdf.setFontSize(size).setFont(undefined, 'normal').text(txt,x+5,y+h/1.4,{
          align: 'left'
        });
    }
   
  }

  doRect(x1:number,y1:number,w:number,h:number){
    if(this.pdfOrdDxf=='PDF'){
      this.pdf.rect(x1,y1,w,h);
    } else {
      this.dxf.drawRect(x1,-y1,w+x1,-h-y1);
    }
  }

  stampaTestoInRettangolo(left:number, top:number, width:number, height:number, testo:string, verticale:boolean=false){
    if(!testo){
      return;
    }
    const angolo = verticale ? 90 : 0;
    const centerX = left + width / 2;
    const centerY = top + height / 2;

    if(this.pdfOrdDxf=='PDF'){
      this.pdf.setFontSize(8).setFont(undefined, 'normal');
      if(angolo==0){
        this.pdf.text(testo, centerX - this.pdf.getTextWidth(testo) / 2, centerY, {
          align: 'left',
          angle: angolo
        });
      } else {
        this.pdf.text(testo, centerX, centerY + this.pdf.getTextWidth(testo) / 2, {
          align: 'left',
          angle: angolo
        });
      }
    } else {
      const dim = {
        h: 5,
        w: 0.65 * testo.length * 5
      };
      if(angolo==0){
        this.dxf.drawText(centerX - dim.w / 2, -centerY + 2 * dim.h, 5, angolo, testo);
      } else {
        this.dxf.drawText(centerX, -centerY + dim.w / 2, 5, angolo, testo);
      }
    }
  }

  doRectArr(x1:number,y1:number,w:number,h:number, fillBlack:boolean=false, angoloarr:boolean=true, testo:string='', verticale:boolean=false){
    const width = Math.abs(w);
    const height = Math.abs(h);
    const left = w >= 0 ? x1 : x1 + w;
    const top = h >= 0 ? y1 : y1 + h;
    const right = left + width;
    const bottom = top + height;
    const xMin = Math.min(x1, x1 + w);
    const xMax = Math.max(x1, x1 + w);
    const yMin = Math.min(-y1, -h - y1);
    const yMax = Math.max(-y1, -h - y1);

    if(!angoloarr){
      if(this.pdfOrdDxf=='PDF'){
        if(fillBlack){
          this.pdf.setFillColor(0, 0, 0);
          this.pdf.setDrawColor(0, 0, 0);
          this.pdf.rect(x1, y1, w, h, 'FD');
        } else {
          this.doRect(x1, y1, w, h);
        }
      } else {
        if(fillBlack){
          this.dxf.drawFace(xMin, yMin, 0, xMax, yMin, 0, xMax, yMax, 0, xMin, yMax, 0);
        }
        this.dxf.drawRect(xMin, yMin, xMax, yMax);
      }
    } else {
      const radius = Math.min(width, height) * 0.05;
      if(radius <= 0){
        this.doRectArr(x1, y1, w, h, fillBlack, false, testo, verticale);
        return;
      }

      if(this.pdfOrdDxf=='PDF'){
        const context = this.pdf.context2d;
        context.lineWidth = .1;
        context.beginPath();
        context.moveTo(left + radius, top);
        context.lineTo(right - radius, top);
        context.arc(right - radius, top + radius, radius, -Math.PI / 2, 0, false);
        context.lineTo(right, bottom - radius);
        context.arc(right - radius, bottom - radius, radius, 0, Math.PI / 2, false);
        context.lineTo(left + radius, bottom);
        context.arc(left + radius, bottom - radius, radius, Math.PI / 2, Math.PI, false);
        context.lineTo(left, top + radius);
        context.arc(left + radius, top + radius, radius, Math.PI, 3 * Math.PI / 2, false);
        context.closePath();
        if(fillBlack){
          context.fillStyle = 'black';
          context.fill();
        }
        context.stroke();
      } else {
        if(fillBlack){
          this.dxf.drawFace(xMin, yMin, 0, xMax, yMin, 0, xMax, yMax, 0, xMin, yMax, 0);
        }
        this.dxf.drawRect(xMin, yMin, xMax, yMax, radius, Math.tan(Math.PI / 8));
      }
    }

    this.stampaTestoInRettangolo(left, top, width, height, testo, verticale);
  }

  doLine(x1:number,y1:number,x2:number,y2:number){
    if(this.pdfOrdDxf=='PDF'){
      this.pdf.line(x1,y1,x2,y2);
    } else {  
      this.dxf.drawLine(x1,-y1,x2,-y2);
    }
  }

  doArc(x1: number, y1: number, r: number, startAngle: number, endAngle: number){
    if(this.pdfOrdDxf=='PDF'){
      var context = this.pdf.context2d;
      context.lineWidth =.1;
      context.beginPath();
      context.arc(x1, y1, r,startAngle,endAngle,false);
      context.stroke();
    } else {
      this.dxf.drawArc(x1, -y1, r,360-endAngle*(180 / Math.PI),360-startAngle*(180 / Math.PI));   
    }
  }

  exportDiagram() {
   let options: IExportOptions;
    options = {};
    options.mode = 'Download';
    options.margin = { left: 0, right: 0, top: 0, bottom: 0};
    
    this.diagram.pageSettings={width:500,height:500};

         options.bounds = new Rect(0, 0, 500, 500);

 
     options.region = 'CustomBounds';
    options.stretch = 'Stretch';
    this.diagram.exportDiagram(options);
     this.diagram.pageSettings={width:8000,height:5000};
  }


  creaListini(){
    this.listini={
      ingombroXMin:200,
      ingombroXMax:400,
      ingombroYMin:200,
      ingombroYMax:400,
      ingombroXCurrent:100,
      ingombroYCurrent:100,
      currentIterazione:0,
      totIterazioni:0,
      prezzi:[],
      distinte:[],
      distinteDesc:[]
    };
    this.listiniError='';
    this.cC.elencoCelle[this.mS.currCellaInd].pavimenti=true;
    let params=this.cambiaModelloPortaPerListini(this.cC.elencoCelle[this.mS.currCellaInd],this.cC.elencoCelle[this.mS.currCellaInd].elencoPorte[0]);
       
    this.apiService.post('app/opportunity_getporte',{param:params}).subscribe(data2 => {
      void this.lang.loadDesTranslations().then(() => {
        this.listiniModelliPortaOptionsConPav = this.lang.desList('t_porte', Array.isArray(data2) ? data2 : []);
        this.listiniModelloPorta='';
        this.listiniModelloPortaDesc='';
        this.showDialogListini=true;
      });
     
      this.cC.elencoCelle[this.mS.currCellaInd].pavimenti=false;
      params=this.cambiaModelloPortaPerListini(this.cC.elencoCelle[this.mS.currCellaInd],this.cC.elencoCelle[this.mS.currCellaInd].elencoPorte[0]);
      
      this.apiService.post('app/opportunity_getporte',{param:params}).subscribe(data2 => {
        void this.lang.loadDesTranslations().then(() => {
          this.listiniModelliPortaOptionsSenzaPav = this.lang.desList('t_porte', Array.isArray(data2) ? data2 : []);
          this.listiniModelloPorta='';
          this.listiniModelloPortaDesc='';
          this.showDialogListini=true;
        });
      });
        
    });
  }

  changeIngombriListini(cella:any){
    if(cella.spessore==13){
     this.listini.ingombroYMin=Math.round(this.listini.ingombroYMin/40)*40;
     this.listini.ingombroYMax=Math.round(this.listini.ingombroYMax/40)*40;
    } else {
     this.listini.ingombroYMin=Math.round(this.listini.ingombroYMin/20)*20;
     this.listini.ingombroYMax=Math.round(this.listini.ingombroYMax/20)*20;
    }
    this.listini.ingombroXMin=Math.round(this.listini.ingombroXMin/20)*20;
    this.listini.ingombroXMax=Math.round(this.listini.ingombroXMax/20)*20;


  }
  
  startCreazioneListini(cella:any){
    let salto=20;
    if(cella.spessore==13){
      salto=40;
    }
    this.listini.totIterazioni=2*(1+(this.listini.ingombroXMax-this.listini.ingombroXMin)/salto)*(1+(this.listini.ingombroYMax-this.listini.ingombroYMin)/salto);
  
    this.listini.ingombroXCurrent=this.listini.ingombroXMin-salto;
    this.listini.ingombroYCurrent=this.listini.ingombroYMin;
    this.cC.elencoCelle[this.mS.currCellaInd].ingombroX=this.listini.ingombroXCurrent;
    this.cC.elencoCelle[this.mS.currCellaInd].ingombroY=this.listini.ingombroYCurrent;
    this.cC.elencoCelle[this.mS.currCellaInd].pavimenti=false;
    this.stepCompletatoCreazioneListini();
  }

  annullaCreazioneListini(){
    this.showDialogListini=false;
  }

  cambiaModelloPortaPerListini(cellaDati:any,porta:any){
   
    let dxOrSxString='';
    switch (porta.versoAperturaPorta) {
        case 1:
            dxOrSxString = "DX";
            break;
        case 2:
            dxOrSxString = "SX";
            break;
        default:
            dxOrSxString = "";
            break;
    }
    

    let param:any={
      sql:this.mS.listaporteOK(cellaDati,porta,porta.scollegata? false:cellaDati.electrolux),
      tipoPorta:porta.tipo1Porta,
      spe_pann:porta.scollegata? porta.spessore:cellaDati.spessore,
      electrolux:porta.scollegata? false:cellaDati.electrolux
    }
    if(dxOrSxString!=''){
      param.TipoApertura=dxOrSxString;
    }
   
    return param;
  

  }
  
  public stepCompletatoCreazioneListini(){
    let salto=20;
   
    let spessore=this.cC.elencoCelle[this.mS.currCellaInd].spessore;
     if(spessore==13){
      salto=40;
    }
    if(this.listini.currentIterazione==0){ 
      this.listini.currentIterazione=1;
      this.cC.elencoCelle[this.mS.currCellaInd].pavimenti=true;
      this.listini.ingombroXCurrent+=salto;
    } else {
      this.listini.currentIterazione++;
      if(!this.cC.elencoCelle[this.mS.currCellaInd].pavimenti){
        if(this.listini.ingombroXCurrent<this.listini.ingombroXMax){
          this.listini.ingombroXCurrent+=salto;
        } else {
          this.listini.ingombroXCurrent=this.listini.ingombroXMin;
          if(spessore==13){
            this.listini.ingombroYCurrent+=salto;
          } else {
            this.listini.ingombroYCurrent+=salto;
          }
        }
      }
      
      this.cC.elencoCelle[this.mS.currCellaInd].pavimenti=!this.cC.elencoCelle[this.mS.currCellaInd].pavimenti;
    }
    if(this.cC.elencoCelle[this.mS.currCellaInd].elencoPorte.length>0){
        if(this.cC.elencoCelle[this.mS.currCellaInd].pavimenti){
          this.listiniModelloPorta= this.listiniPortaConPav;
          this.listiniModelloPortaDesc=this.listiniModelliPortaOptionsConPav.filter((x:any)=>x.value==this.listiniModelloPorta)[0].label;
          this.cC.elencoCelle[this.mS.currCellaInd].elencoPorte[0].modelliPortaOptions=this.listiniModelliPortaOptionsConPav;
        } else {
          if(spessore!=13){
            this.listiniModelloPorta= this.listiniPortaSenzaPav;
            this.listiniModelloPortaDesc=this.listiniModelliPortaOptionsSenzaPav.filter((x:any)=>x.value==this.listiniModelloPorta)[0].label;
            this.cC.elencoCelle[this.mS.currCellaInd].elencoPorte[0].modelliPortaOptions=this.listiniModelliPortaOptionsSenzaPav;
              
          }
        }
         
      
        this.cC.elencoCelle[this.mS.currCellaInd].elencoPorte[0].modelloPorta=this.listiniModelloPorta;
      
        
        if(this.showDialogListini && this.listini.ingombroYCurrent<=this.listini.ingombroYMax){
          this.cC.elencoCelle[this.mS.currCellaInd].ingombroX=this.listini.ingombroXCurrent;
          this.cC.elencoCelle[this.mS.currCellaInd].ingombroY=this.listini.ingombroYCurrent;
          this.cC.elencoScaffali.forEach((sc:any,ind3:number)=>{
              let nodosc=this.diagram.nodes.filter((n:any)=> n.addInfo.id &&  n.addInfo.id==sc.id);
              if(nodosc[0].addInfo.title.indexOf('R')>0){
                this.cC.elencoScaffali[ind3].height=this.listini.ingombroYCurrent;
              } else {
                this.cC.elencoScaffali[ind3].width=this.listini.ingombroXCurrent;
              }
              this.changeScaffale(this.cC.elencoScaffali[ind3]);
          });
          if(this.listini.distinteDesc.filter((x:any)=>x.Pavimenti==(this.cC.elencoCelle[this.mS.currCellaInd].pavimenti? 'SI':'No') && x.Larghezza==this.listini.ingombroYCurrent && x.Profondita==this.listini.ingombroXCurrent).length==0){
            this.listini.distinteDesc.push({
              Altezza:this.cC.elencoCelle[this.mS.currCellaInd].altezza,
              Larghezza:this.cC.elencoCelle[this.mS.currCellaInd].ingombroX,
              Profondita:this.cC.elencoCelle[this.mS.currCellaInd].ingombroY,
              Spessore:this.cC.elencoCelle[this.mS.currCellaInd].spessore,
              Pavimenti:this.cC.elencoCelle[this.mS.currCellaInd].pavimenti?'SI':'No',
            });
            this.draw3D(false,true);      
          }  else {
            this.stepCompletatoCreazioneListini();
          }
        }
    
    }
  }

  percentualeAvanzamento(){
     return this.listini.totIterazioni > 0 ?this.listini.currentIterazione / this.listini.totIterazioni * 100 : 0;
  }

  exportListini() {
       
    import('xlsx').then((xlsx) => {
        const spessore=this.cC.elencoCelle[this.mS.currCellaInd].spessore;
     
        const dati2 = [{ 
          spessore: spessore, 
          pavimenti: this.cC.elencoCelle[this.mS.currCellaInd].finituraPavimento 
        }];

      
        const workbook = xlsx.utils.book_new();
        const ws1 = xlsx.utils.json_to_sheet(this.listini.prezzi);
        const ws3 = xlsx.utils.json_to_sheet(dati2);

        

        let worksheet = xlsx.utils.json_to_sheet([]);
        this.listini.distinte.forEach((d:any,ind:number)=>{
          let totPrezzo=0;
          let totCosto=0;
          let dist=[];
          d.forEach((dr:any,indR:number)=>{
            if(!d[indR].pzu_costo){
              d[indR].pzu_costo=0;
            }
            if(!d[indR].quantity){
              d[indR].quantity=0;
            }
           
            totPrezzo+=d[indR].pzu_comp;
            this.listini.distinte[ind][indR].pzu_comp_costo=d[indR].pzu_costo*d[indR].quantity;
            totCosto+=d[indR].pzu_comp_costo;
            dist.push({
              spessore:spessore,
              pavimenti:this.listini.distinteDesc[ind].Pavimenti,
              altezza:this.listini.distinteDesc[ind].Altezza,
              larghezza:this.listini.distinteDesc[ind].Larghezza,
              profondita:this.listini.distinteDesc[ind].Profondita,
              codicePadre:d[indR].codicePadre,
              art_comp:d[indR].art_comp,
              des_comp:d[indR].des_comp,
              quantity:d[indR].quantity,
              pzu_comp:d[indR].pzu_comp,
              pzu_comp_uni:d[indR].pzu_comp_uni,
              pzu_costo:d[indR].pzu_costo,
              pzu_comp_costo:d[indR].pzu_comp_costo,
            });
          });
          let tot={
            spessore:'',
            pavimenti:'',
            altezza:'',
            larghezza:'',
            profondita:'',
            codicePadre:'',
            art_comp:'',
            des_comp:'',
            quantity:'',
            pzu_comp:totPrezzo,
            pzu_comp_uni:'',
            pzu_costo:'',
           pzu_comp_costo:totCosto
          }      
          dist.push(tot);    

          xlsx.utils.sheet_add_aoa(worksheet, [[]], { origin: -1 });
          xlsx.utils.sheet_add_json(worksheet, dist, { origin: -1, skipHeader: ind>0 });

        });
      
        
        
        xlsx.utils.book_append_sheet(workbook, ws1, 'Listino');
        xlsx.utils.book_append_sheet(workbook, worksheet, 'Distinte');
        xlsx.utils.book_append_sheet(workbook, ws3, 'Configurazione');

    
        const excelBuffer: any = xlsx.write(workbook, {
            bookType: 'xlsx',
            type: 'array',
        });
        const ora: Date = new Date();
       
       
        let nomefile=this.lang.el('Listino')+'_'+ora.getFullYear()+'-'+(1+ora.getMonth())+'-'+ora.getDate()+this.lang.el('Spessore')+'_'+spessore+' ';
        this.mS.saveAsExcelFile(excelBuffer, nomefile);
        this.showDialogListini=false;
    });

  }


}




  
  



